webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var styled = _interopDefault(__webpack_require__(185));
	
	var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	var newStyled = styled.bind();
	tags.forEach(function (tagName) {
	  newStyled[tagName] = newStyled(tagName);
	});
	
	exports.default = newStyled;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.showOnlyOnDesktop = exports.minDesktop = exports.minTablet = exports.onlyTablet = exports.mediaTablet = exports.mediaPhone = exports.DESKTOP_WIDE = exports.TABLET = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: none;\n  ', ' {\n    display: block;\n  }\n'], ['\n  display: none;\n  ', ' {\n    display: block;\n  }\n']);
	
	var _core = __webpack_require__(10);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TABLET = exports.TABLET = 768;
	var DESKTOP_WIDE = exports.DESKTOP_WIDE = 1270;
	
	var mediaPhone = exports.mediaPhone = '@media (max-width: ' + (TABLET - 1) + 'px)';
	var mediaTablet = exports.mediaTablet = '@media (max-width: ' + (DESKTOP_WIDE - 1) + 'px)';
	
	var onlyTablet = exports.onlyTablet = '@media (min-width: ' + TABLET + 'px) and (max-width: ' + (DESKTOP_WIDE - 1) + 'px)';
	
	var minTablet = exports.minTablet = '@media (min-width: ' + TABLET + 'px)';
	var minDesktop = exports.minDesktop = '@media (min-width: ' + DESKTOP_WIDE + 'px)';
	
	var showOnlyOnDesktop = exports.showOnlyOnDesktop = (0, _core.css)(_templateObject, minDesktop);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var White = '#fff';
	var Black = '#000';
	
	var PrimaryColor = '#C8A237';
	var PrimaryDarkColor = '#B89227';
	
	var TextColor = '#000';
	var TextGray = '#AAAAAA';
	
	var BackHeroColor = '#DADADB';
	var GrayBack = '#F7F7F7';
	
	exports.BackHeroColor = BackHeroColor;
	exports.Black = Black;
	exports.GrayBack = GrayBack;
	exports.PrimaryColor = PrimaryColor;
	exports.PrimaryDarkColor = PrimaryDarkColor;
	exports.TextColor = TextColor;
	exports.TextGray = TextGray;
	exports.White = White;

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var createCache = _interopDefault(__webpack_require__(121));
	var utils = __webpack_require__(77);
	var serialize = __webpack_require__(58);
	var sheet = __webpack_require__(123);
	var css = _interopDefault(__webpack_require__(182));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var EmotionCacheContext = React.createContext(createCache());
	var ThemeContext = React.createContext({});
	var CacheProvider = // $FlowFixMe
	EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function ( // $FlowFixMe we know it won't be null
	    cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var type = props[typePropName];
	  var registeredStyles = [];
	  var className = '';
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  registeredStyles.push(cssProp);
	
	  if (props.className !== undefined) {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion = exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	}); // $FlowFixMe
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || props.css == null) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at jsx.*\n\s+at ([A-Z][A-Za-z]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/^.*\n([A-Z][A-Za-z]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = match[1];
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[0].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css$$1, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css$$1(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css$$1 = function css$$1() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css$$1, classnames(args));
	    };
	
	    var content = {
	      css: css$$1,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.Global = Global;
	exports.keyframes = keyframes;
	exports.ClassNames = ClassNames;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(189);


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(326);
	} else {
	  module.exports = require("./emotion.cjs.dev.js");
	}


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Stacheldraht = __webpack_require__(237);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Stacheldraht).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// ==============================
	// THEME
	// ==============================
	
	var theme = {};
	
	// container
	theme.container = {
		background: 'rgba(0, 0, 0, 0.8)',
		gutter: {
			horizontal: 10,
			vertical: 10
		},
		zIndex: 2001
	};
	
	// header
	theme.header = {
		height: 40
	};
	theme.close = {
		fill: 'white'
	};
	
	// footer
	theme.footer = {
		color: 'white',
		count: {
			color: 'rgba(255, 255, 255, 0.75)',
			fontSize: '0.85em'
		},
		height: 40,
		gutter: {
			horizontal: 0,
			vertical: 5
		}
	};
	
	// thumbnails
	theme.thumbnail = {
		activeBorderColor: 'white',
		size: 50,
		gutter: 2
	};
	
	// arrow
	theme.arrow = {
		background: 'none',
		fill: 'white',
		height: 120
	};
	
	exports.default = theme;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(79);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(114);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(115);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(112);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(113);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        style = (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(7);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(7);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(7);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines',
	  flexGrow: 'WebkitBoxFlex'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(7);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return value.replace(values, function (grad) {
	        return prefix + grad;
	      });
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(7);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(108);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(7);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(56);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function deepMerge(target) {
		var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		var extended = _extends({}, target);
	
		Object.keys(source).forEach(function (key) {
			if (_typeof(source[key]) !== 'object' || !source[key]) {
				extended[key] = source[key];
			} else {
				if (!target[key]) {
					extended[key] = source[key];
				} else {
					extended[key] = deepMerge(target[key], source[key]);
				}
			}
		});
	
		return extended;
	}
	
	exports.default = deepMerge;

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

	"use strict";
	
	function hash(str) {
	  var hash = 5381,
	      i    = str.length;
	
	  while(i) {
	    hash = (hash * 33) ^ str.charCodeAt(--i);
	  }
	
	  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
	   * integers. Since we want the results to be always positive, convert the
	   * signed int to an unsigned by doing an unsigned bitshift. */
	  return hash >>> 0;
	}
	
	module.exports = hash;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _H = __webpack_require__(213);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_H).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(183));
	var unitless = _interopDefault(__webpack_require__(187));
	var memoize = _interopDefault(__webpack_require__(122));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	var processStyleName = memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          value = value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    if (key.charCodeAt(1) !== 45 && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, char) {
	        return char.toUpperCase();
	      }) + "?");
	    }
	
	    return oldProcessStyleValue(key, value);
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles;
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	      }
	    // eslint-disable-next-line no-fallthrough
	
	    default:
	      {
	        if (registered == null) {
	          return interpolation;
	        }
	
	        var cached = registered[interpolation];
	
	        if (false) {
	          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	          shouldWarnAboutInterpolatingClassNameFromCss = false;
	        }
	
	        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	      }
	  }
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	          }
	        } else {
	          string += _key + "{" + handleInterpolation(mergedProps, registered, value, false) + "}";
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var stringHash = _interopDefault(__webpack_require__(47));
	var calc = _interopDefault(__webpack_require__(32));
	var crossFade = _interopDefault(__webpack_require__(33));
	var cursor = _interopDefault(__webpack_require__(34));
	var filter = _interopDefault(__webpack_require__(35));
	var flex = _interopDefault(__webpack_require__(36));
	var flexboxIE = _interopDefault(__webpack_require__(37));
	var flexboxOld = _interopDefault(__webpack_require__(38));
	var gradient = _interopDefault(__webpack_require__(39));
	var imageSet = _interopDefault(__webpack_require__(40));
	var position = _interopDefault(__webpack_require__(41));
	var sizing = _interopDefault(__webpack_require__(42));
	var transition = _interopDefault(__webpack_require__(43));
	var createPrefixer = _interopDefault(__webpack_require__(31));
	var asap = _interopDefault(__webpack_require__(23));
	
	/* ::
	type ObjectMap = { [id:string]: any };
	*/
	
	var UPPERCASE_RE = /([A-Z])/g;
	var UPPERCASE_RE_TO_KEBAB = function UPPERCASE_RE_TO_KEBAB(match /* : string */) {
	    return (/* : string */'-' + String(match.toLowerCase())
	    );
	};
	
	var kebabifyStyleName = function kebabifyStyleName(string /* : string */) /* : string */{
	    var result = string.replace(UPPERCASE_RE, UPPERCASE_RE_TO_KEBAB);
	    if (result[0] === 'm' && result[1] === 's' && result[2] === '-') {
	        return '-' + String(result);
	    }
	    return result;
	};
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 * Taken from React's CSSProperty.js
	 */
	var isUnitlessNumber = {
	    animationIterationCount: true,
	    borderImageOutset: true,
	    borderImageSlice: true,
	    borderImageWidth: true,
	    boxFlex: true,
	    boxFlexGroup: true,
	    boxOrdinalGroup: true,
	    columnCount: true,
	    flex: true,
	    flexGrow: true,
	    flexPositive: true,
	    flexShrink: true,
	    flexNegative: true,
	    flexOrder: true,
	    gridRow: true,
	    gridColumn: true,
	    fontWeight: true,
	    lineClamp: true,
	    lineHeight: true,
	    opacity: true,
	    order: true,
	    orphans: true,
	    tabSize: true,
	    widows: true,
	    zIndex: true,
	    zoom: true,
	
	    // SVG-related properties
	    fillOpacity: true,
	    floodOpacity: true,
	    stopOpacity: true,
	    strokeDasharray: true,
	    strokeDashoffset: true,
	    strokeMiterlimit: true,
	    strokeOpacity: true,
	    strokeWidth: true
	};
	
	/**
	 * Taken from React's CSSProperty.js
	 *
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 * Taken from React's CSSProperty.js
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	// Taken from React's CSSProperty.js
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	    prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	    });
	});
	
	var stringifyValue = function stringifyValue(key /* : string */
	, prop /* : any */
	) /* : string */{
	    if (typeof prop === "number") {
	        if (isUnitlessNumber[key]) {
	            return "" + prop;
	        } else {
	            return prop + "px";
	        }
	    } else {
	        return '' + prop;
	    }
	};
	
	var stringifyAndImportantifyValue = function stringifyAndImportantifyValue(key /* : string */
	, prop /* : any */
	) {
	    return (/* : string */importantify(stringifyValue(key, prop))
	    );
	};
	
	// Turn a string into a hash string of base-36 values (using letters and numbers)
	// eslint-disable-next-line no-unused-vars
	var hashString = function hashString(string /* : string */, key /* : ?string */) {
	    return (/* string */stringHash(string).toString(36)
	    );
	};
	
	// Hash a javascript object using JSON.stringify. This is very fast, about 3
	// microseconds on my computer for a sample object:
	// http://jsperf.com/test-hashfnv32a-hash/5
	//
	// Note that this uses JSON.stringify to stringify the objects so in order for
	// this to produce consistent hashes browsers need to have a consistent
	// ordering of objects. Ben Alpert says that Facebook depends on this, so we
	// can probably depend on this too.
	var hashObject = function hashObject(object /* : ObjectMap */) {
	    return (/* : string */hashString(JSON.stringify(object))
	    );
	};
	
	// Given a single style value string like the "b" from "a: b;", adds !important
	// to generate "b !important".
	var importantify = function importantify(string /* : string */) {
	    return (/* : string */
	        // Bracket string character access is very fast, and in the default case we
	        // normally don't expect there to be "!important" at the end of the string
	        // so we can use this simple check to take an optimized path. If there
	        // happens to be a "!" in this position, we follow up with a more thorough
	        // check.
	        string[string.length - 10] === '!' && string.slice(-11) === ' !important' ? string : String(string) + ' !important'
	    );
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MAP_EXISTS = typeof Map !== 'undefined';
	
	var OrderedElements = function () {
	    /* ::
	    elements: {[string]: any};
	    keyOrder: string[];
	    */
	
	    function OrderedElements() {
	        _classCallCheck(this, OrderedElements);
	
	        this.elements = {};
	        this.keyOrder = [];
	    }
	
	    _createClass(OrderedElements, [{
	        key: 'forEach',
	        value: function () {
	            function forEach(callback /* : (string, any) => void */) {
	                for (var i = 0; i < this.keyOrder.length; i++) {
	                    // (value, key) to match Map's API
	                    callback(this.elements[this.keyOrder[i]], this.keyOrder[i]);
	                }
	            }
	
	            return forEach;
	        }()
	    }, {
	        key: 'set',
	        value: function () {
	            function set(key /* : string */, value /* : any */, shouldReorder /* : ?boolean */) {
	                if (!this.elements.hasOwnProperty(key)) {
	                    this.keyOrder.push(key);
	                } else if (shouldReorder) {
	                    var index = this.keyOrder.indexOf(key);
	                    this.keyOrder.splice(index, 1);
	                    this.keyOrder.push(key);
	                }
	
	                if (value == null) {
	                    this.elements[key] = value;
	                    return;
	                }
	
	                if (MAP_EXISTS && value instanceof Map || value instanceof OrderedElements) {
	                    // We have found a nested Map, so we need to recurse so that all
	                    // of the nested objects and Maps are merged properly.
	                    var nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
	                    value.forEach(function (value, key) {
	                        nested.set(key, value, shouldReorder);
	                    });
	                    this.elements[key] = nested;
	                    return;
	                }
	
	                if (!Array.isArray(value) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	                    // We have found a nested object, so we need to recurse so that all
	                    // of the nested objects and Maps are merged properly.
	                    var _nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
	                    var keys = Object.keys(value);
	                    for (var i = 0; i < keys.length; i += 1) {
	                        _nested.set(keys[i], value[keys[i]], shouldReorder);
	                    }
	                    this.elements[key] = _nested;
	                    return;
	                }
	
	                this.elements[key] = value;
	            }
	
	            return set;
	        }()
	    }, {
	        key: 'get',
	        value: function () {
	            function get(key /* : string */) /* : any */{
	                return this.elements[key];
	            }
	
	            return get;
	        }()
	    }, {
	        key: 'has',
	        value: function () {
	            function has(key /* : string */) /* : boolean */{
	                return this.elements.hasOwnProperty(key);
	            }
	
	            return has;
	        }()
	    }, {
	        key: 'addStyleType',
	        value: function () {
	            function addStyleType(styleType /* : any */) /* : void */{
	                var _this = this;
	
	                if (MAP_EXISTS && styleType instanceof Map || styleType instanceof OrderedElements) {
	                    styleType.forEach(function (value, key) {
	                        _this.set(key, value, true);
	                    });
	                } else {
	                    var keys = Object.keys(styleType);
	                    for (var i = 0; i < keys.length; i++) {
	                        this.set(keys[i], styleType[keys[i]], true);
	                    }
	                }
	            }
	
	            return addStyleType;
	        }()
	    }]);
	
	    return OrderedElements;
	}();
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	
	var staticPrefixData = {
	  plugins: [calc, crossFade, cursor, filter, flex, flexboxIE, flexboxOld, gradient, imageSet, position, sizing, transition],
	  prefixMap: { "transform": wms, "transformOrigin": wms, "transformOriginX": wms, "transformOriginY": wms, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "appearance": wm, "userSelect": wmms, "fontKerning": w, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": wm, "textDecorationSkip": wm, "textDecorationLine": wm, "textDecorationColor": wm, "filter": w, "fontFeatureSettings": wm, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": wms, "flexBasis": w, "flexDirection": wms, "flexGrow": w, "flexFlow": wms, "flexShrink": w, "flexWrap": wms, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w, "backdropFilter": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textOrientation": w, "boxSizing": m, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "touchAction": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w }
	};
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var prefixAll = createPrefixer(staticPrefixData);
	
	/* ::
	import type { SheetDefinition } from './index.js';
	type StringHandlers = { [id:string]: Function };
	type SelectorCallback = (selector: string) => string[];
	export type SelectorHandler = (
	    selector: string,
	    baseSelector: string,
	    callback: SelectorCallback
	) => string[] | string | null;
	*/
	
	/**
	 * `selectorHandlers` are functions which handle special selectors which act
	 * differently than normal style definitions. These functions look at the
	 * current selector and can generate CSS for the styles in their subtree by
	 * calling the callback with a new selector.
	 *
	 * For example, when generating styles with a base selector of '.foo' and the
	 * following styles object:
	 *
	 *   {
	 *     ':nth-child(2n)': {
	 *       ':hover': {
	 *         color: 'red'
	 *       }
	 *     }
	 *   }
	 *
	 * when we reach the ':hover' style, we would call our selector handlers like
	 *
	 *   handler(':hover', '.foo:nth-child(2n)', callback)
	 *
	 * Since our `pseudoSelectors` handles ':hover' styles, that handler would call
	 * the callback like
	 *
	 *   callback('.foo:nth-child(2n):hover')
	 *
	 * to generate its subtree `{ color: 'red' }` styles with a
	 * '.foo:nth-child(2n):hover' selector. The callback would return an array of CSS
	 * rules like
	 *
	 *   ['.foo:nth-child(2n):hover{color:red !important;}']
	 *
	 * and the handler would then return that resulting CSS.
	 *
	 * `defaultSelectorHandlers` is the list of default handlers used in a call to
	 * `generateCSS`.
	 *
	 * @name SelectorHandler
	 * @function
	 * @param {string} selector: The currently inspected selector. ':hover' in the
	 *     example above.
	 * @param {string} baseSelector: The selector of the parent styles.
	 *     '.foo:nth-child(2n)' in the example above.
	 * @param {function} generateSubtreeStyles: A function which can be called to
	 *     generate CSS for the subtree of styles corresponding to the selector.
	 *     Accepts a new baseSelector to use for generating those styles.
	 * @returns {string[] | string | null} The generated CSS for this selector, or
	 *     null if we don't handle this selector.
	 */
	var defaultSelectorHandlers /* : SelectorHandler[] */ = [
	// Handle pseudo-selectors, like :hover and :nth-child(3n)
	function () {
	    function pseudoSelectors(selector, baseSelector, generateSubtreeStyles) {
	        if (selector[0] !== ":") {
	            return null;
	        }
	        return generateSubtreeStyles(baseSelector + selector);
	    }
	
	    return pseudoSelectors;
	}(),
	
	// Handle media queries (or font-faces)
	function () {
	    function mediaQueries(selector, baseSelector, generateSubtreeStyles) {
	        if (selector[0] !== "@") {
	            return null;
	        }
	        // Generate the styles normally, and then wrap them in the media query.
	        var generated = generateSubtreeStyles(baseSelector);
	        return [String(selector) + '{' + String(generated.join('')) + '}'];
	    }
	
	    return mediaQueries;
	}()];
	
	/**
	 * Generate CSS for a selector and some styles.
	 *
	 * This function handles the media queries and pseudo selectors that can be used
	 * in aphrodite styles.
	 *
	 * @param {string} selector: A base CSS selector for the styles to be generated
	 *     with.
	 * @param {Object} styleTypes: A list of properties of the return type of
	 *     StyleSheet.create, e.g. [styles.red, styles.blue].
	 * @param {Array.<SelectorHandler>} selectorHandlers: A list of selector
	 *     handlers to use for handling special selectors. See
	 *     `defaultSelectorHandlers`.
	 * @param stringHandlers: See `generateCSSRuleset`
	 * @param useImportant: See `generateCSSRuleset`
	 *
	 * To actually generate the CSS special-construct-less styles are passed to
	 * `generateCSSRuleset`.
	 *
	 * For instance, a call to
	 *
	 *     generateCSS(".foo", [{
	 *       color: "red",
	 *       "@media screen": {
	 *         height: 20,
	 *         ":hover": {
	 *           backgroundColor: "black"
	 *         }
	 *       },
	 *       ":active": {
	 *         fontWeight: "bold"
	 *       }
	 *     }], defaultSelectorHandlers);
	 *
	 * with the default `selectorHandlers` will make 5 calls to
	 * `generateCSSRuleset`:
	 *
	 *     generateCSSRuleset(".foo", { color: "red" }, ...)
	 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
	 *     // These 2 will be wrapped in @media screen {}
	 *     generateCSSRuleset(".foo", { height: 20 }, ...)
	 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
	 */
	var generateCSS = function generateCSS(selector /* : string */
	, styleTypes /* : SheetDefinition[] */
	, selectorHandlers /* : SelectorHandler[] */
	, stringHandlers /* : StringHandlers */
	, useImportant /* : boolean */
	) /* : string[] */{
	    var merged = new OrderedElements();
	
	    for (var i = 0; i < styleTypes.length; i++) {
	        merged.addStyleType(styleTypes[i]);
	    }
	
	    var plainDeclarations = new OrderedElements();
	    var generatedStyles = [];
	
	    // TODO(emily): benchmark this to see if a plain for loop would be faster.
	    merged.forEach(function (val, key) {
	        // For each key, see if one of the selector handlers will handle these
	        // styles.
	        var foundHandler = selectorHandlers.some(function (handler) {
	            var result = handler(key, selector, function (newSelector) {
	                return generateCSS(newSelector, [val], selectorHandlers, stringHandlers, useImportant);
	            });
	            if (result != null) {
	                // If the handler returned something, add it to the generated
	                // CSS and stop looking for another handler.
	                if (Array.isArray(result)) {
	                    generatedStyles.push.apply(generatedStyles, _toConsumableArray(result));
	                } else {
	                    // eslint-disable-next-line
	                    console.warn('WARNING: Selector handlers should return an array of rules.' + 'Returning a string containing multiple rules is deprecated.', handler);
	                    generatedStyles.push('@media all {' + String(result) + '}');
	                }
	                return true;
	            }
	        });
	        // If none of the handlers handled it, add it to the list of plain
	        // style declarations.
	        if (!foundHandler) {
	            plainDeclarations.set(key, val, true);
	        }
	    });
	    var generatedRuleset = generateCSSRuleset(selector, plainDeclarations, stringHandlers, useImportant, selectorHandlers);
	
	    if (generatedRuleset) {
	        generatedStyles.unshift(generatedRuleset);
	    }
	
	    return generatedStyles;
	};
	
	/**
	 * Helper method of generateCSSRuleset to facilitate custom handling of certain
	 * CSS properties. Used for e.g. font families.
	 *
	 * See generateCSSRuleset for usage and documentation of paramater types.
	 */
	var runStringHandlers = function runStringHandlers(declarations /* : OrderedElements */
	, stringHandlers /* : StringHandlers */
	, selectorHandlers /* : SelectorHandler[] */
	) /* : void */{
	    if (!stringHandlers) {
	        return;
	    }
	
	    var stringHandlerKeys = Object.keys(stringHandlers);
	    for (var i = 0; i < stringHandlerKeys.length; i++) {
	        var key = stringHandlerKeys[i];
	        if (declarations.has(key)) {
	            // A declaration exists for this particular string handler, so we
	            // need to let the string handler interpret the declaration first
	            // before proceeding.
	            //
	            // TODO(emily): Pass in a callback which generates CSS, similar to
	            // how our selector handlers work, instead of passing in
	            // `selectorHandlers` and have them make calls to `generateCSS`
	            // themselves. Right now, this is impractical because our string
	            // handlers are very specialized and do complex things.
	            declarations.set(key, stringHandlers[key](declarations.get(key), selectorHandlers),
	
	            // Preserve order here, since we are really replacing an
	            // unprocessed style with a processed style, not overriding an
	            // earlier style
	            false);
	        }
	    }
	};
	
	var transformRule = function transformRule(key /* : string */
	, value /* : string */
	, transformValue /* : function */
	) {
	    return (/* : string */String(kebabifyStyleName(key)) + ':' + String(transformValue(key, value)) + ';'
	    );
	};
	
	var arrayToObjectKeysReducer = function arrayToObjectKeysReducer(acc, val) {
	    acc[val] = true;
	    return acc;
	};
	
	/**
	 * Generate a CSS ruleset with the selector and containing the declarations.
	 *
	 * This function assumes that the given declarations don't contain any special
	 * children (such as media queries, pseudo-selectors, or descendant styles).
	 *
	 * Note that this method does not deal with nesting used for e.g.
	 * psuedo-selectors or media queries. That responsibility is left to  the
	 * `generateCSS` function.
	 *
	 * @param {string} selector: the selector associated with the ruleset
	 * @param {Object} declarations: a map from camelCased CSS property name to CSS
	 *     property value.
	 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
	 *     property name to a function which will map the given value to the value
	 *     that is output.
	 * @param {bool} useImportant: A boolean saying whether to append "!important"
	 *     to each of the CSS declarations.
	 * @returns {string} A string of raw CSS.
	 *
	 * Examples:
	 *
	 *    generateCSSRuleset(".blah", { color: "red" })
	 *    -> ".blah{color: red !important;}"
	 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
	 *    -> ".blah{color: red}"
	 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
	 *    -> ".blah{color: RED}"
	 *    generateCSSRuleset(".blah:hover", { color: "red" })
	 *    -> ".blah:hover{color: red}"
	 */
	var generateCSSRuleset = function generateCSSRuleset(selector /* : string */
	, declarations /* : OrderedElements */
	, stringHandlers /* : StringHandlers */
	, useImportant /* : boolean */
	, selectorHandlers /* : SelectorHandler[] */
	) /* : string */{
	    // Mutates declarations
	    runStringHandlers(declarations, stringHandlers, selectorHandlers);
	
	    var originalElements = Object.keys(declarations.elements).reduce(arrayToObjectKeysReducer, Object.create(null));
	
	    // NOTE(emily): This mutates handledDeclarations.elements.
	    var prefixedElements = prefixAll(declarations.elements);
	
	    var elementNames = Object.keys(prefixedElements);
	    if (elementNames.length !== declarations.keyOrder.length) {
	        // There are some prefixed values, so we need to figure out how to sort
	        // them.
	        //
	        // Loop through prefixedElements, looking for anything that is not in
	        // sortOrder, which means it was added by prefixAll. This means that we
	        // need to figure out where it should appear in the sortOrder.
	        for (var i = 0; i < elementNames.length; i++) {
	            if (!originalElements[elementNames[i]]) {
	                // This element is not in the sortOrder, which means it is a prefixed
	                // value that was added by prefixAll. Let's try to figure out where it
	                // goes.
	                var originalStyle = void 0;
	                if (elementNames[i][0] === 'W') {
	                    // This is a Webkit-prefixed style, like "WebkitTransition". Let's
	                    // find its original style's sort order.
	                    originalStyle = elementNames[i][6].toLowerCase() + elementNames[i].slice(7);
	                } else if (elementNames[i][1] === 'o') {
	                    // This is a Moz-prefixed style, like "MozTransition". We check
	                    // the second character to avoid colliding with Ms-prefixed
	                    // styles. Let's find its original style's sort order.
	                    originalStyle = elementNames[i][3].toLowerCase() + elementNames[i].slice(4);
	                } else {
	                    // if (elementNames[i][1] === 's') {
	                    // This is a Ms-prefixed style, like "MsTransition".
	                    originalStyle = elementNames[i][2].toLowerCase() + elementNames[i].slice(3);
	                }
	
	                if (originalStyle && originalElements[originalStyle]) {
	                    var originalIndex = declarations.keyOrder.indexOf(originalStyle);
	                    declarations.keyOrder.splice(originalIndex, 0, elementNames[i]);
	                } else {
	                    // We don't know what the original style was, so sort it to
	                    // top. This can happen for styles that are added that don't
	                    // have the same base name as the original style.
	                    declarations.keyOrder.unshift(elementNames[i]);
	                }
	            }
	        }
	    }
	
	    var transformValue = useImportant === false ? stringifyValue : stringifyAndImportantifyValue;
	
	    var rules = [];
	    for (var _i = 0; _i < declarations.keyOrder.length; _i++) {
	        var key = declarations.keyOrder[_i];
	        var value = prefixedElements[key];
	        if (Array.isArray(value)) {
	            // inline-style-prefixer returns an array when there should be
	            // multiple rules for the same key. Here we flatten to multiple
	            // pairs with the same key.
	            for (var j = 0; j < value.length; j++) {
	                rules.push(transformRule(key, value[j], transformValue));
	            }
	        } else {
	            rules.push(transformRule(key, value, transformValue));
	        }
	    }
	
	    if (rules.length) {
	        return String(selector) + '{' + String(rules.join("")) + '}';
	    } else {
	        return "";
	    }
	};
	
	var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/* ::
	import type { SheetDefinition, SheetDefinitions } from './index.js';
	import type { MaybeSheetDefinition } from './exports.js';
	import type { SelectorHandler } from './generate.js';
	*/
	
	// The current <style> tag we are inserting into, or null if we haven't
	// inserted anything yet. We could find this each time using
	// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
	// faster.
	var styleTag /* : ?HTMLStyleElement */ = null;
	
	// Inject a set of rules into a <style> tag in the head of the document. This
	// will automatically create a style tag and then continue to use it for
	// multiple injections. It will also use a style tag with the `data-aphrodite`
	// tag on it if that exists in the DOM. This could be used for e.g. reusing the
	// same style tag that server-side rendering inserts.
	var injectStyleTag = function injectStyleTag(cssRules /* : string[] */) {
	    if (styleTag == null) {
	        // Try to find a style tag with the `data-aphrodite` attribute first.
	        styleTag = document.querySelector("style[data-aphrodite]") /* : any */;
	
	        // If that doesn't work, generate a new style tag.
	        if (styleTag == null) {
	            // Taken from
	            // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
	            var head = document.head || document.getElementsByTagName('head')[0];
	            styleTag = document.createElement('style');
	
	            styleTag.type = 'text/css';
	            styleTag.setAttribute("data-aphrodite", "");
	            head.appendChild(styleTag);
	        }
	    }
	
	    // $FlowFixMe
	    var sheet = styleTag.styleSheet || styleTag.sheet /* : any */;
	
	    if (sheet.insertRule) {
	        var numRules = sheet.cssRules.length;
	        cssRules.forEach(function (rule) {
	            try {
	                sheet.insertRule(rule, numRules);
	                numRules += 1;
	            } catch (e) {
	                // The selector for this rule wasn't compatible with the browser
	            }
	        });
	    } else {
	        styleTag.innerText = (styleTag.innerText || '') + cssRules.join('');
	    }
	};
	
	// Custom handlers for stringifying CSS values that have side effects
	// (such as fontFamily, which can cause @font-face rules to be injected)
	var stringHandlers = {
	    // With fontFamily we look for objects that are passed in and interpret
	    // them as @font-face rules that we need to inject. The value of fontFamily
	    // can either be a string (as normal), an object (a single font face), or
	    // an array of objects and strings.
	    fontFamily: function () {
	        function fontFamily(val) {
	            if (Array.isArray(val)) {
	                var nameMap = {};
	
	                val.forEach(function (v) {
	                    nameMap[fontFamily(v)] = true;
	                });
	
	                return Object.keys(nameMap).join(",");
	            } else if ((typeof val === 'undefined' ? 'undefined' : _typeof$1(val)) === "object") {
	                injectStyleOnce(val.src, "@font-face", [val], false);
	                return '"' + String(val.fontFamily) + '"';
	            } else {
	                return val;
	            }
	        }
	
	        return fontFamily;
	    }(),
	
	    // With animationName we look for an object that contains keyframes and
	    // inject them as an `@keyframes` block, returning a uniquely generated
	    // name. The keyframes object should look like
	    //  animationName: {
	    //    from: {
	    //      left: 0,
	    //      top: 0,
	    //    },
	    //    '50%': {
	    //      left: 15,
	    //      top: 5,
	    //    },
	    //    to: {
	    //      left: 20,
	    //      top: 20,
	    //    }
	    //  }
	    // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
	    // to use `animationName` here. Improve that so we can call this
	    // `animation` instead of `animationName`.
	    animationName: function () {
	        function animationName(val, selectorHandlers) {
	            if (Array.isArray(val)) {
	                return val.map(function (v) {
	                    return animationName(v, selectorHandlers);
	                }).join(",");
	            } else if ((typeof val === 'undefined' ? 'undefined' : _typeof$1(val)) === "object") {
	                // Generate a unique name based on the hash of the object. We can't
	                // just use the hash because the name can't start with a number.
	                // TODO(emily): this probably makes debugging hard, allow a custom
	                // name?
	                var name = 'keyframe_' + String(hashObject(val));
	
	                // Since keyframes need 3 layers of nesting, we use `generateCSS` to
	                // build the inner layers and wrap it in `@keyframes` ourselves.
	                var finalVal = '@keyframes ' + name + '{';
	
	                // TODO see if we can find a way where checking for OrderedElements
	                // here is not necessary. Alternatively, perhaps we should have a
	                // utility method that can iterate over either a plain object, an
	                // instance of OrderedElements, or a Map, and then use that here and
	                // elsewhere.
	                if (val instanceof OrderedElements) {
	                    val.forEach(function (valVal, valKey) {
	                        finalVal += generateCSS(valKey, [valVal], selectorHandlers, stringHandlers, false).join('');
	                    });
	                } else {
	                    Object.keys(val).forEach(function (key) {
	                        finalVal += generateCSS(key, [val[key]], selectorHandlers, stringHandlers, false).join('');
	                    });
	                }
	                finalVal += '}';
	
	                injectGeneratedCSSOnce(name, [finalVal]);
	
	                return name;
	            } else {
	                return val;
	            }
	        }
	
	        return animationName;
	    }()
	};
	
	// This is a map from Aphrodite's generated class names to `true` (acting as a
	// set of class names)
	var alreadyInjected = {};
	
	// This is the buffer of styles which have not yet been flushed.
	var injectionBuffer /* : string[] */ = [];
	
	// A flag to tell if we are already buffering styles. This could happen either
	// because we scheduled a flush call already, so newly added styles will
	// already be flushed, or because we are statically buffering on the server.
	var isBuffering = false;
	
	var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
	    var _injectionBuffer;
	
	    if (alreadyInjected[key]) {
	        return;
	    }
	
	    if (!isBuffering) {
	        // We should never be automatically buffering on the server (or any
	        // place without a document), so guard against that.
	        if (typeof document === "undefined") {
	            throw new Error("Cannot automatically buffer without a document");
	        }
	
	        // If we're not already buffering, schedule a call to flush the
	        // current styles.
	        isBuffering = true;
	        asap(flushToStyleTag);
	    }
	
	    (_injectionBuffer = injectionBuffer).push.apply(_injectionBuffer, _toConsumableArray$1(generatedCSS));
	    alreadyInjected[key] = true;
	};
	
	var injectStyleOnce = function injectStyleOnce(key /* : string */
	, selector /* : string */
	, definitions /* : SheetDefinition[] */
	, useImportant /* : boolean */
	) {
	    var selectorHandlers /* : SelectorHandler[] */ = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	    if (alreadyInjected[key]) {
	        return;
	    }
	
	    var generated = generateCSS(selector, definitions, selectorHandlers, stringHandlers, useImportant);
	
	    injectGeneratedCSSOnce(key, generated);
	};
	
	var reset = function reset() {
	    injectionBuffer = [];
	    alreadyInjected = {};
	    isBuffering = false;
	    styleTag = null;
	};
	
	var getBufferedStyles = function getBufferedStyles() {
	    return injectionBuffer;
	};
	
	var startBuffering = function startBuffering() {
	    if (isBuffering) {
	        throw new Error("Cannot buffer while already buffering");
	    }
	    isBuffering = true;
	};
	
	var flushToArray = function flushToArray() {
	    isBuffering = false;
	    var ret = injectionBuffer;
	    injectionBuffer = [];
	    return ret;
	};
	
	var flushToString = function flushToString() {
	    return flushToArray().join('');
	};
	
	var flushToStyleTag = function flushToStyleTag() {
	    var cssRules = flushToArray();
	    if (cssRules.length > 0) {
	        injectStyleTag(cssRules);
	    }
	};
	
	var getRenderedClassNames = function getRenderedClassNames() /* : string[] */{
	    return Object.keys(alreadyInjected);
	};
	
	var addRenderedClassNames = function addRenderedClassNames(classNames /* : string[] */) {
	    classNames.forEach(function (className) {
	        alreadyInjected[className] = true;
	    });
	};
	
	var processStyleDefinitions = function processStyleDefinitions(styleDefinitions /* : any[] */
	, classNameBits /* : string[] */
	, definitionBits /* : Object[] */
	, length /* : number */
	) /* : number */{
	    for (var i = 0; i < styleDefinitions.length; i += 1) {
	        // Filter out falsy values from the input, to allow for
	        // `css(a, test && c)`
	        if (styleDefinitions[i]) {
	            if (Array.isArray(styleDefinitions[i])) {
	                // We've encountered an array, so let's recurse
	                length += processStyleDefinitions(styleDefinitions[i], classNameBits, definitionBits, length);
	            } else {
	                classNameBits.push(styleDefinitions[i]._name);
	                definitionBits.push(styleDefinitions[i]._definition);
	                length += styleDefinitions[i]._len;
	            }
	        }
	    }
	    return length;
	};
	
	/**
	 * Inject styles associated with the passed style definition objects, and return
	 * an associated CSS class name.
	 *
	 * @param {boolean} useImportant If true, will append !important to generated
	 *     CSS output. e.g. {color: red} -> "color: red !important".
	 * @param {(Object|Object[])[]} styleDefinitions style definition objects, or
	 *     arbitrarily nested arrays of them, as returned as properties of the
	 *     return value of StyleSheet.create().
	 */
	var injectAndGetClassName = function injectAndGetClassName(useImportant /* : boolean */
	, styleDefinitions /* : MaybeSheetDefinition[] */
	, selectorHandlers /* : SelectorHandler[] */
	) /* : string */{
	    var classNameBits = [];
	    var definitionBits = [];
	
	    // Mutates classNameBits and definitionBits and returns a length which we
	    // will append to the hash to decrease the chance of hash collisions.
	    var length = processStyleDefinitions(styleDefinitions, classNameBits, definitionBits, 0);
	
	    // Break if there aren't any valid styles.
	    if (classNameBits.length === 0) {
	        return "";
	    }
	
	    var className = void 0;
	    if (true) {
	        className = classNameBits.length === 1 ? '_' + String(classNameBits[0]) : '_' + String(hashString(classNameBits.join())) + String((length % 36).toString(36));
	    } else {
	        className = classNameBits.join("-o_O-");
	    }
	
	    injectStyleOnce(className, '.' + String(className), definitionBits, useImportant, selectorHandlers);
	
	    return className;
	};
	
	/* ::
	import type { SelectorHandler } from './generate.js';
	export type SheetDefinition = { [id:string]: any };
	export type SheetDefinitions = SheetDefinition | SheetDefinition[];
	type RenderFunction = () => string;
	type Extension = {
	    selectorHandler: SelectorHandler
	};
	export type MaybeSheetDefinition = SheetDefinition | false | null | void
	*/
	
	var unminifiedHashFn = function unminifiedHashFn(str /* : string */, key /* : string */) {
	    return String(key) + '_' + String(hashString(str));
	};
	
	// StyleSheet.create is in a hot path so we want to keep as much logic out of it
	// as possible. So, we figure out which hash function to use once, and only
	// switch it out via minify() as necessary.
	//
	// This is in an exported function to make it easier to test.
	var initialHashFn = function initialHashFn() {
	    return  true ? hashString : unminifiedHashFn;
	};
	
	var hashFn = initialHashFn();
	
	var StyleSheet = {
	    create: function () {
	        function create(sheetDefinition /* : SheetDefinition */) /* : Object */{
	            var mappedSheetDefinition = {};
	            var keys = Object.keys(sheetDefinition);
	
	            for (var i = 0; i < keys.length; i += 1) {
	                var key = keys[i];
	                var val = sheetDefinition[key];
	                var stringVal = JSON.stringify(val);
	
	                mappedSheetDefinition[key] = {
	                    _len: stringVal.length,
	                    _name: hashFn(stringVal, key),
	                    _definition: val
	                };
	            }
	
	            return mappedSheetDefinition;
	        }
	
	        return create;
	    }(),
	    rehydrate: function () {
	        function rehydrate() {
	            var renderedClassNames /* : string[] */ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            addRenderedClassNames(renderedClassNames);
	        }
	
	        return rehydrate;
	    }()
	};
	
	/**
	 * Utilities for using Aphrodite server-side.
	 *
	 * This can be minified out in client-only bundles by replacing `typeof window`
	 * with `"object"`, e.g. via Webpack's DefinePlugin:
	 *
	 *   new webpack.DefinePlugin({
	 *     "typeof window": JSON.stringify("object")
	 *   })
	 */
	var StyleSheetServer = typeof window !== 'undefined' ? null : {
	    renderStatic: function () {
	        function renderStatic(renderFunc /* : RenderFunction */) {
	            reset();
	            startBuffering();
	            var html = renderFunc();
	            var cssContent = flushToString();
	
	            return {
	                html: html,
	                css: {
	                    content: cssContent,
	                    renderedClassNames: getRenderedClassNames()
	                }
	            };
	        }
	
	        return renderStatic;
	    }()
	};
	
	/**
	 * Utilities for using Aphrodite in tests.
	 *
	 * Not meant to be used in production.
	 */
	var StyleSheetTestUtils =  true ? null : {
	    /**
	    * Prevent styles from being injected into the DOM.
	    *
	    * This is useful in situations where you'd like to test rendering UI
	    * components which use Aphrodite without any of the side-effects of
	    * Aphrodite happening. Particularly useful for testing the output of
	    * components when you have no DOM, e.g. testing in Node without a fake DOM.
	    *
	    * Should be paired with a subsequent call to
	    * clearBufferAndResumeStyleInjection.
	    */
	    suppressStyleInjection: function () {
	        function suppressStyleInjection() {
	            reset();
	            startBuffering();
	        }
	
	        return suppressStyleInjection;
	    }(),
	
	
	    /**
	    * Opposite method of preventStyleInject.
	    */
	    clearBufferAndResumeStyleInjection: function () {
	        function clearBufferAndResumeStyleInjection() {
	            reset();
	        }
	
	        return clearBufferAndResumeStyleInjection;
	    }(),
	
	
	    /**
	    * Returns a string of buffered styles which have not been flushed
	    *
	    * @returns {string}  Buffer of styles which have not yet been flushed.
	    */
	    getBufferedStyles: function () {
	        function getBufferedStyles$$1() {
	            return getBufferedStyles();
	        }
	
	        return getBufferedStyles$$1;
	    }()
	};
	
	/**
	 * Generate the Aphrodite API exports, with given `selectorHandlers` and
	 * `useImportant` state.
	 */
	function makeExports(useImportant /* : boolean */
	) {
	    var selectorHandlers /* : SelectorHandler[] */ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSelectorHandlers;
	
	    return {
	        StyleSheet: Object.assign({}, StyleSheet, {
	
	            /**
	             * Returns a version of the exports of Aphrodite (i.e. an object
	             * with `css` and `StyleSheet` properties) which have some
	             * extensions included.
	             *
	             * @param {Array.<Object>} extensions: An array of extensions to
	             *     add to this instance of Aphrodite. Each object should have a
	             *     single property on it, defining which kind of extension to
	             *     add.
	             * @param {SelectorHandler} [extensions[].selectorHandler]: A
	             *     selector handler extension. See `defaultSelectorHandlers` in
	             *     generate.js.
	             *
	             * @returns {Object} An object containing the exports of the new
	             *     instance of Aphrodite.
	             */
	            extend: function () {
	                function extend(extensions /* : Extension[] */) {
	                    var extensionSelectorHandlers = extensions
	                    // Pull out extensions with a selectorHandler property
	                    .map(function (extension) {
	                        return extension.selectorHandler;
	                    })
	                    // Remove nulls (i.e. extensions without a selectorHandler property).
	                    .filter(function (handler) {
	                        return handler;
	                    });
	
	                    return makeExports(useImportant, selectorHandlers.concat(extensionSelectorHandlers));
	                }
	
	                return extend;
	            }()
	        }),
	
	        StyleSheetServer: StyleSheetServer,
	        StyleSheetTestUtils: StyleSheetTestUtils,
	
	        minify: function () {
	            function minify(shouldMinify /* : boolean */) {
	                hashFn = shouldMinify ? hashString : unminifiedHashFn;
	            }
	
	            return minify;
	        }(),
	        css: function () {
	            function css() /* : MaybeSheetDefinition[] */{
	                for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
	                    styleDefinitions[_key] = arguments[_key];
	                }
	
	                return injectAndGetClassName(useImportant, styleDefinitions, selectorHandlers);
	            }
	
	            return css;
	        }(),
	
	
	        flushToStyleTag: flushToStyleTag,
	        injectAndGetClassName: injectAndGetClassName,
	        defaultSelectorHandlers: defaultSelectorHandlers
	    };
	}
	
	exports.makeExports = makeExports;


/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DownloadMaterialButton = __webpack_require__(204);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DownloadMaterialButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HideLogoLabelOnPhoneStyles = exports.LogoLabelStyles = exports.LogoLabelFontSize = exports.LogoLabelColor = exports.px = exports.LOGO_PHONE_SCALE = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  font-weight: normal;\n\n  color: ', ';\n\n  padding-bottom: 4px;\n'], ['\n  font-size: ', ';\n  font-weight: normal;\n\n  color: ', ';\n\n  padding-bottom: 4px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    display: none;\n  }\n'], ['\n  ', ' {\n    display: none;\n  }\n']);
	
	var _emotion = __webpack_require__(13);
	
	var _breakpoints = __webpack_require__(4);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LOGO_PHONE_SCALE = exports.LOGO_PHONE_SCALE = 0.73333;
	
	var px = exports.px = function px(px_) {
	  return Math.round(px_) + 'px';
	};
	
	var LogoLabelColor = exports.LogoLabelColor = '#A7A7A7';
	var LogoLabelFontSize = exports.LogoLabelFontSize = '13px';
	
	var LogoLabelStyles = exports.LogoLabelStyles = (0, _emotion.css)(_templateObject, LogoLabelFontSize, LogoLabelColor);
	
	var HideLogoLabelOnPhoneStyles = exports.HideLogoLabelOnPhoneStyles = (0, _emotion.css)(_templateObject2, _breakpoints.mediaPhone);

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var sharpImageRendering = "\n   image-rendering: -moz-crisp-edges;\n   image-rendering:   -o-crisp-edges;\n   image-rendering: -webkit-optimize-contrast;\n   image-rendering: crisp-edges;\n   -ms-interpolation-mode: nearest-neighbor;\n";
	
	exports.sharpImageRendering = sharpImageRendering;

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 76 */,
/* 77 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var __chunk_1 = __webpack_require__(59);
	__webpack_require__(47);
	__webpack_require__(32);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(35);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	__webpack_require__(39);
	__webpack_require__(40);
	__webpack_require__(41);
	__webpack_require__(42);
	__webpack_require__(43);
	__webpack_require__(31);
	__webpack_require__(23);
	
	var useImportant = true; // Add !important to all style definitions
	
	var Aphrodite = __chunk_1.makeExports(useImportant);
	
	var StyleSheet = Aphrodite.StyleSheet,
	    StyleSheetServer = Aphrodite.StyleSheetServer,
	    StyleSheetTestUtils = Aphrodite.StyleSheetTestUtils,
	    css = Aphrodite.css,
	    minify = Aphrodite.minify,
	    flushToStyleTag = Aphrodite.flushToStyleTag,
	    injectAndGetClassName = Aphrodite.injectAndGetClassName,
	    defaultSelectorHandlers = Aphrodite.defaultSelectorHandlers;
	
	exports.StyleSheet = StyleSheet;
	exports.StyleSheetServer = StyleSheetServer;
	exports.StyleSheetTestUtils = StyleSheetTestUtils;
	exports.css = css;
	exports.minify = minify;
	exports.flushToStyleTag = flushToStyleTag;
	exports.injectAndGetClassName = injectAndGetClassName;
	exports.defaultSelectorHandlers = defaultSelectorHandlers;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DownloadPdf = __webpack_require__(205);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DownloadPdf).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PTBold = exports.PTMono = exports.PTSans = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: \'PT Sans\', sans-serif;\n  font-weight: normal;\n'], ['\n  font-family: \'PT Sans\', sans-serif;\n  font-weight: normal;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-family: \'PT Mono\', monospace;\n  font-weight: normal;\n'], ['\n  font-family: \'PT Mono\', monospace;\n  font-weight: normal;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-family: \'PT Mono\', monospace;\n  font-weight: bold;\n'], ['\n  font-family: \'PT Mono\', monospace;\n  font-weight: bold;\n']);
	
	var _core = __webpack_require__(10);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PTSans = exports.PTSans = (0, _core.css)(_templateObject);
	
	var PTMono = exports.PTMono = (0, _core.css)(_templateObject2);
	
	var PTBold = exports.PTBold = (0, _core.css)(_templateObject3);

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var DESKTOP_WIDTH = exports.DESKTOP_WIDTH = 1180;
	var DESKTOP_MARGIN = exports.DESKTOP_MARGIN = 35;
	
	var TABLET_WIDTH = exports.TABLET_WIDTH = 732;
	var TABLET_MARGIN = exports.TABLET_MARGIN = 15;
	
	var PHONE_MARGIN = exports.PHONE_MARGIN = 25;

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(111);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(56);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var newStyle = {};
	    var requiredPrefixes = prefixProperties[property];
	    var capitalizedProperty = (0, _capitalizeString2.default)(property);
	    var keys = Object.keys(style);
	    for (var i = 0; i < keys.length; i++) {
	      var styleProperty = keys[i];
	      if (styleProperty === property) {
	        for (var j = 0; j < requiredPrefixes.length; j++) {
	          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
	        }
	      }
	      newStyle[styleProperty] = style[styleProperty];
	    }
	    return newStyle;
	  }
	  return style;
	}
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(123);
	var Stylis = _interopDefault(__webpack_require__(186));
	__webpack_require__(188);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet$$1, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet$$1;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet$$1.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case 2:
	          {
	            for (var i = 0, len = selectors.length; len > i; i++) {
	              // :last-child isn't included here since it's safe
	              // because a style element will never be the last element
	              var match = selectors[i].match(/:(first|nth|nth-last)-child/);
	
	              if (match !== null) {
	                console.error("The pseudo class \"" + match[0] + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + match[1] + "-of-type\"");
	              }
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ }),
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BALogo = __webpack_require__(202);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BALogo).default;
	  }
	});
	Object.defineProperty(exports, 'BALogoSmallOnPhone', {
	  enumerable: true,
	  get: function get() {
	    return _BALogo.BALogoSmallOnPhone;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BFBLogo = __webpack_require__(203);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BFBLogo).default;
	  }
	});
	Object.defineProperty(exports, 'BFBLogoSmallOnPhone', {
	  enumerable: true,
	  get: function get() {
	    return _BFBLogo.BFBLogoSmallOnPhone;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ExternalSourceShape = __webpack_require__(129);
	
	var _ExternalSourceShape2 = _interopRequireDefault(_ExternalSourceShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.arrayOf(_propTypes2.default.shape({
	  id: _propTypes2.default.string,
	  title: _propTypes2.default.string.isRequired,
	  items: _propTypes2.default.arrayOf(_ExternalSourceShape2.default).isRequired
	}));
	module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  type: _propTypes2.default.oneOf(['link', 'pdf', 'image', 'video']),
	  body: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
	});
	module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExternalLinksCollection = __webpack_require__(207);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExternalLinksCollection).default;
	  }
	});
	
	var _ExternalLinksShape = __webpack_require__(128);
	
	Object.defineProperty(exports, 'ExternalLinksShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExternalLinksShape).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TextFontStyles = exports.SectionIdFontStyles = exports.SectionHeadlineFontStyles = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n\n  font-size: 16px;\n  ', ' {\n    font-size: 20px;\n  }\n  ', ' {\n    font-size: 22px;\n  }\n'], ['\n  color: ', ';\n\n  font-size: 16px;\n  ', ' {\n    font-size: 20px;\n  }\n  ', ' {\n    font-size: 22px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  color: ', ';\n\n  font-size: 22px;\n  ', ' {\n    font-size: 28px;\n  }\n  ', ' {\n    font-size: 32px;\n  }\n'], ['\n  ', ';\n\n  color: ', ';\n\n  font-size: 22px;\n  ', ' {\n    font-size: 28px;\n  }\n  ', ' {\n    font-size: 32px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n\n  font-size: 16px;\n  ', ' {\n    font-size: 18px;\n  }\n'], ['\n  color: ', ';\n\n  font-size: 16px;\n  ', ' {\n    font-size: 18px;\n  }\n']);
	
	var _core = __webpack_require__(10);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	var _fonts = __webpack_require__(82);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SectionHeadlineFontStyles = exports.SectionHeadlineFontStyles = (0, _core.css)(_templateObject, _colors.TextColor, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var SectionIdFontStyles = exports.SectionIdFontStyles = (0, _core.css)(_templateObject2, _fonts.PTMono, _colors.PrimaryColor, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var TextFontStyles = exports.TextFontStyles = (0, _core.css)(_templateObject3, _colors.TextColor, _breakpoints.minDesktop);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GrafikPDFDownload = __webpack_require__(210);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GrafikPDFDownload).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageLayout = __webpack_require__(225);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PageLayout).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(11);
	
	var _theme = __webpack_require__(22);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(45);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	var _Icon = __webpack_require__(167);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Arrow(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var direction = _ref.direction,
		    icon = _ref.icon,
		    onClick = _ref.onClick,
		    size = _ref.size,
		    props = _objectWithoutProperties(_ref, ['direction', 'icon', 'onClick', 'size']);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement(
			'button',
			_extends({
				type: 'button',
				className: (0, _noImportant.css)(classes.arrow, classes['arrow__direction__' + direction], size && classes['arrow__size__' + size]),
				onClick: onClick,
				onTouchEnd: onClick
			}, props),
			_react2.default.createElement(_Icon2.default, { fill: !!theme.arrow && theme.arrow.fill || _theme2.default.arrow.fill, type: icon })
		);
	}
	
	Arrow.propTypes = {
		direction: _propTypes2.default.oneOf(['left', 'right']),
		icon: _propTypes2.default.string,
		onClick: _propTypes2.default.func.isRequired,
		size: _propTypes2.default.oneOf(['medium', 'small']).isRequired
	};
	Arrow.defaultProps = {
		size: 'medium'
	};
	Arrow.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		arrow: {
			background: 'none',
			border: 'none',
			borderRadius: 4,
			cursor: 'pointer',
			outline: 'none',
			padding: 10, // increase hit area
			position: 'absolute',
			top: '50%',
	
			// disable user select
			WebkitTouchCallout: 'none',
			userSelect: 'none'
		},
	
		// sizes
		arrow__size__medium: {
			height: _theme2.default.arrow.height,
			marginTop: _theme2.default.arrow.height / -2,
			width: 40,
	
			'@media (min-width: 768px)': {
				width: 70
			}
		},
		arrow__size__small: {
			height: _theme2.default.thumbnail.size,
			marginTop: _theme2.default.thumbnail.size / -2,
			width: 30,
	
			'@media (min-width: 500px)': {
				width: 40
			}
		},
	
		// direction
		arrow__direction__right: {
			right: _theme2.default.container.gutter.horizontal
		},
		arrow__direction__left: {
			left: _theme2.default.container.gutter.horizontal
		}
	};
	
	exports.default = Arrow;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _arrowLeft = __webpack_require__(373);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	var _arrowRight = __webpack_require__(374);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _close = __webpack_require__(375);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var icons = { arrowLeft: _arrowLeft2.default, arrowRight: _arrowRight2.default, close: _close2.default };
	
	var Icon = function Icon(_ref) {
		var fill = _ref.fill,
		    type = _ref.type,
		    props = _objectWithoutProperties(_ref, ['fill', 'type']);
	
		var icon = icons[type];
	
		return _react2.default.createElement('span', _extends({
			dangerouslySetInnerHTML: { __html: icon(fill) }
		}, props));
	};
	
	Icon.propTypes = {
		fill: _propTypes2.default.string,
		type: _propTypes2.default.oneOf(Object.keys(icons))
	};
	Icon.defaultProps = {
		fill: 'white'
	};
	
	exports.default = Icon;

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// create defaults
	var defaultProps = exports.defaultProps = {
	  attributes: {},
	  styles: {}
	};
	
	var PropToggle = function (_PureComponent) {
	  _inherits(PropToggle, _PureComponent);
	
	  function PropToggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PropToggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PropToggle.__proto__ || Object.getPrototypeOf(PropToggle)).call.apply(_ref, [this].concat(args))), _this), _this.originalAttributes = {}, _this.originalStyles = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PropToggle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          attributes = _props.attributes,
	          styles = _props.styles,
	          _props$target = _props.target,
	          target = _props$target === undefined ? document.body : _props$target;
	
	      if (!target) return;
	
	      this.attributeKeys = Object.keys(attributes);
	      this.styleKeys = Object.keys(styles);
	
	      // styles
	      if (this.styleKeys.length) {
	        this.styleKeys.forEach(function (k) {
	          _this2.originalStyles[k] = target.style.getPropertyValue(k);
	          target.style.setProperty(k, styles[k]);
	        });
	      }
	
	      // attributes
	      if (this.attributeKeys.length) {
	        this.attributeKeys.forEach(function (k) {
	          _this2.originalAttributes[k] = target.getAttribute(k) || '';
	          target.setAttribute(k, attributes[k]);
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      var _props$target2 = this.props.target,
	          target = _props$target2 === undefined ? document.body : _props$target2;
	
	      if (!target) return;
	
	      // styles
	      if (this.styleKeys.length) {
	        this.styleKeys.forEach(function (k) {
	          target.style.setProperty(k, _this3.originalStyles[k]);
	        });
	      }
	
	      // attributes
	      if (this.attributeKeys.length) {
	        this.attributeKeys.forEach(function (k) {
	          if (_this3.originalAttributes[k]) {
	            target.setAttribute(k, _this3.originalAttributes[k]);
	          } else {
	            target.removeAttribute(k);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return PropToggle;
	}(_react.PureComponent);
	
	PropToggle.defaultProps = defaultProps;
	exports.default = PropToggle;

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventTouchMove = preventTouchMove;
	exports.allowTouchMove = allowTouchMove;
	exports.preventInertiaScroll = preventInertiaScroll;
	exports.isTouchDevice = isTouchDevice;
	exports.getPadding = getPadding;
	exports.camelToKebab = camelToKebab;
	exports.getWindowHeight = getWindowHeight;
	exports.getDocumentHeight = getDocumentHeight;
	exports.parse = parse;
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	}
	
	// `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	function isTouchDevice() {
	  if (!window) return false;
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	function getPadding() {
	  if (!document || !window) return 0;
	
	  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
	  var clientWidth = document.body ? document.body.clientWidth : 0;
	  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	
	  return adjustedPadding;
	}
	
	function camelToKebab(str) {
	  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	
	function getWindowHeight() {
	  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	  if (window && window.innerHeight) {
	    return window.innerHeight * multiplier;
	  }
	}
	
	function getDocumentHeight() {
	  if (document && document.body) {
	    return document.body.clientHeight;
	  }
	}
	
	function parse(val) {
	  return isNaN(val) ? val : val + 'px';
	}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(54));
	
	var _reactLifecyclesCompat = __webpack_require__(168);
	
	var _PropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?
	
	
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(168);
	
	var _ChildMapping = __webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};;
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.transitionTimeout = transitionTimeout;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number
	}).isRequired]);
	
	exports.timeoutsShape = timeoutsShape;
	
	var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]);
	
	exports.classNamesShape = classNamesShape;

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTE4MCIgaGVpZ2h0PSI2NCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDAgTDExODAgMCBMMCA2NCBaIiBmaWxsPSIjRjdGN0Y3IiAvPgo8L3N2Zz4K"

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTE4MCIgaGVpZ2h0PSI2NCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDY0IEwxMTgwIDAgTDExODAgNjQgWiIgZmlsbD0iI0Y3RjdGNyIgLz4KPC9zdmc+Cg=="

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(58);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	exports.default = murmurhash2_32_gc;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(122));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var index = memoize(function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports.default = index;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var isPropValid = _interopDefault(__webpack_require__(184));
	var _objectAssign = _interopDefault(__webpack_require__(44));
	var core = __webpack_require__(10);
	var utils = __webpack_require__(77);
	var serialize = __webpack_require__(58);
	
	var testOmitPropsOnStringTag = isPropValid;
	
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	
	var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
	  return typeof tag === 'string' && // 96 is one less than the char code
	  // for "a" so this is checking that
	  // it's a lowercase character
	  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	};
	
	var createStyled = function createStyled(tag, options) {
	  if (false) {
	    if (tag === undefined) {
	      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	    }
	  }
	
	  var identifierName;
	  var shouldForwardProp;
	  var targetClassName;
	
	  if (options !== undefined) {
	    identifierName = options.label;
	    targetClassName = options.target;
	    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
	      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
	      options.shouldForwardProp(propName);
	    } : options.shouldForwardProp;
	  }
	
	  var isReal = tag.__emotion_real === tag;
	  var baseTag = isReal && tag.__emotion_base || tag;
	
	  if (typeof shouldForwardProp !== 'function' && isReal) {
	    shouldForwardProp = tag.__emotion_forwardProp;
	  }
	
	  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
	  var shouldUseAs = !defaultShouldForwardProp('as');
	  return function () {
	    var args = arguments;
	    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
	
	    if (identifierName !== undefined) {
	      styles.push("label:" + identifierName + ";");
	    }
	
	    if (args[0] == null || args[0].raw === undefined) {
	      styles.push.apply(styles, args);
	    } else {
	      styles.push(args[0][0]);
	      var len = args.length;
	      var i = 1;
	
	      for (; i < len; i++) {
	        styles.push(args[i], args[0][i]);
	      }
	    }
	
	    var Styled = core.withEmotionCache(function (props, context, ref) {
	      return React.createElement(core.ThemeContext.Consumer, null, function (theme) {
	        var finalTag = shouldUseAs && props.as || baseTag;
	        var className = '';
	        var classInterpolations = [];
	        var mergedProps = props;
	
	        if (props.theme == null) {
	          mergedProps = {};
	
	          for (var key in props) {
	            mergedProps[key] = props[key];
	          }
	
	          mergedProps.theme = theme;
	        }
	
	        if (typeof props.className === 'string') {
	          className += utils.getRegisteredStyles(context.registered, classInterpolations, props.className);
	        }
	
	        var serialized = serialize.serializeStyles(styles.concat(classInterpolations), context.registered, mergedProps);
	        var rules = utils.insertStyles(context, serialized, typeof finalTag === 'string');
	        className += context.key + "-" + serialized.name;
	
	        if (targetClassName !== undefined) {
	          className += " " + targetClassName;
	        }
	
	        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
	        var newProps = {};
	
	        for (var _key in props) {
	          if (shouldUseAs && _key === 'as') continue;
	
	          if ( // $FlowFixMe
	          finalShouldForwardProp(_key)) {
	            newProps[_key] = props[_key];
	          }
	        }
	
	        newProps.className = className;
	        newProps.ref = ref || props.innerRef;
	
	        if (false) {
	          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
	        }
	
	        var ele = React.createElement(finalTag, newProps);
	
	        return ele;
	      });
	    });
	    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	    Styled.defaultProps = tag.defaultProps;
	    Styled.__emotion_real = Styled;
	    Styled.__emotion_base = baseTag;
	    Styled.__emotion_styles = styles;
	    Styled.__emotion_forwardProp = shouldForwardProp;
	    Object.defineProperty(Styled, 'toString', {
	      value: function value() {
	        if (targetClassName === undefined && ("production") !== 'production') {
	          return 'NO_COMPONENT_SELECTOR';
	        } // $FlowFixMe
	
	
	        return "." + targetClassName;
	      }
	    });
	
	    Styled.withComponent = function (nextTag, nextOptions) {
	      return createStyled(nextTag, nextOptions !== undefined ? _objectAssign({}, options || {}, nextOptions) : options).apply(void 0, styles);
	    };
	
	    return Styled;
	  };
	};
	
	exports.default = createStyled;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e, m).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var __chunk_1 = __webpack_require__(59);
	__webpack_require__(47);
	__webpack_require__(32);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(35);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	__webpack_require__(39);
	__webpack_require__(40);
	__webpack_require__(41);
	__webpack_require__(42);
	__webpack_require__(43);
	__webpack_require__(31);
	__webpack_require__(23);
	
	var useImportant = false; // Don't add !important to style definitions
	
	var Aphrodite = __chunk_1.makeExports(useImportant);
	
	var StyleSheet = Aphrodite.StyleSheet,
	    StyleSheetServer = Aphrodite.StyleSheetServer,
	    StyleSheetTestUtils = Aphrodite.StyleSheetTestUtils,
	    css = Aphrodite.css,
	    minify = Aphrodite.minify,
	    flushToStyleTag = Aphrodite.flushToStyleTag,
	    injectAndGetClassName = Aphrodite.injectAndGetClassName,
	    defaultSelectorHandlers = Aphrodite.defaultSelectorHandlers;
	
	exports.StyleSheet = StyleSheet;
	exports.StyleSheetServer = StyleSheetServer;
	exports.StyleSheetTestUtils = StyleSheetTestUtils;
	exports.css = css;
	exports.minify = minify;
	exports.flushToStyleTag = flushToStyleTag;
	exports.injectAndGetClassName = injectAndGetClassName;
	exports.defaultSelectorHandlers = defaultSelectorHandlers;


/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n\n  ', ' {\n    flex-direction: row;\n    justify-content: space-around;\n  }\n\n  ', ' {\n    display: block;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n\n  ', ' {\n    flex-direction: row;\n    justify-content: space-around;\n  }\n\n  ', ' {\n    display: block;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  flex: 0 1 auto;\n\n  ', ' {\n    margin-bottom: 40px;\n  }\n\n  ', ' {\n    flex: 0 1 306px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ', ' {\n    margin-bottom: 50px;\n  }\n'], ['\n  flex: 0 1 auto;\n\n  ', ' {\n    margin-bottom: 40px;\n  }\n\n  ', ' {\n    flex: 0 1 306px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ', ' {\n    margin-bottom: 50px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  max-width: 340px;\n\n  ', ' {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  flex: 0 1 auto;\n\n  ', ' {\n    flex: 0 1 300px;\n  }\n'], ['\n  max-width: 340px;\n\n  ', ' {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  flex: 0 1 auto;\n\n  ', ' {\n    flex: 0 1 300px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    display: flex;\n    justify-content: space-between;\n    max-width: 1020px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n'], ['\n  ', ' {\n    display: flex;\n    justify-content: space-between;\n    max-width: 1020px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    flex: 0 1 600px;\n    padding-bottom: 150px;\n  }\n'], ['\n  ', ' {\n    flex: 0 1 600px;\n    padding-bottom: 150px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _Introduction = __webpack_require__(199);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _DownloadMaterial = __webpack_require__(198);
	
	var _DownloadMaterial2 = _interopRequireDefault(_DownloadMaterial);
	
	var _MaterialDescription = __webpack_require__(200);
	
	var _MaterialDescription2 = _interopRequireDefault(_MaterialDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DownloadMaterialWithDescription = _styled2.default.div(_templateObject, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var DownloadMaterialStyled = (0, _styled2.default)(_DownloadMaterial2.default)(_templateObject2, _breakpoints.mediaPhone, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var MaterialDescriptionStyled = (0, _styled2.default)(_MaterialDescription2.default)(_templateObject3, _breakpoints.mediaPhone, _breakpoints.minTablet);
	
	var Section = _styled2.default.section(_templateObject4, _breakpoints.minDesktop);
	
	var IntroductionStyled = (0, _styled2.default)(_Introduction2.default)(_templateObject5, _breakpoints.minDesktop);
	
	var AboutMaterialDownload = function AboutMaterialDownload() {
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(IntroductionStyled, null),
	    _react2.default.createElement(
	      DownloadMaterialWithDescription,
	      null,
	      _react2.default.createElement(DownloadMaterialStyled, null),
	      _react2.default.createElement(MaterialDescriptionStyled, null)
	    )
	  );
	};
	
	exports.default = AboutMaterialDownload;
	module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  width: 306px;\n  margin-left: auto;\n  margin-right: auto;\n'], ['\n  position: relative;\n  width: 306px;\n  margin-left: auto;\n  margin-right: auto;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 225px;\n  left: 0;\n  right: 0;\n  padding: 15px 0;\n  border-radius: 3px;\n  text-align: center;\n'], ['\n  position: absolute;\n  top: 225px;\n  left: 0;\n  right: 0;\n  padding: 15px 0;\n  border-radius: 3px;\n  text-align: center;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GrafikPDFDownload = __webpack_require__(132);
	
	var _GrafikPDFDownload2 = _interopRequireDefault(_GrafikPDFDownload);
	
	var _DownloadMaterialButton = __webpack_require__(61);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _DownloadPdf = __webpack_require__(81);
	
	var _DownloadPdf2 = _interopRequireDefault(_DownloadPdf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Article = _styled2.default.article(_templateObject);
	
	var DownloadMaterialButtonStyled = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject2);
	
	var DownloadMaterial = function DownloadMaterial(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    Article,
	    { className: className },
	    _react2.default.createElement(
	      _DownloadPdf2.default,
	      null,
	      _react2.default.createElement(_GrafikPDFDownload2.default, null),
	      _react2.default.createElement(DownloadMaterialButtonStyled, null)
	    )
	  );
	};
	
	DownloadMaterial.propTypes = {
	  className: _propTypes2.default.string
	};
	
	DownloadMaterial.defaultProps = {
	  className: undefined
	};
	
	exports.default = DownloadMaterial;
	module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: 16px;\n  line-height: 1.4;\n\n  ', ' {\n    font-size: 22px;\n  }\n\n  margin-bottom: 0;\n\n  & + &::first-letter {\n    margin-left: 1rem;\n  }\n'], ['\n  font-size: 16px;\n  line-height: 1.4;\n\n  ', ' {\n    font-size: 22px;\n  }\n\n  margin-bottom: 0;\n\n  & + &::first-letter {\n    margin-left: 1rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: -30px;\n\n  ', ' {\n    display: none;\n  }\n'], ['\n  margin-top: -30px;\n\n  ', ' {\n    display: none;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  @media (min-width: 540px) {\n    margin-top: 35px;\n  }\n  ', ' {\n    margin-bottom: 30px;\n  }\n  @media (min-width: 950px) {\n    margin-top: 35px;\n  }\n  ', ' {\n    margin-top: 55px;\n  }\n'], ['\n  @media (min-width: 540px) {\n    margin-top: 35px;\n  }\n  ', ' {\n    margin-bottom: 30px;\n  }\n  @media (min-width: 950px) {\n    margin-top: 35px;\n  }\n  ', ' {\n    margin-top: 55px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: ', ';\n  margin-top: 10px;\n'], ['\n  display: ', ';\n  margin-top: 10px;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  -webkit-appearance: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n  }\n'], ['\n  -webkit-appearance: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  padding-top: 30px;\n  min-height: 250px;\n\n  @media (max-width: 600px) {\n    padding-top: 20px;\n  }\n'], ['\n  position: relative;\n  padding-top: 30px;\n  min-height: 250px;\n\n  @media (max-width: 600px) {\n    padding-top: 20px;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 40px;\n  right: 0;\n\n  & > img {\n    width: 300px;\n  }\n\n  @media (max-width: 600px) {\n    position: static;\n    margin-left: 0;\n  }\n'], ['\n  position: absolute;\n  top: 40px;\n  right: 0;\n\n  & > img {\n    width: 300px;\n  }\n\n  @media (max-width: 600px) {\n    position: static;\n    margin-left: 0;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  padding-top: 20px;\n  padding-right: 320px;\n  @media (max-width: 600px) {\n    padding-right: 0;\n  }\n  max-width: 820px;\n'], ['\n  padding-top: 20px;\n  padding-right: 320px;\n  @media (max-width: 600px) {\n    padding-right: 0;\n  }\n  max-width: 820px;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  padding-bottom: 20px;\n'], ['\n  padding-bottom: 20px;\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  margin-top: 20px;\n'], ['\n  margin-top: 20px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _core = __webpack_require__(10);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _H = __webpack_require__(48);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Stacheldraht = __webpack_require__(15);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _breakpoints = __webpack_require__(4);
	
	var _fonts = __webpack_require__(82);
	
	var _colors = __webpack_require__(8);
	
	var _outlineAdd_circle_outline24px = __webpack_require__(410);
	
	var _outlineAdd_circle_outline24px2 = _interopRequireDefault(_outlineAdd_circle_outline24px);
	
	var _Katharina_HochmuthBfA_ = __webpack_require__(411);
	
	var _Katharina_HochmuthBfA_2 = _interopRequireDefault(_Katharina_HochmuthBfA_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// import UnterschriftImg from './images/unterschrift.png';
	
	var P = _styled2.default.p(_templateObject, _breakpoints.minDesktop);
	
	var StacheldrahtStyled = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject2, _breakpoints.minDesktop);
	
	var Article = _styled2.default.article(_templateObject3, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var ExtendedSection = _styled2.default.section(_templateObject4, function (_ref) {
	  var show = _ref.show;
	  return show ? 'block' : 'none';
	});
	
	var ResetButtonStyles = (0, _core.css)(_templateObject5);
	
	var ShowMoreButton = _styled2.default.button([ResetButtonStyles, _fonts.PTBold, '\n  font-size: 16px;\n  ' + _breakpoints.mediaPhone + ' {\n    font-size: 14px;\n  }\n\n  color: ' + _colors.PrimaryColor + ';\n\n  &:hover {\n    color: ' + _colors.PrimaryDarkColor + ';\n  }\n\n  display: block;\n  margin-top: 20px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 36px;\n  line-height: 24px;\n\n  background-size: 24px 24px;\n  background-repeat: no-repeat;\n  background-position: left;\n  background-image: url(' + _outlineAdd_circle_outline24px2.default + ');\n']);
	
	var IntroFooter = _styled2.default.footer(_templateObject6);
	
	// const Unterschrift = styled.div`
	//   & > img {
	//     width: 222px;
	//   }
	//   @media (max-width: 600px) {
	//     margin-bottom: 15px;
	//   }
	// `;
	
	var Katharina = _styled2.default.div(_templateObject7);
	
	var Absender = _styled2.default.div(_templateObject8);
	
	var AbsenderName = (0, _styled2.default)(P)(_templateObject9);
	
	var H2Styled = (0, _styled2.default)(_H2.default)(_templateObject10);
	
	var Introduction = function (_React$Component) {
	  _inherits(Introduction, _React$Component);
	
	  function Introduction(props) {
	    _classCallCheck(this, Introduction);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      showLongContent: false
	    };
	    return _this;
	  }
	
	  Introduction.prototype.showLongContent = function showLongContent() {
	    this.setState({ showLongContent: true });
	  };
	
	  Introduction.prototype.render = function render() {
	    var _this2 = this;
	
	    var className = this.props.className;
	    var showLongContent = this.state.showLongContent;
	
	
	    return _react2.default.createElement(
	      Article,
	      { className: className },
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          P,
	          null,
	          'Zur Gestaltung Ihres Unterrichts finden Sie hier das Unterrichtsprojekt \u201EFamilien und Flucht aus der DDR\u201C zum Download, Bildmaterialien zur Verwendung auf dem Smartboard, Quellennachweise und weiterf\xFChrende Materialien zu den Themenbereichen DDR-Geschichte, Grundrechte sowie Flucht damals und heute.'
	        ),
	        _react2.default.createElement(
	          H2Styled,
	          null,
	          'Gru\xDFwort'
	        ),
	        _react2.default.createElement(
	          P,
	          null,
	          '1989 st\xFCrzten die B\xFCrgerinnen und B\xFCrger der DDR in einer Friedlichen Revolution die SED-Herrschaft. Sie eroberten sich damit nicht nur Freiheit, demokratische Souver\xE4nit\xE4t, Menschenrechte, einen Rechtsstaat und schlie\xDFlich auch die deutsche Einheit. Die Menschen in der DDR brachten zugleich die vielen sichtbaren und unsichtbaren Mauern zu Fall, die ihr Leben in der SED-Diktatur \xFCber Jahrzehnte hinweg bestimmt hatten.'
	        ),
	        showLongContent || _react2.default.createElement(
	          ShowMoreButton,
	          { onClick: function onClick() {
	              return _this2.showLongContent();
	            } },
	          'Mehr anzeigen'
	        )
	      ),
	      _react2.default.createElement(
	        ExtendedSection,
	        { show: showLongContent },
	        _react2.default.createElement(
	          P,
	          null,
	          'In Deutschland wachsen heute die Kinder ganz selbstverst\xE4ndlich in einer Gesellschaft mit vielen Freiheiten und stabilen demokratischen Institutionen auf. Zugleich wissen sie oft nur wenig \xFCber die DDR und den Alltag hinter der Mauer. Das Leben ihrer Eltern und Gro\xDFeltern im geteilten Deutschland ist f\xFCr sie heute kaum noch vorstellbar. Das Eingesperrtsein der DDR-B\xFCrger hinter der Mauer, die staatliche Bevormundung in fast allen Bereichen des Lebens und die damit verbundenen Dem\xFCtigungen, der vielgehegte und manchmal auch verwirklichte Wunsch, aus dieser Enge in die Freiheit zu fliehen \u2013 \xFCber all dies k\xF6nnen sie heute nur noch etwas aus \u201Ezweiter Hand\u201C erfahren. Doch sie wollen und sollen mehr wissen \xFCber das Leben zwischen Alltag und Repression, Anpassung, Arrangement und Verweigerung. Denn f\xFCr unsere heutige demokratische Gesellschaft ist es ungemein wichtig, dass diese Vergangenheit nicht vergessen wird und schon die ganz jungen Sch\xFClerinnen und Sch\xFCler den elementaren Unterschied zwischen Diktatur und Demokratie verstehen lernen. Auch um zu erkl\xE4ren, warum so viele Menschen der DDR w\xE4hrend ihres 40-j\xE4hrigen Bestehens unter schwierigsten Bedingungen und teilweise unter Lebensgefahr den R\xFCcken kehrten. Dies gilt f\xFCr den Osten genauso wie f\xFCr den Westen. Hierbei helfen Bildungsmaterialien mit einer gegenwartsbezogenen Ausrichtung, die auch die Familiengeschichten der Sch\xFClerinnen und Sch\xFCler mit einbinden und den jungen Menschen Br\xFCcken aus der Vergangenheit in ihre Lebenswirklichkeit bauen. So kann Geschichtsaufarbeitung heute gut gelingen!'
	        ),
	        _react2.default.createElement(
	          IntroFooter,
	          null,
	          _react2.default.createElement(
	            Katharina,
	            null,
	            _react2.default.createElement('img', { src: _Katharina_HochmuthBfA_2.default, alt: 'Ein Bild von Katharina Hochmuth' })
	          ),
	          _react2.default.createElement(
	            Absender,
	            null,
	            _react2.default.createElement(
	              AbsenderName,
	              null,
	              'Katharina Hochmuth'
	            ),
	            _react2.default.createElement(
	              P,
	              null,
	              'Leiterin des Arbeitsbereichs Schulische Bildungsarbeit, Bundesstiftung zur Aufarbeitung der SED-Diktatur'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(StacheldrahtStyled, { small: true })
	    );
	  };
	
	  return Introduction;
	}(_react2.default.Component);
	
	Introduction.propTypes = {
	  className: _propTypes2.default.string
	};
	
	Introduction.defaultProps = {
	  className: undefined
	};
	
	exports.default = Introduction;
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  padding-bottom: 5px;\n'], ['\n  padding: 0;\n  padding-bottom: 5px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 16px;\n  line-height: 1.2;\n  list-style-type: none;\n\n  &:before {\n    content: \'\u2192\';\n    font-family: \'PT Mono\', monospace;\n    margin-right: 0.5em;\n    margin-left: 0.1em;\n\n    font-size: 24px;\n    ', ' {\n      font-size: 32px;\n    }\n  }\n\n  ', ' {\n    font-size: 22px;\n  }\n'], ['\n  font-size: 16px;\n  line-height: 1.2;\n  list-style-type: none;\n\n  &:before {\n    content: \'\\u2192\';\n    font-family: \'PT Mono\', monospace;\n    margin-right: 0.5em;\n    margin-left: 0.1em;\n\n    font-size: 24px;\n    ', ' {\n      font-size: 32px;\n    }\n  }\n\n  ', ' {\n    font-size: 22px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-top: 20px;\n  padding-bottom: 50px;\n'], ['\n  margin-top: 20px;\n  padding-bottom: 50px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 15px 20px;\n  border-radius: 3px;\n'], ['\n  padding: 15px 20px;\n  border-radius: 3px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DownloadMaterialButton = __webpack_require__(61);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _breakpoints = __webpack_require__(4);
	
	var _H = __webpack_require__(48);
	
	var _H2 = _interopRequireDefault(_H);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DESCRIPTIONS = ['Hinweise zur Nutzung', 'Einf&uuml;hrung in das Thema', 'Acht Lerneinheiten', 'Hintergrundinformationen', 'Unterrichtsimpulse', 'Arbeitsbl&auml;tter'];
	
	var UL = _styled2.default.ul(_templateObject);
	
	var LI = _styled2.default.li(_templateObject2, _breakpoints.minDesktop, _breakpoints.minDesktop);
	
	var Article = _styled2.default.article(_templateObject3);
	
	var DownloadContainer = _styled2.default.div(_templateObject4);
	
	var DownloadMaterialButtonStyled = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject5);
	
	var MaterialDescription = function MaterialDescription(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    Article,
	    { className: className },
	    _react2.default.createElement(
	      _H2.default,
	      null,
	      'Unterrichtsmaterialien f\xFCr die Grundschule, ',
	      _react2.default.createElement(
	        'nobr',
	        null,
	        '3.\u20136. Klasse'
	      ),
	      ' (PDF)'
	    ),
	    _react2.default.createElement(
	      UL,
	      null,
	      DESCRIPTIONS.map(function (text) {
	        return _react2.default.createElement(LI, { key: text, dangerouslySetInnerHTML: { __html: text } });
	      })
	    ),
	    _react2.default.createElement(
	      DownloadContainer,
	      null,
	      _react2.default.createElement(DownloadMaterialButtonStyled, { label: 'Lehrplananbindung', download: 'Lehrplananbindung.pdf', href: '/downloads/Lehrplananbindung.pdf' })
	    )
	  );
	};
	
	MaterialDescription.propTypes = {
	  className: _propTypes2.default.string
	};
	
	MaterialDescription.defaultProps = {
	  className: undefined
	};
	
	exports.default = MaterialDescription;
	module.exports = exports['default'];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AboutMaterialDownload = __webpack_require__(197);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AboutMaterialDownload).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BALogoSmallOnPhone = undefined;
	
	var _css; /* eslint-disable react/no-unused-prop-types */
	/* eslint-disable object-curly-newline */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(13);
	
	var _breakpoints = __webpack_require__(4);
	
	var _Logo = __webpack_require__(62);
	
	var _images = __webpack_require__(63);
	
	var _BundesstiftungLogo = __webpack_require__(412);
	
	var _BundesstiftungLogo2 = _interopRequireDefault(_BundesstiftungLogo);
	
	var _BundesstiftungLogo2x = __webpack_require__(413);
	
	var _BundesstiftungLogo2x2 = _interopRequireDefault(_BundesstiftungLogo2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOGO_WIDTH = 186;
	var LOGO_HEIGHT = 31;
	
	var BALogoSmallOnPhone = exports.BALogoSmallOnPhone = (0, _emotion.css)((_css = {}, _css[_breakpoints.mediaPhone] = {
	  width: (0, _Logo.px)(LOGO_WIDTH * _Logo.LOGO_PHONE_SCALE),
	  height: (0, _Logo.px)(LOGO_HEIGHT * _Logo.LOGO_PHONE_SCALE),
	  marginTop: '11px'
	}, _css));
	
	var BALogo = function BALogo(_ref) {
	  var className = _ref.className,
	      labelStyles = _ref.labelStyles,
	      imageContainerStyles = _ref.imageContainerStyles,
	      imageStyles = _ref.imageStyles;
	  return _react2.default.createElement(
	    'article',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _emotion.css)(_Logo.LogoLabelStyles, labelStyles) },
	      'Gef\xF6rdert von'
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)({
	          textAlign: 'right'
	        }, imageContainerStyles)
	      },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.bundesstiftung-aufarbeitung.de', target: '_blank', rel: 'noopener nofollow external' },
	        _react2.default.createElement('img', {
	          src: _BundesstiftungLogo2.default,
	          srcSet: _BundesstiftungLogo2.default + ' 1x, ' + _BundesstiftungLogo2x2.default + ' 2x',
	          alt: 'Bundesstiftung Aufarbeitung',
	          className: (0, _emotion.css)(_images.sharpImageRendering, {
	            width: (0, _Logo.px)(LOGO_WIDTH),
	            height: (0, _Logo.px)(LOGO_HEIGHT),
	            marginTop: '7px'
	          }, imageStyles)
	        })
	      )
	    )
	  );
	};
	
	BALogo.propTypes = {
	  className: _propTypes2.default.string,
	  labelStyles: _propTypes2.default.any,
	  imageContainerStyles: _propTypes2.default.any,
	  imageStyles: _propTypes2.default.any
	};
	
	BALogo.defaultProps = {
	  className: undefined,
	  labelStyles: undefined,
	  imageContainerStyles: undefined,
	  imageStyles: undefined
	};
	
	exports.default = BALogo;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BFBLogoSmallOnPhone = undefined;
	
	var _css; /* eslint-disable react/jsx-no-target-blank */
	/* eslint-disable object-curly-newline */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(13);
	
	var _breakpoints = __webpack_require__(4);
	
	var _Logo = __webpack_require__(62);
	
	var _images = __webpack_require__(63);
	
	var _BfBLogo = __webpack_require__(414);
	
	var _BfBLogo2 = _interopRequireDefault(_BfBLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOGO_WIDTH = 120;
	var LOGO_HEIGHT = 40;
	var LOGO_SCALE = 0.95;
	
	var BFBLogoSmallOnPhone = exports.BFBLogoSmallOnPhone = (0, _emotion.css)((_css = {}, _css[_breakpoints.mediaPhone] = {
	  width: (0, _Logo.px)(LOGO_WIDTH * LOGO_SCALE * _Logo.LOGO_PHONE_SCALE),
	  height: (0, _Logo.px)(LOGO_HEIGHT * LOGO_SCALE * _Logo.LOGO_PHONE_SCALE),
	  marginTop: '7px'
	}, _css));
	
	var BFBLogo = function BFBLogo(_ref) {
	  var className = _ref.className,
	      labelStyles = _ref.labelStyles,
	      imageContainerStyles = _ref.imageContainerStyles,
	      imageStyles = _ref.imageStyles;
	  return _react2.default.createElement(
	    'article',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _emotion.css)(_Logo.LogoLabelStyles, labelStyles) },
	      'Initiiert und umgesetzt von'
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)('\n        text-align: right;\n      ', imageContainerStyles)
	      },
	      _react2.default.createElement(
	        'a',
	        { href: 'http://www.bundfuerbildung.de', target: '_blank', rel: 'noopener nofollow external' },
	        _react2.default.createElement('img', {
	          src: _BfBLogo2.default,
	          alt: 'Bund f\xFCr Bildung',
	          className: (0, _emotion.css)(_images.sharpImageRendering, {
	            width: (0, _Logo.px)(LOGO_WIDTH * LOGO_SCALE),
	            height: (0, _Logo.px)(LOGO_HEIGHT * LOGO_SCALE),
	            marginTop: '2px'
	          }, imageStyles)
	        })
	      )
	    )
	  );
	};
	
	BFBLogo.propTypes = {
	  className: _propTypes2.default.string,
	  labelStyles: _propTypes2.default.any,
	  imageContainerStyles: _propTypes2.default.any,
	  imageStyles: _propTypes2.default.any
	};
	
	BFBLogo.defaultProps = {
	  className: undefined,
	  labelStyles: undefined,
	  imageContainerStyles: undefined,
	  imageStyles: undefined
	};
	
	exports.default = BFBLogo;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  font-family: \'PT Mono\', monospace;\n  font-weight: bold;\n  font-size: 16px;\n\n  text-decoration: none;\n  cursor: pointer;\n\n  line-height: 1.2;\n\n  background-color: ', ';\n  color: ', ';\n\n  &:hover, &:visited {\n    color: ', ';\n    text-decoration: none;\n    background-color: ', ';\n  }\n'], ['\n  display: inline-block;\n  font-family: \'PT Mono\', monospace;\n  font-weight: bold;\n  font-size: 16px;\n\n  text-decoration: none;\n  cursor: pointer;\n\n  line-height: 1.2;\n\n  background-color: ', ';\n  color: ', ';\n\n  &:hover, &:visited {\n    color: ', ';\n    text-decoration: none;\n    background-color: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-right: 1rem;\n'], ['\n  margin-right: 1rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _DownloadPdf = __webpack_require__(81);
	
	var _DownloadPdf2 = _interopRequireDefault(_DownloadPdf);
	
	var _colors = __webpack_require__(8);
	
	var _IconDownload = __webpack_require__(415);
	
	var _IconDownload2 = _interopRequireDefault(_IconDownload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DEFAULT_LABEL = 'Material herunterladen';
	
	var A = (0, _styled2.default)(_DownloadPdf2.default)(_templateObject, _colors.PrimaryColor, _colors.White, _colors.White, _colors.PrimaryDarkColor);
	
	var IconImg = _styled2.default.img(_templateObject2);
	
	var renderIcon = function renderIcon(noicon, label) {
	  return noicon ? null : _react2.default.createElement(IconImg, { width: '25', height: '22', src: _IconDownload2.default, alt: label });
	};
	
	var renderLabel = function renderLabel(nolabel, label) {
	  return nolabel ? null : _react2.default.createElement(
	    'span',
	    null,
	    label
	  );
	};
	
	var DownloadMaterialButton = function DownloadMaterialButton(_ref) {
	  var className = _ref.className,
	      download = _ref.download,
	      href = _ref.href,
	      label = _ref.label,
	      noicon = _ref.noicon,
	      nolabel = _ref.nolabel;
	  return _react2.default.createElement(
	    A,
	    { href: href, download: download, className: className },
	    renderIcon(noicon, label),
	    renderLabel(nolabel, label)
	  );
	};
	
	DownloadMaterialButton.propTypes = {
	  nolabel: _propTypes2.default.bool,
	  noicon: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  download: _propTypes2.default.string
	};
	
	DownloadMaterialButton.defaultProps = {
	  nolabel: false,
	  noicon: false,
	  label: DEFAULT_LABEL,
	  className: undefined,
	  href: undefined,
	  download: undefined
	};
	
	exports.default = DownloadMaterialButton;
	module.exports = exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n'], ['\n  cursor: pointer;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable object-curly-newline */
	
	
	var Link = _styled2.default.a(_templateObject);
	
	var DownloadPdf = function DownloadPdf(_ref) {
	  var className = _ref.className,
	      href = _ref.href,
	      download = _ref.download,
	      children = _ref.children;
	  return _react2.default.createElement(
	    Link,
	    { className: className, href: href, download: download },
	    children
	  );
	};
	
	DownloadPdf.propTypes = {
	  href: _propTypes2.default.string,
	  download: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.any.isRequired
	};
	
	DownloadPdf.defaultProps = {
	  href: '/downloads/Familien_und_Flucht_aus_der_DDR.pdf',
	  download: 'Familien und Flucht aus der DDR.pdf',
	  className: undefined
	};
	
	exports.default = DownloadPdf;
	module.exports = exports['default'];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  width: ', 'px;\n  height: ', 'px;\n\n  cursor: pointer;\n'], ['\n  position: relative;\n\n  width: ', 'px;\n  height: ', 'px;\n\n  cursor: pointer;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n\n  transition: all .25s;\n\n  height: ', 'px;\n\n  background-color: ', ';\n'], ['\n  position: absolute;\n\n  transition: all .25s;\n\n  height: ', 'px;\n\n  background-color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  top: 7px;\n  left: -2px;\n  transform: rotate(45deg);\n'], ['\n  width: ', ';\n  top: 7px;\n  left: -2px;\n  transform: rotate(45deg);\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  top: 13px;\n  left: -5px;\n  transform: rotate(225deg); // -135deg); // 225deg);\n'], ['\n  width: ', ';\n  top: 13px;\n  left: -5px;\n  transform: rotate(225deg); // -135deg); // 225deg);\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  top: 7px;\n  right: -2px;\n  transform: rotate(-45deg);\n'], ['\n  width: ', ';\n  top: 7px;\n  right: -2px;\n  transform: rotate(-45deg);\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  top: 13px;\n  right: -5px;\n  transform: rotate(135deg); // -225deg);\n'], ['\n  width: ', ';\n  top: 13px;\n  right: -5px;\n  transform: rotate(135deg); // -225deg);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _emotion = __webpack_require__(13);
	
	var _colors = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SIZE = 32;
	var LINE_SIZE = 3;
	
	var px = function px(pixels) {
	  return Math.round(pixels) + 'px';
	};
	
	var Container = _styled2.default.div(_templateObject, SIZE, SIZE);
	
	var LineStyles = (0, _emotion.css)(_templateObject2, LINE_SIZE, _colors.PrimaryColor);
	
	var AStyles = (0, _emotion.css)(_templateObject3, px(SIZE * 0.7));
	
	var ACloseStyles = (0, _emotion.css)(_templateObject4, px(SIZE * 1.3125));
	
	var BStyles = (0, _emotion.css)(_templateObject5, px(SIZE * 0.7));
	
	var BCloseStyles = (0, _emotion.css)(_templateObject6, px(SIZE * 1.3125));
	
	var Collapsor = function Collapsor(_ref) {
	  var open = _ref.open,
	      className = _ref.className,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    Container,
	    { className: className, onClick: onClick },
	    _react2.default.createElement('div', { className: LineStyles + ' ' + AStyles + ' ' + (open ? ACloseStyles : '') }),
	    _react2.default.createElement('div', { className: LineStyles + ' ' + BStyles + ' ' + (open ? BCloseStyles : '') })
	  );
	};
	
	Collapsor.propTypes = {
	  open: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	Collapsor.defaultProps = {
	  open: false,
	  className: undefined,
	  onClick: undefined
	};
	
	exports.default = Collapsor;
	module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: ', 'px;\n  margin-right: ', 'px;\n\n  ', ' {\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n  }\n  ', ' {\n    margin-left: 80px;\n    margin-right: 80px;\n  }\n'], ['\n  margin-left: ', 'px;\n  margin-right: ', 'px;\n\n  ', ' {\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n  }\n  ', ' {\n    margin-left: 80px;\n    margin-right: 80px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 13px;\n  padding: 0;\n'], ['\n  margin-top: 13px;\n  padding: 0;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  border-bottom: 1px solid ', ';\n\n  &:last-child {\n    ', ' {\n      border-bottom: 0;\n    }\n  }\n'], ['\n  border-bottom: 1px solid ', ';\n\n  &:last-child {\n    ', ' {\n      border-bottom: 0;\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    margin-left: 25px;\n    margin-right: 25px;\n    margin-bottom: 20px;\n  }\n  ', ' {\n    margin-bottom: 40px;\n  }\n  ', ' {\n    margin-bottom: 50px;\n  }\n'], ['\n  ', ' {\n    margin-left: 25px;\n    margin-right: 25px;\n    margin-bottom: 20px;\n  }\n  ', ' {\n    margin-bottom: 40px;\n  }\n  ', ' {\n    margin-bottom: 50px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	var _pageLayout = __webpack_require__(83);
	
	var _H = __webpack_require__(48);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _ExternalLinksSection = __webpack_require__(208);
	
	var _ExternalLinksSection2 = _interopRequireDefault(_ExternalLinksSection);
	
	var _ExternalLinksShape = __webpack_require__(128);
	
	var _ExternalLinksShape2 = _interopRequireDefault(_ExternalLinksShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.div(_templateObject, -_pageLayout.PHONE_MARGIN, -_pageLayout.PHONE_MARGIN, _breakpoints.minTablet, -_pageLayout.TABLET_MARGIN + 40, -_pageLayout.TABLET_MARGIN + 40, _breakpoints.minDesktop);
	
	var SectionsList = _styled2.default.ul(_templateObject2);
	
	var ExternalLinksSectionStyled = (0, _styled2.default)(_ExternalLinksSection2.default)(_templateObject3, _colors.PrimaryColor, _breakpoints.minDesktop);
	
	var Headline = (0, _styled2.default)(_H2.default)(_templateObject4, _breakpoints.mediaPhone, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var ExternalLinksCollection = function ExternalLinksCollection(_ref) {
	  var headline = _ref.headline,
	      sources = _ref.sources,
	      showIds = _ref.showIds;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      Headline,
	      null,
	      headline
	    ),
	    _react2.default.createElement(
	      SectionsList,
	      null,
	      sources.map(function (_ref2) {
	        var id = _ref2.id,
	            title = _ref2.title,
	            items = _ref2.items;
	        return _react2.default.createElement(ExternalLinksSectionStyled, {
	          key: id || title,
	          id: id,
	          headline: title,
	          showId: showIds,
	          sources: items
	        });
	      })
	    )
	  );
	};
	
	ExternalLinksCollection.propTypes = {
	  headline: _propTypes2.default.string.isRequired,
	  sources: _ExternalLinksShape2.default.isRequired,
	  showIds: _propTypes2.default.bool
	};
	
	ExternalLinksCollection.defaultProps = {
	  showIds: false
	};
	
	exports.default = ExternalLinksCollection;
	module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  list-style-type: none;\n  min-height: ', ';\n\n  ', ' {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n  ', ' {\n    padding-left: 20px;\n  }\n'], ['\n  list-style-type: none;\n  min-height: ', ';\n\n  ', ' {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n  ', ' {\n    padding-left: 20px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding-bottom: 25px;\n\n  ', ' {\n    padding-bottom: 35px;\n  }\n'], ['\n  padding-bottom: 25px;\n\n  ', ' {\n    padding-bottom: 35px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  margin-top: 10px;\n\n  ', ' {\n    margin-top: 20px;\n  }\n\n  ', ' {\n    margin-top: 25px;\n  }\n\n  ', '\n'], ['\n  position: relative;\n\n  margin-top: 10px;\n\n  ', ' {\n    margin-top: 20px;\n  }\n\n  ', ' {\n    margin-top: 25px;\n  }\n\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  ', ' {\n    margin-bottom: 2px;\n  }\n'], ['\n  ', ';\n\n  ', ' {\n    margin-bottom: 2px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding-left: 80px;\n\n  ', ' {\n    padding-left: 65px;\n  }\n'], ['\n  padding-left: 80px;\n\n  ', ' {\n    padding-left: 65px;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  padding-left: 0;\n\n  ', ' {\n    padding-left: 55px;\n  }\n'], ['\n  padding-left: 0;\n\n  ', ' {\n    padding-left: 55px;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  line-height: 1.3;\n\n  padding-top: 6px;\n\n  color: ', ';\n\n  cursor: pointer;\n  &:hover {\n    color: ', ';\n    @media (hover: none) {\n      color: ', ';\n    }\n  }\n\n  ', ' {\n    padding-top: 7px;\n    padding-right: 60px;\n  }\n\n  ', '\n'], ['\n  ', ';\n\n  line-height: 1.3;\n\n  padding-top: 6px;\n\n  color: ', ';\n\n  cursor: pointer;\n  &:hover {\n    color: ', ';\n    @media (hover: none) {\n      color: ', ';\n    }\n  }\n\n  ', ' {\n    padding-top: 7px;\n    padding-right: 60px;\n  }\n\n  ', '\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  padding: 40px 0 40px 65px;\n  ', ' {\n    padding: 40px 20px 40px 80px;\n  }\n  ', ' {\n    padding: 40px 40px 40px 80px;\n  }\n'], ['\n  padding: 40px 0 40px 65px;\n  ', ' {\n    padding: 40px 20px 40px 80px;\n  }\n  ', ' {\n    padding: 40px 40px 40px 80px;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  padding: 40px 0 40px 0;\n  ', ' {\n    padding: 40px 20px 40px 0;\n  }\n  ', ' {\n    padding: 40px 40px 40px 0;\n  }\n'], ['\n  padding: 40px 0 40px 0;\n  ', ' {\n    padding: 40px 20px 40px 0;\n  }\n  ', ' {\n    padding: 40px 40px 40px 0;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  display: none;\n'], ['\n  display: none;\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n'], ['\n']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n  from {\n    transform: translate3d(0,10px,0);\n  }\n\n  to {\n    transform: translate3d(0,0,0);\n  }\n'], ['\n  from {\n    transform: translate3d(0,10px,0);\n  }\n\n  to {\n    transform: translate3d(0,0,0);\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(1.1);\n  }\n'], ['\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(1.1);\n  }\n']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n  *:hover > & {\n    animation: ', ' .4s alternate infinite;\n    @media (hover: none) {\n      animation: none;\n    }\n  }\n'], ['\n  *:hover > & {\n    animation: ', ' .4s alternate infinite;\n    @media (hover: none) {\n      animation: none;\n    }\n  }\n']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  display: none;\n  ', ' {\n    display: block;\n  }\n  margin-top: ', '; \n'], ['\n  ', ';\n\n  display: none;\n  ', ' {\n    display: block;\n  }\n  margin-top: ', '; \n']),
	    _templateObject18 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  position: absolute;\n  top: 10px;\n  right: 25px;\n  ', ' {\n    right: 35px;\n  }\n  ', ' {\n    display: none;\n  }\n'], ['\n  ', ';\n\n  position: absolute;\n  top: 10px;\n  right: 25px;\n  ', ' {\n    right: 35px;\n  }\n  ', ' {\n    display: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _core = __webpack_require__(10);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	var _ExternalSourceShape = __webpack_require__(129);
	
	var _ExternalSourceShape2 = _interopRequireDefault(_ExternalSourceShape);
	
	var _ExternalSource = __webpack_require__(209);
	
	var _ExternalSource2 = _interopRequireDefault(_ExternalSource);
	
	var _Collapsor = __webpack_require__(206);
	
	var _Collapsor2 = _interopRequireDefault(_Collapsor);
	
	var _styles = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable object-curly-newline */
	
	
	var Container = _styled2.default.li(_templateObject, function (_ref) {
	  var showId = _ref.showId;
	  return showId ? '68px' : '55px';
	}, _breakpoints.mediaPhone, _breakpoints.minTablet);
	
	var HeaderWithCollapsedSection = (0, _core.css)(_templateObject2, _breakpoints.minDesktop);
	
	var Header = _styled2.default.div(_templateObject3, _breakpoints.minTablet, _breakpoints.minDesktop, function (_ref2) {
	  var open = _ref2.open;
	  return !open && HeaderWithCollapsedSection;
	});
	
	var HeaderStart = _styled2.default.div(_templateObject4);
	
	var SectionId = _styled2.default.div(_templateObject5, _styles.SectionIdFontStyles, _breakpoints.mediaPhone);
	
	var HeadlineWithIdStyles = (0, _core.css)(_templateObject6, _breakpoints.mediaPhone);
	
	var HeadlineWithoutIdStyles = (0, _core.css)(_templateObject7, _breakpoints.mediaPhone);
	
	var Headline = _styled2.default.div(_templateObject8, _styles.SectionHeadlineFontStyles, function (_ref3) {
	  var open = _ref3.open;
	  return open ? _colors.PrimaryColor : _colors.TextColor;
	}, _colors.PrimaryColor, function (_ref4) {
	  var open = _ref4.open;
	  return open ? _colors.PrimaryColor : _colors.TextColor;
	}, _breakpoints.minTablet, function (_ref5) {
	  var showId = _ref5.showId;
	  return showId ? HeadlineWithIdStyles : HeadlineWithoutIdStyles;
	});
	
	var SourcesWithIdStyles = (0, _core.css)(_templateObject9, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var SourcesWithoutIdStyles = (0, _core.css)(_templateObject10, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var SourcesCollapsed = (0, _core.css)(_templateObject11);
	
	var SourcesOpened = (0, _core.css)(_templateObject12);
	
	var Sources = _styled2.default.ul(_templateObject13, function (_ref6) {
	  var showId = _ref6.showId;
	  return showId ? SourcesWithIdStyles : SourcesWithoutIdStyles;
	}, function (_ref7) {
	  var open = _ref7.open;
	  return open ? SourcesOpened : SourcesCollapsed;
	});
	
	var BounceAnimation = (0, _core.keyframes)(_templateObject14);
	
	var ZoomAnimation = (0, _core.keyframes)(_templateObject15);
	
	var BounceStyles = (0, _core.css)(_templateObject16, BounceAnimation);
	
	var ZoomStyles = (0, _core.css)(_templateObject16, ZoomAnimation);
	
	var CollapsorPhone = (0, _styled2.default)(_Collapsor2.default)(_templateObject17, function (_ref8) {
	  var open = _ref8.open;
	  return open ? ZoomStyles : BounceStyles;
	}, _breakpoints.mediaPhone, function (_ref9) {
	  var showId = _ref9.showId;
	  return showId ? '0' : '10px';
	});
	
	var CollapsorRight = (0, _styled2.default)(_Collapsor2.default)(_templateObject18, function (_ref10) {
	  var open = _ref10.open;
	  return open ? ZoomStyles : BounceStyles;
	}, _breakpoints.minDesktop, _breakpoints.mediaPhone);
	
	var ExternalLinksSection = function (_React$Component) {
	  _inherits(ExternalLinksSection, _React$Component);
	
	  function ExternalLinksSection() {
	    _classCallCheck(this, ExternalLinksSection);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  ExternalLinksSection.prototype.toggleCollapse = function toggleCollapse() {
	    this.setState(function (state) {
	      return { isOpen: !state.isOpen };
	    });
	  };
	
	  ExternalLinksSection.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        id = _props.id,
	        headline = _props.headline,
	        sources = _props.sources,
	        showId = _props.showId,
	        className = _props.className;
	    var isOpen = this.state.isOpen;
	
	    return _react2.default.createElement(
	      Container,
	      { className: className, showId: showId },
	      _react2.default.createElement(
	        Header,
	        { open: isOpen },
	        _react2.default.createElement(
	          HeaderStart,
	          null,
	          showId && _react2.default.createElement(
	            SectionId,
	            null,
	            id
	          ),
	          _react2.default.createElement(CollapsorPhone, { onClick: function onClick() {
	              return _this2.toggleCollapse();
	            }, showId: showId, open: isOpen })
	        ),
	        _react2.default.createElement(Headline, { showId: showId, open: isOpen, onClick: function onClick() {
	            return _this2.toggleCollapse();
	          }, dangerouslySetInnerHTML: { __html: headline } }),
	        _react2.default.createElement(CollapsorRight, { onClick: function onClick() {
	            return _this2.toggleCollapse();
	          }, open: isOpen })
	      ),
	      _react2.default.createElement(
	        Sources,
	        { showId: showId, open: isOpen },
	        sources.map(function (_ref11) {
	          var type = _ref11.type,
	              body = _ref11.body,
	              url = _ref11.url,
	              download = _ref11.download;
	          return _react2.default.createElement(_ExternalSource2.default, { key: body, type: type, body: body, url: url, download: download });
	        })
	      )
	    );
	  };
	
	  return ExternalLinksSection;
	}(_react2.default.Component);
	
	ExternalLinksSection.propTypes = {
	  id: _propTypes2.default.string,
	  headline: _propTypes2.default.string.isRequired,
	  sources: _propTypes2.default.arrayOf(_ExternalSourceShape2.default).isRequired,
	  showId: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	ExternalLinksSection.defaultProps = {
	  id: undefined,
	  showId: false,
	  className: undefined
	};
	
	exports.default = ExternalLinksSection;
	module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin-bottom: 15px;\n  list-style-type: none;\n'], ['\n  position: relative;\n  margin-bottom: 15px;\n  list-style-type: none;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 32px;\n  height: 32px;\n\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 32px;\n  height: 32px;\n\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    background-image: url(', ');\n  '], ['\n    background-image: url(', ');\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  padding-left: ', ';\n'], ['\n  ', ';\n\n  padding-left: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding: 0;\n'], ['\n  padding: 0;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  list-style-type: none;\n  padding-left: 55px;\n\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  a, a:hover, a:visited {\n    ', ';\n  }\n'], ['\n  list-style-type: none;\n  padding-left: 55px;\n\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  a, a:hover, a:visited {\n    ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _emotion = __webpack_require__(13);
	
	var _styles = __webpack_require__(131);
	
	var _colors = __webpack_require__(8);
	
	var _outlineLaunch24px = __webpack_require__(417);
	
	var _outlineLaunch24px2 = _interopRequireDefault(_outlineLaunch24px);
	
	var _outlineImage24px = __webpack_require__(416);
	
	var _outlineImage24px2 = _interopRequireDefault(_outlineImage24px);
	
	var _outlineMovie24px = __webpack_require__(418);
	
	var _outlineMovie24px2 = _interopRequireDefault(_outlineMovie24px);
	
	var _outlinePicture_as_pdf24px = __webpack_require__(419);
	
	var _outlinePicture_as_pdf24px2 = _interopRequireDefault(_outlinePicture_as_pdf24px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable react/prop-types */
	/* eslint-disable object-curly-newline */
	
	
	var Container = _styled2.default.li(_templateObject);
	
	var TypeStyles = (0, _emotion.css)(_templateObject2);
	
	var TypeExtStyles = {
	  pdf: (0, _emotion.css)(_templateObject3, _outlinePicture_as_pdf24px2.default),
	  image: (0, _emotion.css)(_templateObject3, _outlineImage24px2.default),
	  video: (0, _emotion.css)(_templateObject3, _outlineMovie24px2.default),
	  link: (0, _emotion.css)(_templateObject3, _outlineLaunch24px2.default),
	  notype: (0, _emotion.css)(_templateObject4)
	};
	
	var Body = _styled2.default.div(_templateObject5, _styles.TextFontStyles, function (_ref) {
	  var type = _ref.type;
	  return type === 'notype' ? '0' : '55px';
	});
	
	var LinkList = _styled2.default.ul(_templateObject6);
	
	var LinkItem = _styled2.default.li(_templateObject7, _styles.TextFontStyles);
	
	var LINK_TARGET = '_blank';
	var LINK_REL = 'noopener noreferrer';
	
	var Link = function Link(_ref2) {
	  var href = _ref2.href,
	      download = _ref2.download;
	  return _react2.default.createElement(
	    LinkItem,
	    null,
	    download ? _react2.default.createElement(
	      'a',
	      { href: href, download: download },
	      download
	    ) : _react2.default.createElement(
	      'a',
	      { href: href, target: LINK_TARGET, rel: href && href[0] === '/' ? undefined : LINK_REL },
	      href && href.replace(/^\/[^/]+\//g, '')
	    )
	  );
	};
	
	var parseAutoLinks = function parseAutoLinks(text) {
	  return text.replace(/(https?:\/\/[^ ]*[^ ,.])/g, '<a href="$1" style="color:' + _colors.TextColor + '" target="' + LINK_TARGET + '" rel="' + LINK_REL + '">$1</a>');
	};
	
	var Urls = function Urls(_ref3) {
	  var url = _ref3.url,
	      download = _ref3.download;
	  return Array.isArray(url) ? _react2.default.createElement(
	    LinkList,
	    null,
	    url.map(function (href) {
	      return _react2.default.createElement(Link, { key: href, href: href });
	    })
	  ) : _react2.default.createElement(
	    LinkList,
	    null,
	    _react2.default.createElement(Link, { href: url, download: download })
	  );
	};
	
	var ExternalSource = function ExternalSource(_ref4) {
	  var type = _ref4.type,
	      body = _ref4.body,
	      url = _ref4.url,
	      download = _ref4.download;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement('div', { className: (0, _emotion.css)([TypeStyles, TypeExtStyles[type]]) }),
	    _react2.default.createElement(Body, { type: type, dangerouslySetInnerHTML: { __html: parseAutoLinks(body) } }),
	    _react2.default.createElement(Urls, { url: url, download: download })
	  );
	};
	
	ExternalSource.propTypes = {
	  type: _propTypes2.default.oneOf(['link', 'pdf', 'image', 'video', 'notype']),
	  body: _propTypes2.default.string.isRequired,
	  download: _propTypes2.default.string,
	  url: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
	};
	
	ExternalSource.defaultProps = {
	  type: 'notype',
	  url: undefined,
	  download: undefined
	};
	
	exports.default = ExternalSource;
	module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n'], ['\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  text-align: center;\n  padding: 0 10px;\n  border-bottom: 2px solid #fff;\n\n  height: 170px;\n\n  ', ' {\n    height: 120px;\n    padding: 0 15px;\n  }\n'], ['\n  overflow: hidden;\n  text-align: center;\n  padding: 0 10px;\n  border-bottom: 2px solid #fff;\n\n  height: 170px;\n\n  ', ' {\n    height: 120px;\n    padding: 0 15px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', '\n  max-width: 100%;\n'], ['\n  ', '\n  max-width: 100%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(13);
	
	var _breakpoints = __webpack_require__(4);
	
	var _images = __webpack_require__(63);
	
	var _Grafik_PDFDownload = __webpack_require__(420);
	
	var _Grafik_PDFDownload2 = _interopRequireDefault(_Grafik_PDFDownload);
	
	var _Grafik_PDFDownload2x = __webpack_require__(421);
	
	var _Grafik_PDFDownload2x2 = _interopRequireDefault(_Grafik_PDFDownload2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.div(_templateObject);
	
	var ContainerInsideCTA = (0, _emotion.css)(_templateObject2, _breakpoints.mediaTablet);
	
	var Img = _styled2.default.img(_templateObject3, _images.sharpImageRendering);
	
	var GrafikPDFDownload = function GrafikPDFDownload(_ref) {
	  var insideCTA = _ref.insideCTA;
	  return _react2.default.createElement(
	    Container,
	    { className: insideCTA ? ContainerInsideCTA : '' },
	    _react2.default.createElement(Img, {
	      src: _Grafik_PDFDownload2.default,
	      srcSet: _Grafik_PDFDownload2.default + ' 1x, ' + _Grafik_PDFDownload2x2.default + ' 2x',
	      alt: 'Grafik PDF Download'
	    })
	  );
	};
	
	GrafikPDFDownload.propTypes = {
	  insideCTA: _propTypes2.default.bool
	};
	
	GrafikPDFDownload.defaultProps = {
	  insideCTA: false
	};
	
	exports.default = GrafikPDFDownload;
	module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: \'Zilla Slab\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 58px;\n\n  line-height: 1;\n\n  ', ' {\n    font-size: 37px;\n  }\n'], ['\n  font-family: \'Zilla Slab\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 58px;\n\n  line-height: 1;\n\n  ', ' {\n    font-size: 37px;\n  }\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styled2.default.h1(_templateObject, _breakpoints.mediaTablet);
	module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _H = __webpack_require__(211);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_H).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: \'Zilla Slab\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 26px;\n\n  line-height: 1;\n\n  ', ' {\n    font-size: 32px;\n  }\n'], ['\n  font-family: \'Zilla Slab\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 26px;\n\n  line-height: 1;\n\n  ', ' {\n    font-size: 32px;\n  }\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styled2.default.h2(_templateObject, _breakpoints.minDesktop);
	module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: ', ';\n\n  margin-left: 20px;\n  margin-right: 20px;\n\n  ', ' {\n    width: 645px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n'], ['\n  display: ', ';\n\n  margin-left: 20px;\n  margin-right: 20px;\n\n  ', ' {\n    width: 645px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: inherit;\n  font-weight: bold;\n  color: ', ';\n'], ['\n  font-size: inherit;\n  font-weight: bold;\n  color: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  border: none;\n  height: 1px;\n  color: ', ';\n  background-color: ', ';\n  margin: 2.5em 0;\n'], ['\n  border: none;\n  height: 1px;\n  color: ', ';\n  background-color: ', ';\n  margin: 2.5em 0;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  line-height: 3;\n\n  text-align: right;\n\n  ', ' {\n    font-size: 12px;\n  }\n'], ['\n  line-height: 3;\n\n  text-align: right;\n\n  ', ' {\n    font-size: 12px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-size: 15px;\n  ', ' {\n    font-size: 12px;\n  }\n  margin-bottom: 30px;\n'], ['\n  font-size: 15px;\n  ', ' {\n    font-size: 12px;\n  }\n  margin-bottom: 30px;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  font-size: 13px;\n  ', ' {\n    font-size: 12px;\n  }\n'], ['\n  font-size: 13px;\n  ', ' {\n    font-size: 12px;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  -webkit-appearance: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n  }\n'], ['\n  -webkit-appearance: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 0;\n'], ['\n  margin-bottom: 0;\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  text-decoration: none;\n  color: ', ' !important;\n\n  padding-right: 1.2em;\n\n  background-size: 1em 1em;\n  background-repeat: no-repeat;\n  background-position: right;\n  background-image: url(', ');\n'], ['\n  cursor: pointer;\n  text-decoration: none;\n  color: ', ' !important;\n\n  padding-right: 1.2em;\n\n  background-size: 1em 1em;\n  background-repeat: no-repeat;\n  background-position: right;\n  background-image: url(', ');\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _core = __webpack_require__(10);
	
	var _PageLayout = __webpack_require__(133);
	
	var _PageLayout2 = _interopRequireDefault(_PageLayout);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	var _fonts = __webpack_require__(82);
	
	var _outlineHighlight_off24px = __webpack_require__(422);
	
	var _outlineHighlight_off24px2 = _interopRequireDefault(_outlineHighlight_off24px);
	
	var _outlineLaunch24px = __webpack_require__(423);
	
	var _outlineLaunch24px2 = _interopRequireDefault(_outlineLaunch24px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-env browser */
	
	
	var Section = _styled2.default.section(_templateObject, _colors.TextGray);
	
	var InnerContent = _styled2.default.div(_templateObject2, function (_ref) {
	  var isOpen = _ref.isOpen;
	  return isOpen ? 'block' : 'none';
	}, _breakpoints.minTablet);
	
	var H4 = _styled2.default.h4(_templateObject3, _colors.TextGray);
	
	var Hr = _styled2.default.hr(_templateObject4, _colors.TextGray, _colors.TextGray);
	
	var ImpressumHeader = _styled2.default.div(_templateObject5, _breakpoints.mediaPhone);
	
	var ArticleImpressum = _styled2.default.article(_templateObject6, _breakpoints.mediaPhone);
	
	var Haftungsausschluss = _styled2.default.div(_templateObject7, _breakpoints.mediaPhone);
	
	var ResetButtonStyles = (0, _core.css)(_templateObject8);
	
	var Button = _styled2.default.button([ResetButtonStyles, '\n\n  font-size: 15px;\n  ' + _breakpoints.mediaPhone + ' {\n    font-size: 12px;\n  }\n\n  color: ' + _colors.TextGray + ';\n']);
	
	var CloseImpressumButton = _styled2.default.button([ResetButtonStyles, _fonts.PTMono, '\n  font-size: 15px;\n  ' + _breakpoints.mediaPhone + ' {\n    font-size: 12px;\n  }\n\n  color: #000;\n\n  opacity: .5;\n  &:hover {\n    opacity: .9;\n  }\n\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 30px;\n  line-height: 24px;\n\n  background-size: 24px 24px;\n  background-repeat: no-repeat;\n  background-position: left;\n  background-image: url(' + _outlineHighlight_off24px2.default + ');\n']);
	
	var H4Styled = (0, _styled2.default)(H4)(_templateObject9);
	
	var ExternalLink = _styled2.default.a(_templateObject10, _colors.TextGray, _outlineLaunch24px2.default);
	
	var Impressum = function (_React$Component) {
	  _inherits(Impressum, _React$Component);
	
	  function Impressum() {
	    _classCallCheck(this, Impressum);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  Impressum.prototype.showImpressum = function showImpressum() {
	    this.setState({ isOpen: true });
	    setTimeout(function () {
	      document.getElementById('impressum').scrollIntoView();
	    }, 50);
	  };
	
	  Impressum.prototype.closeImpressum = function closeImpressum() {
	    this.setState({ isOpen: false });
	  };
	
	  Impressum.prototype.render = function render() {
	    var _this2 = this;
	
	    var isOpen = this.state.isOpen;
	
	
	    return _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        _PageLayout2.default,
	        null,
	        _react2.default.createElement(
	          ImpressumHeader,
	          null,
	          _react2.default.createElement(
	            Button,
	            { onClick: function onClick() {
	                return _this2.showImpressum();
	              } },
	            'Impressum, Kontakt und Haftungsausschluss'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'http://www.bundfuerbildung.de', target: '_blank', rel: 'noopener nofollow external' },
	              '\xA9 Bund f\xFCr Bildung e. V.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        InnerContent,
	        { isOpen: isOpen },
	        _react2.default.createElement(
	          ArticleImpressum,
	          { id: 'impressum' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Inhaltlich Verantwortlicher gem\xE4\xDF \xA7 10 Absatz 3 MDStV',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'http://www.bundfuerbildung.de', target: '_blank', rel: 'noopener nofollow external' },
	              'Bund f\xFCr Bildung e. V.'
	            ),
	            _react2.default.createElement('br', null),
	            'Alle Rechte Vorbehalten'
	          ),
	          _react2.default.createElement(
	            H4Styled,
	            null,
	            'Verantwortlich f\xFCr die Erstellung der Unterrichtsmaterialien und der Website:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Konzept und Redaktion: Dr. Ulrike Wunderle, Claudia Wegener',
	            _react2.default.createElement('br', null),
	            'Fachberater: Prof. Dr. Eckhard Jesse, Prof. Dr. Christoph Kle\xDFmann, Thomas Knoll, Martina Feindt, Falko Stolp',
	            _react2.default.createElement('br', null),
	            'Grafische Umsetzung: Kira Freese (Unterrichtsmaterialien), Stefan Hoch (Illustrationen) und Melanie Sch\xF6llhammer (Website)',
	            _react2.default.createElement('br', null),
	            'Programmierung und Hosting: ',
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'https://www.spearwolf.de', target: '_blank', rel: 'noopener nofollow external' },
	              'Wolfger Schramm (spearwolf)'
	            )
	          ),
	          _react2.default.createElement(Hr, null),
	          _react2.default.createElement(
	            Haftungsausschluss,
	            null,
	            _react2.default.createElement(
	              H4,
	              null,
	              'Haftungsausschluss'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '1. Inhalt des Onlineangebotes: Der Autor \xFCbernimmt keinerlei Gew\xE4hr f\xFCr die Aktualit\xE4t, Korrektheit, Vollst\xE4ndigkeit oder Qualit\xE4t der bereitgestellten Informationen. Haftungsanspr\xFCche gegen den Autor, welche sich auf Sch\xE4den materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollst\xE4ndiger Informationen verursacht wurden, sind grunds\xE4tzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vors\xE4tzliches oder grob fahrl\xE4ssiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor beh\xE4lt es sich ausdr\xFCcklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ank\xFCndigung zu ver\xE4ndern, zu erg\xE4nzen, zu l\xF6schen oder die Ver\xF6ffentlichung zeitweise oder endg\xFCltig einzustellen.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '2. Verweise und Links: Bei direkten oder indirekten Verweisen auf fremde Webseiten (\u201EHyperlinks\u201C), die au\xDFerhalb des Verantwortungsbereiches des Autors liegen, w\xFCrde eine Haftungsverpflichtung ausschlie\xDFlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch m\xF6glich und zumutbar w\xE4re, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Autor erkl\xE4rt hiermit ausdr\xFCcklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zuk\xFCnftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verkn\xFCpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdr\xFCcklich von allen Inhalten aller verlinkten /verkn\xFCpften Seiten, die nach der Linksetzung ver\xE4ndert wurden. Diese Feststellung gilt f\xFCr alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie f\xFCr Fremdeintr\xE4ge in vom Autor eingerichteten G\xE4steb\xFCchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen anderen Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe m\xF6glich sind. F\xFCr illegale, fehlerhafte oder unvollst\xE4ndige Inhalte und insbesondere f\xFCr Sch\xE4den, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der \xFCber Links auf die jeweilige Ver\xF6ffentlichung lediglich verweist.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '3. Urheber und Kennzeichenrecht: Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zur\xFCckzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte gesch\xFCtzten Marken- und Warenzeichen unterliegen uneingeschr\xE4nkt den Bestimmungen des jeweils g\xFCltigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigent\xFCmer. Allein aufgrund der blo\xDFen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter gesch\xFCtzt sind! Das Copyright f\xFCr ver\xF6ffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielf\xE4ltigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdr\xFCckliche Zustimmung des Autors nicht gestattet.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '4. Datenschutz: Sofern innerhalb des Internetangebotes die M\xF6glichkeit zur Eingabe pers\xF6nlicher oder gesch\xE4ftlicher Daten (Emailadressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf ausdr\xFCcklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist \u2013 soweit technisch m\xF6glich und zumutbar \u2013 auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben ver\xF6ffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie Emailadressen durch Dritte zur \xDCbersendung von nicht ausdr\xFCcklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails bei Verst\xF6ssen gegen dieses Verbot sind ausdr\xFCcklich vorbehalten.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '5. Rechtswirksamkeit dieses Haftungsausschlusses: Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollst\xE4ndig entsprechen sollten, bleiben die \xFCbrigen Teile des Dokumentes in ihrem Inhalt und ihrer G\xFCltigkeit davon unber\xFChrt.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          CloseImpressumButton,
	          { onClick: function onClick() {
	              return _this2.closeImpressum();
	            } },
	          'Verbergen'
	        )
	      )
	    );
	  };
	
	  return Impressum;
	}(_react2.default.Component);
	
	exports.default = Impressum;
	module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Impressum = __webpack_require__(214);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Impressum).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: ', 'px;\n  height: ', 'px;\n\n  transform: rotate(-3deg);\n\n  ', ' {\n    width: ', 'px;\n    height: ', 'px;\n  }\n\n  background-color: ', ';\n  border-radius: 50%;\n\n  padding: 40px;\n  ', ' {\n    padding: 30px;\n  }\n\n  text-align: center;\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n\n  transform: rotate(-3deg);\n\n  ', ' {\n    width: ', 'px;\n    height: ', 'px;\n  }\n\n  background-color: ', ';\n  border-radius: 50%;\n\n  padding: 40px;\n  ', ' {\n    padding: 30px;\n  }\n\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 15px;\n  ', ' {\n    margin-top: 10px;\n  }\n'], ['\n  margin-top: 15px;\n  ', ' {\n    margin-top: 10px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-top: 10px;\n  ', ' {\n    margin-top: 0;\n  }\n'], ['\n  margin-top: 10px;\n  ', ' {\n    margin-top: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _GrafikPDFDownload = __webpack_require__(132);
	
	var _GrafikPDFDownload2 = _interopRequireDefault(_GrafikPDFDownload);
	
	var _DownloadMaterialButton = __webpack_require__(61);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _DownloadPdf = __webpack_require__(81);
	
	var _DownloadPdf2 = _interopRequireDefault(_DownloadPdf);
	
	var _colors = __webpack_require__(8);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CTA_DESKTOP_SIZE = 325;
	var CTA_SIZE = 250;
	
	var Container = _styled2.default.article(_templateObject, CTA_DESKTOP_SIZE, CTA_DESKTOP_SIZE, _breakpoints.mediaTablet, CTA_SIZE, CTA_SIZE, _colors.PrimaryColor, _breakpoints.mediaTablet);
	
	var DownloadMaterialButton1st = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject2, _breakpoints.mediaTablet);
	
	var DownloadMaterialButton2nd = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject3, _breakpoints.mediaTablet);
	
	var CTA = function CTA(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    _DownloadPdf2.default,
	    { className: className },
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(_GrafikPDFDownload2.default, { insideCTA: true }),
	      _react2.default.createElement(DownloadMaterialButton1st, { noicon: true }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(DownloadMaterialButton2nd, { nolabel: true })
	    )
	  );
	};
	
	CTA.propTypes = {
	  className: _propTypes2.default.string
	};
	
	CTA.defaultProps = {
	  className: undefined
	};
	
	exports.default = CTA;
	module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n  display: inline-block;\n  width: 542px;\n  height: 426px;\n  max-width: 100%;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(', ');\n\n  @media only screen and (max-width: 375px),\n         only screen and (max-width: 375px),\n  {\n    background-image: url(', ');\n  }\n\n  @media only screen and (max-width: 375px) and (-webkit-min-device-pixel-ratio: 1.5),\n         only screen and (max-width: 375px) and (min-resolution: 144dpi),\n  {\n    background-image: url(', ');\n  }\n\n  @media only screen and (min-width: 376px) and (-webkit-min-device-pixel-ratio: 1.5),\n         only screen and (min-width: 376px) and (min-resolution: 144dpi),\n  {\n    background-image: url(', ');\n  }\n'], ['\n  ', '\n  display: inline-block;\n  width: 542px;\n  height: 426px;\n  max-width: 100%;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(', ');\n\n  @media only screen and (max-width: 375px),\n         only screen and (max-width: 375px),\n  {\n    background-image: url(', ');\n  }\n\n  @media only screen and (max-width: 375px) and (-webkit-min-device-pixel-ratio: 1.5),\n         only screen and (max-width: 375px) and (min-resolution: 144dpi),\n  {\n    background-image: url(', ');\n  }\n\n  @media only screen and (min-width: 376px) and (-webkit-min-device-pixel-ratio: 1.5),\n         only screen and (min-width: 376px) and (min-resolution: 144dpi),\n  {\n    background-image: url(', ');\n  }\n']);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _images = __webpack_require__(63);
	
	var _Grafik_family = __webpack_require__(424);
	
	var _Grafik_family2 = _interopRequireDefault(_Grafik_family);
	
	var _Grafik_family2x = __webpack_require__(425);
	
	var _Grafik_family2x2 = _interopRequireDefault(_Grafik_family2x);
	
	var _Grafik_family_mobile = __webpack_require__(426);
	
	var _Grafik_family_mobile2 = _interopRequireDefault(_Grafik_family_mobile);
	
	var _Grafik_family_mobile2x = __webpack_require__(427);
	
	var _Grafik_family_mobile2x2 = _interopRequireDefault(_Grafik_family_mobile2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Hero = _styled2.default.div(_templateObject, _images.sharpImageRendering, _Grafik_family2.default, _Grafik_family_mobile2.default, _Grafik_family_mobile2x2.default, _Grafik_family2x2.default);
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Hero = __webpack_require__(217);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hero).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 50px;\n  padding-bottom: 10px;\n\n  ', ' {\n    padding-top: 74px;\n  }\n\n  ', ' {\n    padding-top: 36px;\n  }\n'], ['\n  padding-top: 50px;\n  padding-bottom: 10px;\n\n  ', ' {\n    padding-top: 74px;\n  }\n\n  ', ' {\n    padding-top: 36px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-family: \'PT Mono\', monospace;\n  font-weight: normal;\n  font-size: 18px;\n\n  ', ' {\n    font-size: 15px;\n  }\n'], ['\n  font-family: \'PT Mono\', monospace;\n  font-weight: normal;\n  font-size: 18px;\n\n  ', ' {\n    font-size: 15px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n          &:before {\n            content: \'/\';\n            margin-left: 0.5em;\n            margin-right: 0.5em;\n          }\n\n          @media only screen and (min-width: 1280px) {\n            &:before { display: none; }\n            display: block;\n          }\n\n          font-weight: bold;\n        '], ['\n          &:before {\n            content: \'/\';\n            margin-left: 0.5em;\n            margin-right: 0.5em;\n          }\n\n          @media only screen and (min-width: 1280px) {\n            &:before { display: none; }\n            display: block;\n          }\n\n          font-weight: bold;\n        ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(13);
	
	var _H = __webpack_require__(212);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Title = (0, _styled2.default)(_H2.default)(_templateObject, _breakpoints.mediaTablet, _breakpoints.mediaPhone);
	
	var P = _styled2.default.p(_templateObject2, _breakpoints.mediaTablet);
	
	var Introduction = function Introduction(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'article',
	    { className: className },
	    _react2.default.createElement(
	      Title,
	      null,
	      'Familien und Flucht aus der DDR'
	    ),
	    _react2.default.createElement(
	      P,
	      null,
	      'Acht Lerneinheiten f\xFCr die Grundschule mit erg\xE4nzenden Materialien',
	      _react2.default.createElement(
	        'span',
	        {
	          className: (0, _emotion.css)(_templateObject3)
	        },
	        '3.\u20136. Klasse'
	      )
	    )
	  );
	};
	
	Introduction.propTypes = {
	  className: _propTypes2.default.string
	};
	
	Introduction.defaultProps = {
	  className: undefined
	};
	
	exports.default = Introduction;
	module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: flex-end;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _emotion = __webpack_require__(13);
	
	var _BFBLogo = __webpack_require__(127);
	
	var _BFBLogo2 = _interopRequireDefault(_BFBLogo);
	
	var _BALogo = __webpack_require__(126);
	
	var _BALogo2 = _interopRequireDefault(_BALogo);
	
	var _breakpoints = __webpack_require__(4);
	
	var _Logo = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Layout = _styled2.default.section(_templateObject);
	
	var Logos = function Logos() {
	  var _css;
	
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(_BFBLogo2.default, {
	      labelStyles: _Logo.HideLogoLabelOnPhoneStyles,
	      imageStyles: _BFBLogo.BFBLogoSmallOnPhone
	    }),
	    _react2.default.createElement(_BALogo2.default, {
	      className: (0, _emotion.css)((_css = {
	        marginLeft: '93px'
	      }, _css[_breakpoints.mediaPhone] = {
	        marginLeft: '52px'
	      }, _css)),
	      labelStyles: (0, _emotion.css)(_Logo.HideLogoLabelOnPhoneStyles, 'text-align: right;'),
	      imageStyles: _BALogo.BALogoSmallOnPhone
	    })
	  );
	};
	
	exports.default = Logos;
	module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: 80px;\n\n  position: relative;\n\n  background-size: 100% 92%;\n  background-repeat: no-repeat;\n\n  background-image: url(', ');\n\n  ', ' {\n    margin-top: 50px;\n    background-size: 100% 75%;\n    background-image: url(', ');\n  }\n\n  ', ' {\n    margin-top: 60px;\n    background-size: 100% 95%;\n    background-image: url(', ');\n\n    margin-left: -', 'px;\n    margin-right: -', 'px;\n    padding-left: ', 'px;\n    padding-right: ', 'px;\n  }\n\n  @media (max-width: 576px) { background-size: 100% 90%; }\n  @media (max-width: 475px) { background-size: 100% 87%; }\n'], ['\n  margin-top: 80px;\n\n  position: relative;\n\n  background-size: 100% 92%;\n  background-repeat: no-repeat;\n\n  background-image: url(', ');\n\n  ', ' {\n    margin-top: 50px;\n    background-size: 100% 75%;\n    background-image: url(', ');\n  }\n\n  ', ' {\n    margin-top: 60px;\n    background-size: 100% 95%;\n    background-image: url(', ');\n\n    margin-left: -', 'px;\n    margin-right: -', 'px;\n    padding-left: ', 'px;\n    padding-right: ', 'px;\n  }\n\n  @media (max-width: 576px) { background-size: 100% 90%; }\n  @media (max-width: 475px) { background-size: 100% 87%; }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n\n  width: ', 'px;\n  height: ', 'px;\n\n  ', ' {\n    width: ', 'px;\n    height: ', 'px;\n  }\n\n  background-position: center;\n  background-size: contain;\n  background-image: url(', ');\n\n  @media only screen and (-o-min-device-pixel-ratio: 1.25),\n         only screen and (-webkit-min-device-pixel-ratio: 1.25),\n         only screen and (min-device-pixel-ratio: 1.25)\n  {\n    background-image: url(', ');\n  }\n'], ['\n  position: absolute;\n\n  width: ', 'px;\n  height: ', 'px;\n\n  ', ' {\n    width: ', 'px;\n    height: ', 'px;\n  }\n\n  background-position: center;\n  background-size: contain;\n  background-image: url(', ');\n\n  @media only screen and (-o-min-device-pixel-ratio: 1.25),\n         only screen and (-webkit-min-device-pixel-ratio: 1.25),\n         only screen and (min-device-pixel-ratio: 1.25)\n  {\n    background-image: url(', ');\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  left: -260px;\n  bottom: -65px;\n  ', ' {\n    left: -167px;\n    bottom: 17px;\n  }\n  ', ' {\n    left: -140px;\n    bottom: 106px;\n  }\n'], ['\n  left: -260px;\n  bottom: -65px;\n  ', ' {\n    left: -167px;\n    bottom: 17px;\n  }\n  ', ' {\n    left: -140px;\n    bottom: 106px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  right: -210px;\n  bottom: -35px;\n  ', ' {\n    right: -147px;\n    bottom: 66px;\n  }\n  ', ' {\n    right: -60px;\n    bottom: 144px;\n  }\n'], ['\n  right: -210px;\n  bottom: -35px;\n  ', ' {\n    right: -147px;\n    bottom: 66px;\n  }\n  ', ' {\n    right: -60px;\n    bottom: 144px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _pageLayout = __webpack_require__(83);
	
	var _Mauer = __webpack_require__(428);
	
	var _Mauer2 = _interopRequireDefault(_Mauer);
	
	var _Mauer12x = __webpack_require__(429);
	
	var _Mauer12x2 = _interopRequireDefault(_Mauer12x);
	
	var _Mauer3 = __webpack_require__(430);
	
	var _Mauer4 = _interopRequireDefault(_Mauer3);
	
	var _Mauer22x = __webpack_require__(431);
	
	var _Mauer22x2 = _interopRequireDefault(_Mauer22x);
	
	var _rhombusDesktop = __webpack_require__(432);
	
	var _rhombusDesktop2 = _interopRequireDefault(_rhombusDesktop);
	
	var _rhombusTablet = __webpack_require__(434);
	
	var _rhombusTablet2 = _interopRequireDefault(_rhombusTablet);
	
	var _rhombusPhone = __webpack_require__(433);
	
	var _rhombusPhone2 = _interopRequireDefault(_rhombusPhone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Rhombus = _styled2.default.section(_templateObject, _rhombusDesktop2.default, _breakpoints.mediaTablet, _rhombusTablet2.default, _breakpoints.mediaPhone, _rhombusPhone2.default, _pageLayout.PHONE_MARGIN, _pageLayout.PHONE_MARGIN, _pageLayout.PHONE_MARGIN, _pageLayout.PHONE_MARGIN);
	
	var Mauer = function Mauer(width, height, scaleTablet, img, img2x) {
	  return _styled2.default.div(_templateObject2, width, height, _breakpoints.mediaTablet, Math.round(width * scaleTablet), Math.round(height * scaleTablet), img, img2x);
	};
	
	var MauerEastside = (0, _styled2.default)(Mauer(617, 380, 0.73, _Mauer2.default, _Mauer12x2.default))(_templateObject3, _breakpoints.mediaTablet, _breakpoints.mediaPhone);
	
	var MauerWestside = (0, _styled2.default)(Mauer(361, 415, 0.69, _Mauer4.default, _Mauer22x2.default))(_templateObject4, _breakpoints.mediaTablet, _breakpoints.mediaPhone);
	
	var MauerBack = function MauerBack(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    Rhombus,
	    null,
	    _react2.default.createElement(MauerEastside, null),
	    children,
	    _react2.default.createElement(MauerWestside, null)
	  );
	};
	
	MauerBack.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = MauerBack;
	module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MauerBack = __webpack_require__(221);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MauerBack).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  ', ' {\n    top: 0;\n    left: 25px;\n  }\n\n  padding-top: 25px;\n  ', ' {\n    padding-top: 5px;\n  }\n'], ['\n  position: relative;\n  ', ' {\n    top: 0;\n    left: 25px;\n  }\n\n  padding-top: 25px;\n  ', ' {\n    padding-top: 5px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n\n  padding-top: 70px;\n\n  ', ' {\n    padding-top: 0;\n    padding-left: 16px;\n  }\n\n  ', ' {\n    padding-left: 0;\n    display: block;\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n\n  padding-top: 70px;\n\n  ', ' {\n    padding-top: 0;\n    padding-left: 16px;\n  }\n\n  ', ' {\n    padding-left: 0;\n    display: block;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: -40px;\n\n  ', ' {\n    width: 100vw;\n    left: 0px;\n    top: -62px;\n  }\n'], ['\n  position: absolute;\n  top: -40px;\n\n  ', ' {\n    width: 100vw;\n    left: 0px;\n    top: -62px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  z-index: 30;\n  flex-basis: 49.5%;\n  order: 20;\n  padding: 0 60px 0 20px;\n\n  ', ' {\n    padding: 0 40px 0 0;\n  }\n\n  ', ' {\n    padding: 0;\n  }\n'], ['\n  position: relative;\n  z-index: 30;\n  flex-basis: 49.5%;\n  order: 20;\n  padding: 0 60px 0 20px;\n\n  ', ' {\n    padding: 0 40px 0 0;\n  }\n\n  ', ' {\n    padding: 0;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  z-index: 20;\n  flex-basis: 49%;\n  order: 10;\n\n  ', ' {\n    ', '\n    order: 20;\n    position: relative;\n    top: -80px;\n    margin-bottom: -80px;\n    max-width: 90vw;\n  }\n\n  @media (max-width: 576px) { top: -100px; margin-bottom: -100px; }\n  @media (max-width: 475px) { top: -120px; margin-bottom: -120px; }\n'], ['\n  z-index: 20;\n  flex-basis: 49%;\n  order: 10;\n\n  ', ' {\n    ', '\n    order: 20;\n    position: relative;\n    top: -80px;\n    margin-bottom: -80px;\n    max-width: 90vw;\n  }\n\n  @media (max-width: 576px) { top: -100px; margin-bottom: -100px; }\n  @media (max-width: 475px) { top: -120px; margin-bottom: -120px; }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  z-index: 10;\n\n  top: -130px;\n  left: 50px;\n\n  ', ' {\n    top: -108px;\n    left: 25px;\n  }\n\n  ', ' {\n    ', '\n    position: relative;\n    top: auto;\n    left: auto;\n    order: 10;\n  }\n'], ['\n  position: absolute;\n  z-index: 10;\n\n  top: -130px;\n  left: 50px;\n\n  ', ' {\n    top: -108px;\n    left: 25px;\n  }\n\n  ', ' {\n    ', '\n    position: relative;\n    top: auto;\n    left: auto;\n    order: 10;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Logos = __webpack_require__(220);
	
	var _Logos2 = _interopRequireDefault(_Logos);
	
	var _Introduction = __webpack_require__(219);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _CTA = __webpack_require__(216);
	
	var _CTA2 = _interopRequireDefault(_CTA);
	
	var _Hero = __webpack_require__(218);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _MauerBack = __webpack_require__(222);
	
	var _MauerBack2 = _interopRequireDefault(_MauerBack);
	
	var _Stacheldraht = __webpack_require__(15);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _PageLayout = __webpack_require__(133);
	
	var _PageLayout2 = _interopRequireDefault(_PageLayout);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styled2.default.header(_templateObject, _breakpoints.minDesktop, _breakpoints.mediaPhone);
	
	var MauerContent = _styled2.default.div(_templateObject2, _breakpoints.mediaTablet, _breakpoints.mediaPhone);
	
	var StacheldrahtStyled = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject3, _breakpoints.mediaPhone);
	
	var IntroductionStyled = (0, _styled2.default)(_Introduction2.default)(_templateObject4, _breakpoints.mediaTablet, _breakpoints.mediaPhone);
	
	var centerVertical = '\n  margin-left: auto;\n  margin-right: auto;\n';
	
	var HeroStyled = (0, _styled2.default)(_Hero2.default)(_templateObject5, _breakpoints.mediaPhone, centerVertical);
	
	var CTAStyled = (0, _styled2.default)(_CTA2.default)(_templateObject6, _breakpoints.mediaTablet, _breakpoints.mediaPhone, centerVertical);
	
	var PageHeader = function PageHeader() {
	  return _react2.default.createElement(
	    Header,
	    null,
	    _react2.default.createElement(
	      _PageLayout2.default,
	      null,
	      _react2.default.createElement(_Logos2.default, null),
	      _react2.default.createElement(
	        _MauerBack2.default,
	        null,
	        _react2.default.createElement(StacheldrahtStyled, null),
	        _react2.default.createElement(
	          MauerContent,
	          null,
	          _react2.default.createElement(IntroductionStyled, null),
	          _react2.default.createElement(CTAStyled, null),
	          _react2.default.createElement(HeroStyled, null)
	        )
	      )
	    )
	  );
	};
	
	exports.default = PageHeader;
	module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageHeader = __webpack_require__(223);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PageHeader).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: auto;\n  margin-right: auto;\n\n  padding: 0 ', 'px;\n\n  ', ' {\n    padding: 0 ', 'px;\n  }\n\n  ', ' {\n    max-width: ', 'px;\n    padding: 0 ', 'px;\n  }\n'], ['\n  margin-left: auto;\n  margin-right: auto;\n\n  padding: 0 ', 'px;\n\n  ', ' {\n    padding: 0 ', 'px;\n  }\n\n  ', ' {\n    max-width: ', 'px;\n    padding: 0 ', 'px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _pageLayout = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Layout = _styled2.default.div(_templateObject, _pageLayout.PHONE_MARGIN, _breakpoints.minTablet, _pageLayout.TABLET_MARGIN, _breakpoints.minDesktop, _pageLayout.DESKTOP_WIDTH + _pageLayout.DESKTOP_MARGIN * 2, _pageLayout.DESKTOP_MARGIN);
	
	var PageLayout = function PageLayout(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	  return _react2.default.createElement(
	    Layout,
	    { className: className },
	    children
	  );
	};
	
	PageLayout.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node.isRequired
	};
	
	PageLayout.defaultProps = {
	  className: undefined
	};
	
	exports.default = PageLayout;
	module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: 25px;\n  margin-right: 25px;\n\n  ', ' {\n    margin-left: 40px;\n    margin-right: 40px;\n  }\n\n  ', ' {\n    width: ', 'px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    top: 0;\n    left: -30px;\n\n    background-color: ', ';\n\n    ::before, ::after {\n      content: \'\';\n      display: block;\n      left: 0;\n      right: 0;\n      height: ', 'px;\n      background-color: ', ';\n      background-size: 100% 100%;\n      background-repeat: no-repeat;\n    }\n\n    ::before {\n      top: 0;\n      background-image: url(', ');\n    }\n\n    ::after {\n      bottom: 0;\n      background-image: url(', ');\n    }\n  }\n'], ['\n  margin-left: 25px;\n  margin-right: 25px;\n\n  ', ' {\n    margin-left: 40px;\n    margin-right: 40px;\n  }\n\n  ', ' {\n    width: ', 'px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    top: 0;\n    left: -30px;\n\n    background-color: ', ';\n\n    ::before, ::after {\n      content: \'\';\n      display: block;\n      left: 0;\n      right: 0;\n      height: ', 'px;\n      background-color: ', ';\n      background-size: 100% 100%;\n      background-repeat: no-repeat;\n    }\n\n    ::before {\n      top: 0;\n      background-image: url(', ');\n    }\n\n    ::after {\n      bottom: 0;\n      background-image: url(', ');\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	var _rhombusFlatTop = __webpack_require__(181);
	
	var _rhombusFlatTop2 = _interopRequireDefault(_rhombusFlatTop);
	
	var _rhombusFlatBottom = __webpack_require__(180);
	
	var _rhombusFlatBottom2 = _interopRequireDefault(_rhombusFlatBottom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var RHOMBUS_HEIGHT = 64;
	var DESKTOP_WIDTH = 1180;
	
	var Main = _styled2.default.main(_templateObject, _breakpoints.minTablet, _breakpoints.minDesktop, DESKTOP_WIDTH, _colors.GrayBack, RHOMBUS_HEIGHT, _colors.White, _rhombusFlatTop2.default, _rhombusFlatBottom2.default);
	
	var PageMainLayout = function PageMainLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    Main,
	    null,
	    children
	  );
	};
	
	PageMainLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = PageMainLayout;
	module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageMainLayout = __webpack_require__(226);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PageMainLayout).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';  \n\n  ', ' {\n    margin-bottom: -30px;    \n  }\n\n  ::after {\n    content: \'\';\n    display: block;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: ', 'px;\n    background-color: ', ';\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-image: url(', ');\n  }\n\n  ', ' {\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-bottom: -20px;    \n\n    ::after {\n      height: ', 'px;\n    }\n  }\n\n  ', ' {\n    width: ', 'px;\n\n    margin-top: -40px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;    \n\n    position: relative;\n    top: 0;\n    left: 25px;\n    \n    background-color: transparent;  \n\n    ::after {\n      height: ', 'px;\n      background-image: url(', ');\n    }\n  }\n'], ['\n  background-color: ', ';  \n\n  ', ' {\n    margin-bottom: -30px;    \n  }\n\n  ::after {\n    content: \'\';\n    display: block;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: ', 'px;\n    background-color: ', ';\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-image: url(', ');\n  }\n\n  ', ' {\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-bottom: -20px;    \n\n    ::after {\n      height: ', 'px;\n    }\n  }\n\n  ', ' {\n    width: ', 'px;\n\n    margin-top: -40px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;    \n\n    position: relative;\n    top: 0;\n    left: 25px;\n    \n    background-color: transparent;  \n\n    ::after {\n      height: ', 'px;\n      background-image: url(', ');\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: ', 'px;\n\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-color: ', ';\n  background-image: url(', ');\n\n  ', ' {\n    height: ', 'px;\n  }\n\n  ', ' {\n    height: ', 'px;\n    width: ', 'px;\n    background-color: transparent;\n    background-image: url(', ');\n  }\n'], ['\n  height: ', 'px;\n\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-color: ', ';\n  background-image: url(', ');\n\n  ', ' {\n    height: ', 'px;\n  }\n\n  ', ' {\n    height: ', 'px;\n    width: ', 'px;\n    background-color: transparent;\n    background-image: url(', ');\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: 0 20px 40px;\n\n  ', ' {\n    padding: 20px 40px;\n  }\n\n  ', ' {\n    width: ', 'px;\n\n    padding: 40px 80px;\n\n    background-color: ', ';\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-image: url(', ');\n  }\n'], ['\n  padding: 0 20px 40px;\n\n  ', ' {\n    padding: 20px 40px;\n  }\n\n  ', ' {\n    width: ', 'px;\n\n    padding: 40px 80px;\n\n    background-color: ', ';\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-image: url(', ');\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: none;\n  ', ' {\n    display: block;\n    margin-bottom: -10px;\n  }\n'], ['\n  display: none;\n  ', ' {\n    display: block;\n    margin-bottom: -10px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  line-height: 1;\n  margin-bottom: 20px;\n  ', ' {\n    line-height: 2;\n    margin-bottom: 30px;\n  }\n'], ['\n  line-height: 1;\n  margin-bottom: 20px;\n  ', ' {\n    line-height: 2;\n    margin-bottom: 30px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    display: flex;\n  }\n  ', ' {\n    padding-left: 150px;\n  }\n'], ['\n  ', ' {\n    display: flex;\n  }\n  ', ' {\n    padding-left: 150px;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  line-height: 1.3;\n\n  font-size: 16px;\n\n  ', ' {\n    font-size: 18px;\n\n    order: 2;\n  }\n'], ['\n  line-height: 1.3;\n\n  font-size: 16px;\n\n  ', ' {\n    font-size: 18px;\n\n    order: 2;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  margin-top: 30px;\n\n  ', ' {\n    margin-top: 2px;\n    margin-right: 40px;\n  }\n  ', ' {\n    margin-right: 70px;\n  }\n'], ['\n  margin-top: 30px;\n\n  ', ' {\n    margin-top: 2px;\n    margin-right: 40px;\n  }\n  ', ' {\n    margin-right: 70px;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  margin-top: 35px;\n  ', ' {\n    margin-top: 50px;\n  }\n'], ['\n  margin-top: 35px;\n  ', ' {\n    margin-top: 50px;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  ', ' {\n    text-align: right;\n  }\n'], ['\n  text-align: center;\n  ', ' {\n    text-align: right;\n  }\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    text-align: center;\n  }\n'], ['\n  ', ' {\n    text-align: center;\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n  ', ';\n  ', ';\n'], ['\n  ', ';\n  ', ';\n']),
	    _templateObject14 = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n  max-height: 50px;\n'], ['\n  max-height: 50px;\n']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n  margin-top: 14px;\n  max-height: 60px;\n  ', ' {\n    margin-left: 10px;\n  }\n'], ['\n  margin-top: 14px;\n  max-height: 60px;\n  ', ' {\n    margin-left: 10px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _core = __webpack_require__(10);
	
	var _breakpoints = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	var _Logo = __webpack_require__(62);
	
	var _BALogo = __webpack_require__(126);
	
	var _BALogo2 = _interopRequireDefault(_BALogo);
	
	var _BFBLogo = __webpack_require__(127);
	
	var _BFBLogo2 = _interopRequireDefault(_BFBLogo);
	
	var _H = __webpack_require__(48);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Stacheldraht = __webpack_require__(15);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _rhombusOutlineTop = __webpack_require__(445);
	
	var _rhombusOutlineTop2 = _interopRequireDefault(_rhombusOutlineTop);
	
	var _rhombusOutlineMiddle = __webpack_require__(444);
	
	var _rhombusOutlineMiddle2 = _interopRequireDefault(_rhombusOutlineMiddle);
	
	var _rhombusOutlineBottom = __webpack_require__(443);
	
	var _rhombusOutlineBottom2 = _interopRequireDefault(_rhombusOutlineBottom);
	
	var _rhombusFlatTop = __webpack_require__(181);
	
	var _rhombusFlatTop2 = _interopRequireDefault(_rhombusFlatTop);
	
	var _rhombusFlatBottom = __webpack_require__(180);
	
	var _rhombusFlatBottom2 = _interopRequireDefault(_rhombusFlatBottom);
	
	var _CARELogo = __webpack_require__(435);
	
	var _CARELogo2 = _interopRequireDefault(_CARELogo);
	
	var _kiwi = __webpack_require__(436);
	
	var _kiwi2 = _interopRequireDefault(_kiwi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var RHOMBUS_PHONE_HEIGHT = 20;
	var RHOMBUS_TABLET_HEIGHT = 40;
	var RHOMBUS_DESKTOP_HEIGHT = 64;
	var RHOMBUS_DESKTOP_WIDTH = 1180;
	
	var Container = _styled2.default.div(_templateObject, _colors.GrayBack, _breakpoints.mediaPhone, RHOMBUS_PHONE_HEIGHT, _colors.White, _rhombusFlatBottom2.default, _breakpoints.minTablet, RHOMBUS_TABLET_HEIGHT, _breakpoints.minDesktop, RHOMBUS_DESKTOP_WIDTH, RHOMBUS_DESKTOP_HEIGHT, _rhombusOutlineBottom2.default);
	
	var Before = _styled2.default.div(_templateObject2, RHOMBUS_PHONE_HEIGHT, _colors.White, _rhombusFlatTop2.default, _breakpoints.minTablet, RHOMBUS_TABLET_HEIGHT, _breakpoints.minDesktop, RHOMBUS_DESKTOP_HEIGHT, RHOMBUS_DESKTOP_WIDTH, _rhombusOutlineTop2.default);
	
	var Content = _styled2.default.article(_templateObject3, _breakpoints.minTablet, _breakpoints.minDesktop, RHOMBUS_DESKTOP_WIDTH, _colors.White, _rhombusOutlineMiddle2.default);
	
	var StacheldrahtStyled = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject4, _breakpoints.mediaPhone);
	
	var Title = (0, _styled2.default)(_H2.default)(_templateObject5, _breakpoints.minTablet);
	
	var InnerContent = _styled2.default.div(_templateObject6, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var AboutThisProject = _styled2.default.div(_templateObject7, _breakpoints.minTablet);
	
	var Logos = _styled2.default.div(_templateObject8, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var LogoMargins = (0, _core.css)(_templateObject9, _breakpoints.minTablet);
	
	var BALogoStyled = (0, _styled2.default)(_BALogo2.default)(_templateObject10, LogoMargins);
	
	var LogoAlignStyles = (0, _core.css)(_templateObject11, _breakpoints.minTablet);
	
	var LogoImageContainerStyles = (0, _core.css)(_templateObject12, _breakpoints.mediaPhone);
	
	var Fachpartner = _styled2.default.article(_templateObject13, LogoMargins, LogoAlignStyles);
	
	var FachpartnerLabel = _styled2.default.div(_templateObject14);
	
	var FachpartnerLogoContainer = _styled2.default.div(_templateObject14);
	
	var FachpartnerLink = _styled2.default.a(_templateObject14);
	
	var CareLogo = _styled2.default.img(_templateObject15);
	
	var KiwiLogo = _styled2.default.img(_templateObject16, _breakpoints.mediaPhone);
	
	var ProjectPartners = function ProjectPartners() {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(Before, null),
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(StacheldrahtStyled, { left: true, small: true }),
	      _react2.default.createElement(
	        Title,
	        null,
	        'Projektpartner'
	      ),
	      _react2.default.createElement(
	        InnerContent,
	        null,
	        _react2.default.createElement(
	          AboutThisProject,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Das Projekt entstand als Idee und auf Initiative des Bund f\xFCr Bildung e. V. und wurde innerhalb des Vereins erstellt. Ganz herzlich bedanken m\xF6chten wir uns bei der Bundesstiftung zur Aufarbeitung der SED-Diktatur, mit deren F\xF6rderung wir das Projekt realisieren konnten.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ein besonderer Dank gilt ebenfalls unseren Fachberater*innen:',
	            _react2.default.createElement('br', null),
	            'Prof. Dr. Eckhard Jesse von der TU Chemnitz und Prof. Dr. Christoph Kle\xDFmann vom Zentrum f\xFCr Zeithistorische Forschungen f\xFCr die historischen Fragen; Thomas Knoll von CARE Deutschland-Luxemburg e.V., Projektleiter KIWI \u2013 Integrationsf\xF6rderung an Schulen zur aktuellen Fl\xFCchtlingssituation sowie Schulleiterin Martina Feindt und Schulleiter Falko Stolp zur Didaktik und P\xE4dagogik.'
	          )
	        ),
	        _react2.default.createElement(
	          Logos,
	          null,
	          _react2.default.createElement(_BFBLogo2.default, { labelStyles: LogoAlignStyles, imageContainerStyles: LogoImageContainerStyles }),
	          _react2.default.createElement(BALogoStyled, { labelStyles: LogoAlignStyles, imageContainerStyles: LogoImageContainerStyles }),
	          _react2.default.createElement(
	            Fachpartner,
	            null,
	            _react2.default.createElement(
	              FachpartnerLabel,
	              { className: _Logo.LogoLabelStyles },
	              'Fachpartner'
	            ),
	            _react2.default.createElement(
	              FachpartnerLogoContainer,
	              null,
	              _react2.default.createElement(
	                FachpartnerLink,
	                { href: 'https://www.care.de', target: '_blank', rel: 'noopener nofollow external' },
	                _react2.default.createElement(CareLogo, { src: _CARELogo2.default })
	              ),
	              _react2.default.createElement(
	                FachpartnerLink,
	                { href: 'https://www.care.de/nothilfe/themen/integration-in-deutschland/', target: '_blank', rel: 'noopener nofollow external' },
	                _react2.default.createElement(KiwiLogo, { src: _kiwi2.default })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProjectPartners;
	module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProjectPartners = __webpack_require__(228);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProjectPartners).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-bottom: 60px;\n  padding-top: 10px;\n'], ['\n  margin-bottom: 60px;\n  padding-top: 10px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n  position: relative;\n  top: 0;\n  left: 38%;\n'], ['\n  ', ';\n  position: relative;\n  top: 0;\n  left: 38%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Stacheldraht = __webpack_require__(15);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _ExternalLinksCollection = __webpack_require__(130);
	
	var _ExternalLinksCollection2 = _interopRequireDefault(_ExternalLinksCollection);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.section(_templateObject);
	
	var StacheldrahtStyled = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject2, _breakpoints.showOnlyOnDesktop);
	
	var ProofOfSources = function ProofOfSources(_ref) {
	  var sources = _ref.sources;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(_ExternalLinksCollection2.default, { headline: 'Quellen und weitere Informationen', sources: sources, showIds: true }),
	    _react2.default.createElement(StacheldrahtStyled, { small: true })
	  );
	};
	
	ProofOfSources.propTypes = {
	  sources: _ExternalLinksCollection.ExternalLinksShape.isRequired
	};
	
	exports.default = ProofOfSources;
	module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProofOfSources = __webpack_require__(230);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProofOfSources).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-bottom: 30px;\n  ', ' {\n    margin-bottom: 50px;\n  }\n  ', ' {\n    margin-bottom: 0;\n  }\n'], ['\n  margin-bottom: 30px;\n  ', ' {\n    margin-bottom: 50px;\n  }\n  ', ' {\n    margin-bottom: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n  position: relative;\n  top: 0;\n  left: -38%;\n'], ['\n  ', ';\n  position: relative;\n  top: 0;\n  left: -38%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Stacheldraht = __webpack_require__(15);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _ExternalLinksCollection = __webpack_require__(130);
	
	var _ExternalLinksCollection2 = _interopRequireDefault(_ExternalLinksCollection);
	
	var _breakpoints = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styled2.default.section(_templateObject, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	var StacheldrahtStyled = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject2, _breakpoints.showOnlyOnDesktop);
	
	var RelatedMaterials = function RelatedMaterials(_ref) {
	  var sources = _ref.sources;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(_ExternalLinksCollection2.default, { headline: 'Weiterf\xFChrende Materialen', sources: sources }),
	    _react2.default.createElement(StacheldrahtStyled, { small: true })
	  );
	};
	
	RelatedMaterials.propTypes = {
	  sources: _ExternalLinksCollection.ExternalLinksShape.isRequired
	};
	
	exports.default = RelatedMaterials;
	module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RelatedMaterials = __webpack_require__(232);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RelatedMaterials).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(11);
	
	var _reactImages = __webpack_require__(364);
	
	var _reactImages2 = _interopRequireDefault(_reactImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-array-index-key */
	/* eslint-disable arrow-body-style */
	/* eslint-disable arrow-parens */
	/* eslint-disable react/prop-types */
	/* eslint-disable jsx-a11y/alt-text */
	/* eslint-disable no-use-before-define */
	/* eslint-disable react/destructuring-assignment */
	/* eslint-disable react/no-access-state-in-setstate */
	/* eslint-disable react/require-default-props */
	
	// https://github.com/jossmac/react-images/blob/master/examples/src/components/Gallery.js
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery() {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      lightboxIsOpen: false,
	      currentImage: 0
	    };
	
	    _this.closeLightbox = _this.closeLightbox.bind(_this);
	    _this.gotoNext = _this.gotoNext.bind(_this);
	    _this.gotoPrevious = _this.gotoPrevious.bind(_this);
	    _this.gotoImage = _this.gotoImage.bind(_this);
	    _this.handleClickImage = _this.handleClickImage.bind(_this);
	    _this.openLightbox = _this.openLightbox.bind(_this);
	    return _this;
	  }
	
	  Gallery.prototype.openLightbox = function openLightbox(index, event) {
	    event.preventDefault();
	    this.setState({
	      currentImage: index,
	      lightboxIsOpen: true
	    });
	  };
	
	  Gallery.prototype.closeLightbox = function closeLightbox() {
	    this.setState({
	      currentImage: 0,
	      lightboxIsOpen: false
	    });
	  };
	
	  Gallery.prototype.gotoPrevious = function gotoPrevious() {
	    this.setState({
	      currentImage: this.state.currentImage - 1
	    });
	  };
	
	  Gallery.prototype.gotoNext = function gotoNext() {
	    this.setState({
	      currentImage: this.state.currentImage + 1
	    });
	  };
	
	  Gallery.prototype.gotoImage = function gotoImage(index) {
	    this.setState({
	      currentImage: index
	    });
	  };
	
	  Gallery.prototype.handleClickImage = function handleClickImage() {
	    if (this.state.currentImage === this.props.images.length - 1) return;
	
	    this.gotoNext();
	  };
	
	  Gallery.prototype.renderGallery = function renderGallery() {
	    var _this2 = this;
	
	    var images = this.props.images;
	
	
	    if (!images) return;
	
	    var gallery = images.filter(function (i) {
	      return i.useForDemo;
	    }).map(function (obj, i) {
	      return _react2.default.createElement(
	        'a',
	        {
	          href: obj.src,
	          className: (0, _noImportant.css)(classes.thumbnail, classes[obj.orientation]),
	          key: i,
	          onClick: function onClick(e) {
	            return _this2.openLightbox(i, e);
	          }
	        },
	        _react2.default.createElement('img', { src: obj.thumbnail, className: (0, _noImportant.css)(classes.source) })
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _noImportant.css)(classes.gallery) },
	      gallery
	    );
	  };
	
	  Gallery.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      this.props.heading && _react2.default.createElement(
	        'h2',
	        null,
	        this.props.heading
	      ),
	      this.props.subheading && _react2.default.createElement(
	        'p',
	        null,
	        this.props.subheading
	      ),
	      this.renderGallery(),
	      _react2.default.createElement(_reactImages2.default, {
	        currentImage: this.state.currentImage,
	        images: this.props.images,
	        isOpen: this.state.lightboxIsOpen,
	        onClickImage: this.handleClickImage,
	        onClickNext: this.gotoNext,
	        onClickPrev: this.gotoPrevious,
	        onClickThumbnail: this.gotoImage,
	        onClose: this.closeLightbox,
	        preventScroll: this.props.preventScroll,
	        showThumbnails: this.props.showThumbnails,
	        spinner: this.props.spinner,
	        spinnerColor: this.props.spinnerColor,
	        spinnerSize: this.props.spinnerSize,
	        theme: this.props.theme
	      })
	    );
	  };
	
	  return Gallery;
	}(_react.Component);
	
	Gallery.displayName = 'Gallery';
	
	Gallery.propTypes = {
	  heading: _propTypes2.default.string,
	  images: _propTypes2.default.array,
	  showThumbnails: _propTypes2.default.bool,
	  subheading: _propTypes2.default.string
	};
	
	var gutter = {
	  small: 10,
	  large: 14
	};
	
	var classes = _noImportant.StyleSheet.create({
	  gallery: {
	    marginRight: -gutter.small,
	    overflow: 'hidden',
	
	    '@media (min-width: 768px)': {
	      marginRight: -gutter.large
	    }
	  },
	
	  // anchor
	  thumbnail: {
	    boxSizing: 'border-box',
	    display: 'block',
	    float: 'left',
	    lineHeight: 0,
	    paddingRight: gutter.small,
	    paddingBottom: gutter.small,
	    overflow: 'hidden',
	
	    '@media (min-width: 768px)': {
	      paddingRight: gutter.large,
	      paddingBottom: gutter.large
	    }
	  },
	
	  // orientation
	  landscape: {
	    width: '49%',
	    '@media (min-width: 768px)': {
	      width: '33%'
	    }
	  },
	  square: {
	    paddingBottom: 0,
	    width: '40%',
	
	    '@media (min-width: 768px)': {
	      paddingBottom: 0
	    }
	  },
	
	  // actual <img />
	  source: {
	    border: 0,
	    display: 'block',
	    height: 'auto',
	    maxWidth: '100%',
	    width: 'auto'
	  }
	});
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-bottom: -30px;\n  ', ' {\n    margin-bottom: -20px;\n  }\n'], ['\n  margin-bottom: -30px;\n  ', ' {\n    margin-bottom: -20px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    display: none;\n  }\n'], ['\n  ', ' {\n    display: none;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-family: \'PT Mono\', monospace;\n  font-size: 16px; // 18px\n  line-height: 1.2;\n  text-align: center;\n  color: ', ';\n  transform: rotate(-3deg);\n  margin-left: auto;\n  margin-right: auto;\n'], ['\n  font-family: \'PT Mono\', monospace;\n  font-size: 16px; // 18px\n  line-height: 1.2;\n  text-align: center;\n  color: ', ';\n  transform: rotate(-3deg);\n  margin-left: auto;\n  margin-right: auto;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1020px;\n\n  ', ' {\n    margin-bottom: 80px;\n  }\n'], ['\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1020px;\n\n  ', ' {\n    margin-bottom: 80px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin-top: 30px;\n  text-align: center;\n  margin-bottom: 30px;\n'], ['\n  margin-top: 30px;\n  text-align: center;\n  margin-bottom: 30px;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding: 15px;\n  border-radius: 3px;\n  text-align: center;\n'], ['\n  padding: 15px;\n  border-radius: 3px;\n  text-align: center;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 18px;\n'], ['\n  margin-bottom: 18px;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  top: 0;\n  left: 50%;\n  ', ' {\n    top: -10px;\n    left: 66%;\n    width: 48px;\n  }\n'], ['\n  position: relative;\n  top: 0;\n  left: 50%;\n  ', ' {\n    top: -10px;\n    left: 66%;\n    width: 48px;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  margin-left: auto;\n  margin-right: auto;\n\n  max-width: 330px;\n  ', ' {\n    max-width: 540px;\n  }\n  ', ' {\n    font-size: 18px;\n  }\n  ', ' {\n    max-width: 400px;\n    left: -20%;\n    top: -130px;\n    margin-bottom: -130px;\n  }\n'], ['\n  position: relative;\n\n  margin-left: auto;\n  margin-right: auto;\n\n  max-width: 330px;\n  ', ' {\n    max-width: 540px;\n  }\n  ', ' {\n    font-size: 18px;\n  }\n  ', ' {\n    max-width: 400px;\n    left: -20%;\n    top: -130px;\n    margin-bottom: -130px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _colors = __webpack_require__(8);
	
	var _breakpoints = __webpack_require__(4);
	
	var _DownloadMaterialButton = __webpack_require__(61);
	
	var _DownloadMaterialButton2 = _interopRequireDefault(_DownloadMaterialButton);
	
	var _H = __webpack_require__(48);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Stacheldraht = __webpack_require__(15);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _Gallery = __webpack_require__(234);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Grafik_Pfeil = __webpack_require__(437);
	
	var _Grafik_Pfeil2 = _interopRequireDefault(_Grafik_Pfeil);
	
	var _Grafik_Pfeil2x = __webpack_require__(438);
	
	var _Grafik_Pfeil2x2 = _interopRequireDefault(_Grafik_Pfeil2x);
	
	var _images = __webpack_require__(356);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable object-curly-newline */
	
	
	var StacheldrahtInfoTop = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject, _breakpoints.minTablet);
	
	var StacheldrahtBottom = (0, _styled2.default)(_Stacheldraht2.default)(_templateObject2, _breakpoints.minTablet);
	
	var Info = _styled2.default.p(_templateObject3, _colors.PrimaryColor);
	
	var Section = _styled2.default.div(_templateObject4, _breakpoints.minTablet);
	
	var DownloadAllContainer = _styled2.default.div(_templateObject5);
	
	var DownloadAll = (0, _styled2.default)(_DownloadMaterialButton2.default)(_templateObject6);
	
	var Title = (0, _styled2.default)(_H2.default)(_templateObject7);
	
	var Pfeil = _styled2.default.img(_templateObject8, _breakpoints.mediaPhone);
	
	var InfoContainer = _styled2.default.div(_templateObject9, _breakpoints.onlyTablet, _breakpoints.minTablet, _breakpoints.minDesktop);
	
	/*
	const makeUnsplashSrc = id => `https://images.unsplash.com/photo-${id}?dpr=2&auto=format&w=1024&h=1024`;
	const makeUnsplashSrcSet = (id, size) => `https://images.unsplash.com/photo-${id}?dpr=2&auto=format&w=${size} ${size}w`;
	const makeUnsplashThumbnail = (id, orientation = 'landscape') => {
	  const dimensions = orientation === 'square' ? 'w=300&h=300' : 'w=240&h=159';
	  return `https://images.unsplash.com/photo-${id}?dpr=2&auto=format&crop=faces&fit=crop&${dimensions}`;
	};
	
	// Unsplash images from the "Spirit Animals" collection
	// https://unsplash.com/collections/158825/spirit-animals
	
	const DEFAULT_IMAGES = [
	  // { id: '1470619549108-b85c56fe5be8', caption: 'Photo by Alan Emery', orientation: 'square', useForDemo: true }, // https://unsplash.com/photos/SYzUF6XcWBY (Flamingo)
	  { id: '1449104532935-d9209c70e2b6', caption: 'Photo by Casey Allen', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/SYzUF6XcWBY (Flamingo)
	  { id: '1480472684115-4966367dde1d', caption: 'Photo by Gary Bendig', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/SYzUF6XcWBY (Flamingo)
	  { id: '1454023492550-5696f8ff10e1', caption: 'Photo by Jessica Weiller', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/LmVSKeDy6EA (Tiger)
	  { id: '1471079502516-250c19af6928', caption: 'Photo by Jeremy Bishop', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/GIpGxe2_cT4 (Turtle)
	  { id: '1470854989922-5be2f7456d78', caption: 'Photo by Piotr Łaskawski', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/GXMr7BadXQo (Hedgehog)
	  { id: '1470317596697-cbdeda56f999', caption: 'Photo by Michel Bosma', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/XgF9e93Tkt0 (Ladybug)
	];
	*/
	
	var SmartboardGallery = function SmartboardGallery() {
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(
	      InfoContainer,
	      null,
	      _react2.default.createElement(StacheldrahtInfoTop, { small: true }),
	      _react2.default.createElement(
	        Info,
	        null,
	        'Hier k\xF6nnen Sie Bilder aus dem Unterrichtsmaterial zum Einsatz im Klassenraum herunterladen'
	      ),
	      _react2.default.createElement(Pfeil, {
	        src: _Grafik_Pfeil2.default,
	        srcSet: _Grafik_Pfeil2.default + ' 1x, ' + _Grafik_Pfeil2x2.default + ' 2x'
	      })
	    ),
	    _react2.default.createElement(
	      Title,
	      null,
	      'Smartboard-Galerie'
	    ),
	    _react2.default.createElement(_Gallery2.default, { images: _images2.default.map(function (_ref) {
	        var caption = _ref.caption,
	            src = _ref.src,
	            thumbnail = _ref.thumbnail,
	            srcSet = _ref.srcSet,
	            orientation = _ref.orientation;
	        return {
	          src: src,
	          thumbnail: thumbnail,
	          srcSet: srcSet,
	          caption: caption,
	          orientation: orientation,
	          useForDemo: true
	        };
	      })
	    }),
	    _react2.default.createElement(
	      DownloadAllContainer,
	      null,
	      _react2.default.createElement(DownloadAll, {
	        label: 'Alle herunterladen',
	        href: '/downloads/Familien_und_Flucht_aus_der_DDR_Folien.zip',
	        download: 'Familien und Flucht aus der DDR Folien.zip'
	      })
	    ),
	    _react2.default.createElement(StacheldrahtBottom, { small: true })
	  );
	};
	
	/*
	    <Gallery images={DEFAULT_IMAGES.map(({ caption, id, orientation, useForDemo }) => ({
	      src: makeUnsplashSrc(id),
	      thumbnail: makeUnsplashThumbnail(id, orientation),
	      srcSet: [
	        makeUnsplashSrcSet(id, 1024),
	        makeUnsplashSrcSet(id, 800),
	        makeUnsplashSrcSet(id, 500),
	        makeUnsplashSrcSet(id, 320),
	      ],
	      caption,
	      orientation,
	      useForDemo,
	    }))}
	    />
	*/
	
	exports.default = SmartboardGallery;
	module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SmartboardGallery = __webpack_require__(235);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SmartboardGallery).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: ', 'px;\n  margin-top: ', ';\n  max-width: 100%;\n  overflow: hidden;\n'], ['\n  height: ', 'px;\n  margin-top: ', ';\n  max-width: 100%;\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: ', 'px;\n  height: ', 'px;\n  max-width: 100%;\n\n  ', ' {\n    max-width: ', 'px;\n    min-width: 100%;\n  }\n\n  margin-left: auto;\n  margin-right: auto;\n\n  background-position: ', ';\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(', ');\n\n  @media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n         only screen and (min-resolution: 144dpi),\n  {\n    background-image: url(', ');\n  }\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  max-width: 100%;\n\n  ', ' {\n    max-width: ', 'px;\n    min-width: 100%;\n  }\n\n  margin-left: auto;\n  margin-right: auto;\n\n  background-position: ', ';\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(', ');\n\n  @media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n         only screen and (min-resolution: 144dpi),\n  {\n    background-image: url(', ');\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _breakpoints = __webpack_require__(4);
	
	var _stacheldraht_gr = __webpack_require__(441);
	
	var _stacheldraht_gr2 = _interopRequireDefault(_stacheldraht_gr);
	
	var _stacheldraht_gr2x = __webpack_require__(442);
	
	var _stacheldraht_gr2x2 = _interopRequireDefault(_stacheldraht_gr2x);
	
	var _stacheldrahtKl = __webpack_require__(439);
	
	var _stacheldrahtKl2 = _interopRequireDefault(_stacheldrahtKl);
	
	var _stacheldrahtKl2x = __webpack_require__(440);
	
	var _stacheldrahtKl2x2 = _interopRequireDefault(_stacheldrahtKl2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IMAGE = {
	  big: {
	    width: 1182,
	    height: 89,
	    phoneScale: 0.5,
	    '1x': _stacheldraht_gr2.default,
	    '2x': _stacheldraht_gr2x2.default
	  },
	  small: {
	    width: 491,
	    height: 130,
	    phoneScale: 0.6,
	    '1x': _stacheldrahtKl2.default,
	    '2x': _stacheldrahtKl2x2.default
	  }
	};
	
	var getImage = function getImage(small, prop) {
	  return IMAGE[small ? 'small' : 'big'][prop];
	};
	
	var Container = _styled2.default.div(_templateObject, function (_ref) {
	  var small = _ref.small;
	  return getImage(small, 'height');
	}, function (_ref2) {
	  var small = _ref2.small;
	  return '' + (small ? '-60px' : '0');
	});
	
	var Content = _styled2.default.div(_templateObject2, function (_ref3) {
	  var small = _ref3.small;
	  return getImage(small, 'width');
	}, function (_ref4) {
	  var small = _ref4.small;
	  return getImage(small, 'height');
	}, _breakpoints.mediaPhone, function (_ref5) {
	  var small = _ref5.small;
	  return Math.round(getImage(small, 'width') * getImage(small, 'phoneScale'));
	}, function (_ref6) {
	  var left = _ref6.left;
	  return left ? 'left' : 'center center';
	}, function (_ref7) {
	  var small = _ref7.small;
	  return getImage(small, '1x');
	}, function (_ref8) {
	  var small = _ref8.small;
	  return getImage(small, '2x');
	});
	
	var Stacheldraht = function Stacheldraht(_ref9) {
	  var left = _ref9.left,
	      small = _ref9.small,
	      className = _ref9.className;
	  return _react2.default.createElement(
	    Container,
	    { small: small, className: className },
	    _react2.default.createElement(Content, { small: small, left: left })
	  );
	};
	
	Stacheldraht.propTypes = {
	  left: _propTypes2.default.bool,
	  small: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	Stacheldraht.defaultProps = {
	  left: false,
	  small: false,
	  className: undefined
	};
	
	exports.default = Stacheldraht;
	module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  title: 'Zum Umgang mit Fluchterfahrungen',
	  items: [{
	    type: 'pdf',
	    body: 'Hinweis, welche LEs weggelassen/abgeändert werden könnten, sofern Fluchterfahrungen in der Klasse vorhanden sind.',
	    url: ['/downloads/Merkblatt-1_Besonderheiten_in_der_schulischen_Arbeit_mit_Kindern_mit_Fluchterfahrung.pdf', '/downloads/Merkblatt-2_Arbeiten_mit_traumatisierten_Kindern.pdf']
	  }]
	}, {
	  title: 'Zum Thema Zeitzeugengespr&auml;che',
	  items: [{
	    type: 'pdf',
	    body: 'Kontakt zum Koordinierenden Zeitzeugenbüro (KZB) für Zeitzeugengespräche, die vermittelt und finanziert werden können',
	    url: 'http://www.zeitzeugenbuero.de/fileadmin/zzp/pdf/Finanzierung_und_Abrechnung_von_Zeitzeugengespr%C3%A4chen_in_Schulen.pdf'
	  }, {
	    type: 'link',
	    body: 'Lehrer-Leitfaden zur Durchführung von Zeitzeugengesprächen',
	    url: 'https://www.bundesstiftung-aufarbeitung.de/forschung%2C-lehre-und-bildung-foerdern-2475.html?PAGE=artikel_detail&artikel_id=351'
	  }, {
	    type: 'pdf',
	    body: 'Zeitzeugenbroschüre von CARE',
	    url: '/downloads/care-zeitzeugenbroschuere-web.pdf'
	  }, {
	    type: 'video',
	    body: 'Informationen über Stasi und Zeitzeuge Hartmut Rosinger (ex-IM) im Film „Feindberührung“',
	    url: 'http://www.feindberuehrungfilm.de/'
	  }]
	}, {
	  title: 'Quellmaterial f&uuml;r weitere Aufgaben',
	  items: [{
	    type: 'link',
	    body: 'Zur besseren Visualisierung von historischen Ereignissen, können Sie Ihren Zeitstrahl mit zeitgenössischen Bildern ergänzen. Bilder finden Sie online im Münchner Digitalisierungszentrum',
	    url: 'https://www.digitale-sammlungen.de/index.html?c=startseite&l=de'
	  }]
	}, {
	  title: 'Weiterf&uuml;hrende Unterrichtsmaterialien',
	  items: [{
	    type: 'link',
	    body: 'Für die Vertiefung des Themas Freizügigkeit und Mobilität in Europa: Unterrichtsmaterial: „Sophie und Paul entdecken Europa“',
	    url: 'https://publications.europa.eu/de/publication-detail/-/publication/e05d8afe-03da-11e7-8a35-01aa75ed71a1'
	  }, {
	    type: 'pdf',
	    body: 'Zur Vertiefung des Themas Grundrechte und Kinderrechte: Übungen bei CARE(KIWI 2.1.1.: Wertepyramide; 2.4.1. Menschenrechte; 2.1.5. Kinderrechte, „Hänsel und Gretel“-Geschichte als STOP-Spiel)',
	    url: ['/downloads/2.1.1.Wertepyramide.pdf', '/downloads/2.1.5.Kinderrechte.pdf', '/downloads/2.4.1.Menschenrechte.pdf', '/downloads/2.4.1.Menschenrechte+Erklärung.pdf']
	  }, {
	    type: 'pdf',
	    body: 'Der Volksaufstand vom Juni 1953 kann SuS der 3.–6. Klasse über ein Planspiel nähergebracht werden. In Rollenspielen lernen die Schülerinnen und Schüler die schwierigen Lebensumstände, Nahrungsmittelengpässe und die Diktatur in der DDR der 1950er Jahre kennen. Spielanleitungen, Arbeitsblätter und weitere Materialien helfen Ihnen, die Auseinandersetzung mit einer der wichtigsten Zäsuren der deutschen Nachkriegsgeschichte im Klassenzimmer vor- und nachzubereiten. Das Planspiel kann im Laufe eines Projekttages, einer Projektwoche oder auch im regulären Unterricht genutzt werden. Das Planspiel zum Download:',
	    url: 'https://www.bundesstiftung-aufarbeitung.de/uploads/2013-pdf/capito_17juni_planspiel.pdf'
	  }, {
	    type: 'pdf',
	    body: 'Das Unterrichtsheft „Wir feiern die Einheit“ beinhaltet eine Lerneinheit für Grundschulen mit didaktischer Einführung und Arbeitsblättern, die die deutsche Teilungsgeschichte behandeln. Mauerbau, Alltag in der Diktatur und das Aufbegehren der DDR-Bevölkerung werden ebenso thematisiert wie die Friedliche Revolution und Deutsche Einheit. Enthalten ist zudem das Spiel „DIE MAUER MUSS WEG!“, geeignet für den Einsatz in Gruppen bzw. der Schulklasse. Das Unterrichtsmaterial zum Download:',
	    url: 'https://www.bundesstiftung-aufarbeitung.de/uploads/pdf-2010/wirfeiern.pdf'
	  }, {
	    type: 'pdf',
	    body: '„Paul & Emilia auf Spurensuche – Ein Koffer voll Geschichte“ ist ein Comic mit begleitenden Unterrichtsimpulsen: Indem Paul und Emilia im Erinnerungsschatz ihrer Großeltern forschen, erhalten Schülerinnen und Schüler der Klassen 3 bis 6 einen altersgerechten Zugang zur DDR-Geschichte. Sie lernen das Alltagsleben der DDR kennen und werden mit den wichtigsten politischen Ereignissen der deutschen Teilungs- und Einheitsgeschichte vertraut gemacht. Das Unterrichtsmaterial und der Comic zum Download:',
	    url: ['http://www.capito.de/fileadmin/capito/projekte_paedagogen/Bundesstiftung_Aufarbeitung/Paul-und-Emilia/capito_Paul-und-Emilia_Unterrichtsmaterial.pdf', 'http://www.capito.de/fileadmin/capito/projekte_paedagogen/Bundesstiftung_Aufarbeitung/Paul-und-Emilia/capito_Paul-und-Emilia_Comic_komplett.pdf']
	  }]
	}, {
	  title: 'Exkursions-Tipps',
	  items: [{
	    body: 'Vielleicht gibt es die Möglichkeit, Grenzorte in Ihrer Umgebung zu besichtigen oder einen Besuch während einer mehrtägigen Klassenfahrt einzuplanen. Über Stichworte sind entsprechende Webseiten im Internet leicht aufzufinden, z. B. Harzer Grenzweg am „Grünen Band“ https://www.harzinfo.de/natur-pur/gruenes-band.html oder Ausflugsziele Harz http://www.ausflugsziele-harz.de/ausflugsziele-sehenswertes/wandern-biken/harzer-grenzweg.htm'
	  }, {
	    body: 'In Berlin ist das Angebot für Klassenbesuche besonders reichhaltig. Hier bieten sich Besuche in der Gedenkstätte Berliner Mauer, im Mauermuseum am Checkpoint Charlie, im Tränenpalast oder im Notaufnahmelager Marienfelde an. Weitere Angebote finden sich auf dem Stadtportal oder in anderen Auflistungen:'
	  }, {
	    type: 'link',
	    body: 'Gedenkstätte Berliner Mauer',
	    url: 'https://berliner-mauer-gedenkstaette.de/de/'
	  }, {
	    type: 'link',
	    body: 'Mauermuseum am Checkpoint Charlie',
	    url: 'https://www.mauermuseum.de'
	  }, {
	    type: 'link',
	    body: 'Tränenpalast (der Stiftung Haus der Geschichte der Bundesrepublik Deutschland)',
	    url: 'https://www.hdg.de/traenenpalast/ausstellung/'
	  }, {
	    type: 'link',
	    body: 'Mit aktuellen Veranstaltungstipps: Stadtportal Berlin',
	    url: 'https://www.berlin.de/mauer/'
	  }, {
	    type: 'link',
	    body: 'Top10 Liste: Berliner Mauer – Orte',
	    url: 'https://www.top10berlin.de/de/cat/freizeit-268/berliner-mauer-orte-745'
	  }]
	}, {
	  title: 'Literaturtipps',
	  items: [{
	    body: '„Anne Frank, die Mauer und ich. Zeitgeschichtliches Lernen zu Nationalsozialismus und DDR-Geschichte mit Kindern in Schule, Museum und Gedenkstätte“, Tagung der Bundeszentrale für Politische Bildung, der Humboldt-Universität zu Berlin und dem Anne Frank Zentrum, November 2015'
	  }, {
	    body: 'Zu DDR-Geschichte und Geschichtsthemen im Sachunterricht, siehe verschiedene Ausgaben von http://www.widerstreit-sachunterricht.de, so beispielsweise von Monika Pape, „Geschichtsbewusstsein im Grundschulalter: Eine empirische Studie“, Ausgabe 11/Oktober 2008.'
	  }, {
	    body: 'Kinderkrimi ab 10 Jahre: Ute Krause: Im Labyrinth der Lügen, München 2016.'
	  }, {
	    body: 'Bände der Enquete-Kommission zur Aufarbeitung der SED-Diktatur https://enquete-online.de'
	  }]
	}];
	module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  id: 'LE1',
	  title: 'Familien: Verteilung, Kommunikation und Mobilit&auml;t',
	  items: [{
	    type: 'pdf',
	    body: 'Übung „Meine Wurzeln“ aus dem Integrationsprojekt KIWI „Kinder und Jugendliche Willkommen“ der Hilfsorganisation CARE Deutschland-Luxemburg e. V.',
	    url: '/downloads/1.1.1.Meine_Wurzeln.pdf'
	  }, {
	    type: 'link',
	    body: 'Bestellmöglichkeit für eine kostenfreie Europakarte bei der Bundeszentrale für politische Bildung',
	    url: 'http://www.bpb.de/shop/lernen/karten/34305/faltkarte-europa'
	  }]
	}, {
	  id: 'LE2',
	  title: 'Mobilit&auml;t, Flucht und Grundrechte',
	  items: [{
	    type: 'pdf',
	    body: 'Informationen zu „Push“- und „Pull“-Faktoren bei Flucht und Migration',
	    url: '/downloads/Push_Pull_Definition.pdf'
	  }, {
	    type: 'link',
	    body: 'Definition Migration',
	    url: 'https://e-politik.de/projekte/wissenswerte-infografiken/'
	  }, {
	    type: 'pdf',
	    body: 'Erklärung der Menschenrechte von den Vereinten Nationen',
	    url: 'http://www.un.org/depts/german/menschenrechte/aemr.pdf'
	  }, {
	    type: 'link',
	    body: 'Flüchtlinge: Definition und Erklärungen der UNHCR',
	    url: 'http://www.unhcr.org/dach/de/services/faq/faq-fluechtlinge'
	  }]
	}, {
	  id: 'LE3',
	  title: 'Einschr&auml;nkung von Freiz&uuml;gigkeit in der DDR',
	  items: [{
	    type: 'link',
	    body: 'Geschichte von Wolfgang',
	    url: 'http://www.spiegel.de/einestages/fluechtlingsschicksal-a-949975.html'
	  }, {
	    type: 'link',
	    body: 'Geschichte von Lena',
	    url: ['https://www.bstu.bund.de/DE/BundesbeauftragterUndBehoerde/Aktuelles/20180216_das_schweigende_klassenzimmer.html', 'https://www.jugendopposition.de/themen/145437/fuenf-minuten-schweigen-fuer-ungarn']
	  }, {
	    type: 'link',
	    body: 'Bericht vom Deutschlandfunk zur Attraktivität von Diktaturen für Kinder und Jugendliche',
	    url: 'http://www.deutschlandfunkkultur.de/wenn-die-gespielte-diktatur-wirklichkeit-wird.1216.de.html?dram:article_id=188287'
	  }, {
	    type: 'link',
	    body: 'Informationen zu den Notaufnahmelagern: Berlin',
	    url: 'http://www.notaufnahmelager-berlin.de/de/sonderausstellungen-21.html'
	  }, {
	    type: 'link',
	    body: 'Informationen zu den Notaufnahmelagern: Marienfelde',
	    url: 'http://www.bpb.de/gesellschaft/migration/kurzdossiers/239167/marienfelde?p=all'
	  }]
	}, {
	  id: 'LE4',
	  title: 'Republikflucht als Verbrechen',
	  items: [{
	    body: 'Zu den Zahlen auf AB4 (Quelle: Bundesausgleichsamt) siehe: Hans-Hermann Hertle, Chronik des Mauerfalls, 8. Aufl., Berlin 1999, S. 320 [12. Aufl., Berlin 2009, S. 344].'
	  }, {
	    type: 'link',
	    body: 'Stasi-Mediathek',
	    url: 'https://www.stasi-mediathek.de'
	  }, {
	    type: 'pdf',
	    body: 'Stasi-Mediathek: Bericht über die Situation an der Grenze der DDR zur Bundesrepublik im Juli 1961',
	    url: 'https://www.stasi-mediathek.de/fileadmin/pdf/dok164.pdf'
	  }, {
	    type: 'pdf',
	    body: 'Stasi-Mediathek: Bericht über die Entwicklung der Republikflucht 1960',
	    url: 'https://www.stasi-mediathek.de/fileadmin/pdf/dok165.pdf'
	  }, {
	    type: 'pdf',
	    body: 'Stasi-Mediathek: Bericht über Republikfluchten nach dem Bau der Mauer',
	    url: 'https://www.stasi-mediathek.de/fileadmin/pdf/dok97.pdf'
	  }, {
	    type: 'pdf',
	    body: 'Die Methoden der Stasi (BSTU)',
	    url: 'https://www.bstu.de/assets/bstu/de/Downloads/schulausstellung_vertiefung-zum-poster_die-methoden-der-stasi.pdf'
	  }, {
	    type: 'link',
	    body: 'Glossar Rebublikflucht',
	    url: 'https://www.bstu.bund.de/SharedDocs/Glossareintraege/DE/R/republikflucht.html'
	  }]
	}, {
	  id: 'LE5',
	  title: 'Flucht, Opposition oder Arrangement',
	  items: [{
	    type: 'image',
	    body: 'Artikel über Rainer Beck vom 20. Okt. 2004',
	    url: '/downloads/RainerBeck.jpg'
	  }, {
	    type: 'link',
	    body: 'Geschichte von Karlheinz Breinig',
	    url: 'https://www.zeitzeugenbuero.de/index.php?id=detail&tx_zrwzeitzeugen_zeitzeugen%5Buid%5D=313&tx_zrwzeitzeugen_zeitzeugen%5Bcontroller%5D=Zeitzeugen'
	  }, {
	    type: 'link',
	    body: 'Artikel über Stefan Wolle im Tagesspiegel vom 26.07.2009',
	    url: 'https://www.tagesspiegel.de/politik/abgehauen-in-der-opposition-war-die-ddr-flucht-umstritten/1566028.html'
	  }, {
	    type: 'link',
	    body: 'Artikel über Rainer Eckart in der Zeit vom Juli 2009',
	    url: 'https://www.zeit.de/online/2009/31/ddr-opposition-wende/seite-2'
	  }, {
	    type: 'link',
	    body: 'Statistik zu Übersiedlern und Flüchtlingen aus der DDR (1961–1990)',
	    url: 'http://www.chronik-der-mauer.de/material/178768/uebersiedler-und-fluechtlinge-aus-der-ddr-1961-1990'
	  }]
	}, {
	  id: 'LE6',
	  title: 'Fluchtwege',
	  items: [{
	    type: 'link',
	    body: 'Verschiedene Fluchtgeschichten',
	    url: 'http://www.chronik-der-mauer.de/fluchten/'
	  }]
	}, {
	  id: 'LE7',
	  title: 'Fluchthelfer',
	  items: [{
	    type: 'link',
	    body: 'Geschichten der deutsch-deutschen Fluchthilfe in der Online-Ausstellung der Stiftung Berliner Mauer',
	    url: 'https://www.risiko-freiheit.de'
	  }, {
	    type: 'link',
	    body: 'Artikel über Maikes Flucht in der BZ vom 18.12.2005',
	    url: 'https://www.bz-berlin.de/artikel-archiv/flucht-mit-kind-im-koffer'
	  }, {
	    type: 'video',
	    body: 'Musikvideo „Sommer ’89“ von Kettcar auf Youtube',
	    url: 'https://www.youtube.com/watch?v=q5qRbbive6o'
	  }]
	}, {
	  id: 'LE8',
	  title: 'Flucht &uuml;ber die Botschaft in Prag und &Ouml;ffnung der Grenzen',
	  items: [{
	    type: 'link',
	    body: 'Die Geschichte von David Altheide im Handelsblatt vom 18.10.2014',
	    url: 'http://www.handelsblatt.com/politik/deutschland/mauerfall/ddr-flucht-als-kind-wenn-die-freiheit-nach-joghurt-schmeckt/10844622.html'
	  }]
	}];
	module.exports = exports['default'];

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-bottom: 66px;\n'], ['\n  margin-bottom: 66px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styled = __webpack_require__(3);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _AboutMaterialDownload = __webpack_require__(201);
	
	var _AboutMaterialDownload2 = _interopRequireDefault(_AboutMaterialDownload);
	
	var _Impressum = __webpack_require__(215);
	
	var _Impressum2 = _interopRequireDefault(_Impressum);
	
	var _PageHeader = __webpack_require__(224);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _PageMainLayout = __webpack_require__(227);
	
	var _PageMainLayout2 = _interopRequireDefault(_PageMainLayout);
	
	var _ProjectPartners = __webpack_require__(229);
	
	var _ProjectPartners2 = _interopRequireDefault(_ProjectPartners);
	
	var _ProofOfSources = __webpack_require__(231);
	
	var _ProofOfSources2 = _interopRequireDefault(_ProofOfSources);
	
	var _RelatedMaterials = __webpack_require__(233);
	
	var _RelatedMaterials2 = _interopRequireDefault(_RelatedMaterials);
	
	var _SmartboardGallery = __webpack_require__(236);
	
	var _SmartboardGallery2 = _interopRequireDefault(_SmartboardGallery);
	
	var _Stacheldraht = __webpack_require__(15);
	
	var _Stacheldraht2 = _interopRequireDefault(_Stacheldraht);
	
	var _SOURCES = __webpack_require__(239);
	
	var _SOURCES2 = _interopRequireDefault(_SOURCES);
	
	var _MORE_SOURCES = __webpack_require__(238);
	
	var _MORE_SOURCES2 = _interopRequireDefault(_MORE_SOURCES);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import BreakpointDisplay from '../components/BreakpointDisplay';
	
	
	var Footer = _styled2.default.footer(_templateObject);
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_PageHeader2.default, null),
	    _react2.default.createElement(
	      _PageMainLayout2.default,
	      null,
	      _react2.default.createElement(_AboutMaterialDownload2.default, null),
	      _react2.default.createElement(_SmartboardGallery2.default, null),
	      _react2.default.createElement(_ProofOfSources2.default, { sources: _SOURCES2.default }),
	      _react2.default.createElement(_RelatedMaterials2.default, { sources: _MORE_SOURCES2.default })
	    ),
	    _react2.default.createElement(
	      Footer,
	      null,
	      _react2.default.createElement(_ProjectPartners2.default, null),
	      _react2.default.createElement(_Stacheldraht2.default, null),
	      _react2.default.createElement(_Impressum2.default, null)
	    )
	  );
	};
	// <BreakpointDisplay />
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createCache = _interopDefault(__webpack_require__(121));
	var serialize = __webpack_require__(58);
	var utils = __webpack_require__(77);
	
	function insertWithoutScoping(cache, serialized) {
	  if (cache.inserted[serialized.name] === undefined) {
	    return cache.insert('', serialized, cache.sheet, true);
	  }
	}
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var createEmotion = function createEmotion(options) {
	  var cache = createCache(options); // $FlowFixMe
	
	  cache.sheet.speedy = function (value) {
	    if (false) {
	      throw new Error('speedy must be changed before any rules are inserted');
	    }
	
	    this.isSpeedy = value;
	  };
	
	  cache.compat = true;
	
	  var css = function css() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var serialized = serialize.serializeStyles(args, cache.registered, this !== undefined ? this.mergedProps : undefined);
	    utils.insertStyles(cache, serialized, false);
	    return cache.key + "-" + serialized.name;
	  };
	
	  var keyframes = function keyframes() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var serialized = serialize.serializeStyles(args, cache.registered);
	    var animation = "animation-" + serialized.name;
	    insertWithoutScoping(cache, {
	      name: serialized.name,
	      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
	    });
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    var serialized = serialize.serializeStyles(args, cache.registered);
	    insertWithoutScoping(cache, serialized);
	  };
	
	  var cx = function cx() {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return merge(cache.registered, css, classnames(args));
	  };
	
	  return {
	    css: css,
	    cx: cx,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    hydrate: function hydrate(ids) {
	      ids.forEach(function (key) {
	        cache.inserted[key] = true;
	      });
	    },
	    flush: function flush() {
	      cache.registered = {};
	      cache.inserted = {};
	      cache.sheet.flush();
	    },
	    // $FlowFixMe
	    sheet: cache.sheet,
	    cache: cache,
	    getRegisteredStyles: utils.getRegisteredStyles.bind(null, cache.registered),
	    merge: merge.bind(null, cache.registered, css)
	  };
	};
	
	var classnames = function classnames(args) {
	  var cls = '';
	
	  for (var i = 0; i < args.length; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	exports.default = createEmotion;


/***/ }),
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function _interopDefault(ex) {
	  return ex && "object" == typeof ex && "default" in ex ? ex.default : ex;
	}
	Object.defineProperty(exports, "__esModule", { value: !0 });
	var createEmotion = _interopDefault(__webpack_require__(313)),
	  _createEmotion = createEmotion(),
	  flush = _createEmotion.flush,
	  hydrate = _createEmotion.hydrate,
	  cx = _createEmotion.cx,
	  merge = _createEmotion.merge,
	  getRegisteredStyles = _createEmotion.getRegisteredStyles,
	  injectGlobal = _createEmotion.injectGlobal,
	  keyframes = _createEmotion.keyframes,
	  css = _createEmotion.css,
	  sheet = _createEmotion.sheet,
	  cache = _createEmotion.cache;
	(exports.flush = flush),
	  (exports.hydrate = hydrate),
	  (exports.cx = cx),
	  (exports.merge = merge),
	  (exports.getRegisteredStyles = getRegisteredStyles),
	  (exports.injectGlobal = injectGlobal),
	  (exports.keyframes = keyframes),
	  (exports.css = css),
	  (exports.sheet = sheet),
	  (exports.cache = cache);


/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, exports) {

	module.exports = [{"src":"/smartboard/images/out/Familie_Flucht_Cover_Illu_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_Cover_Illu_1024.png 1024w","/smartboard/images/out/Familie_Flucht_Cover_Illu_800.png 800w","/smartboard/images/out/Familie_Flucht_Cover_Illu_500.png 500w","/smartboard/images/out/Familie_Flucht_Cover_Illu_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_Cover_Illu_480x318.png","caption":"Familien und Flucht","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB1_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB1_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB1_800.png 800w","/smartboard/images/out/Familie_Flucht_AB1_500.png 500w","/smartboard/images/out/Familie_Flucht_AB1_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB1_480x318.png","caption":"Familien und Flucht AB1","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB2_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB2_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB2_800.png 800w","/smartboard/images/out/Familie_Flucht_AB2_500.png 500w","/smartboard/images/out/Familie_Flucht_AB2_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB2_480x318.png","caption":"Familien und Flucht AB2","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB3_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB3_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB3_800.png 800w","/smartboard/images/out/Familie_Flucht_AB3_500.png 500w","/smartboard/images/out/Familie_Flucht_AB3_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB3_480x318.png","caption":"Familien und Flucht AB3","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB4_1_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB4_1_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB4_1_800.png 800w","/smartboard/images/out/Familie_Flucht_AB4_1_500.png 500w","/smartboard/images/out/Familie_Flucht_AB4_1_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB4_1_480x318.png","caption":"Familien und Flucht AB4_1","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB4_2_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB4_2_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB4_2_800.png 800w","/smartboard/images/out/Familie_Flucht_AB4_2_500.png 500w","/smartboard/images/out/Familie_Flucht_AB4_2_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB4_2_480x318.png","caption":"Familien und Flucht AB4_2","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB5_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB5_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB5_800.png 800w","/smartboard/images/out/Familie_Flucht_AB5_500.png 500w","/smartboard/images/out/Familie_Flucht_AB5_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB5_480x318.png","caption":"Familien und Flucht AB5","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB6_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB6_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB6_800.png 800w","/smartboard/images/out/Familie_Flucht_AB6_500.png 500w","/smartboard/images/out/Familie_Flucht_AB6_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB6_480x318.png","caption":"Familien und Flucht AB6","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB7_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB7_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB7_800.png 800w","/smartboard/images/out/Familie_Flucht_AB7_500.png 500w","/smartboard/images/out/Familie_Flucht_AB7_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB7_480x318.png","caption":"Familien und Flucht AB7","orientation":"landscape"},{"src":"/smartboard/images/out/Familie_Flucht_AB8_1024.png","srcSet":["/smartboard/images/out/Familie_Flucht_AB8_1024.png 1024w","/smartboard/images/out/Familie_Flucht_AB8_800.png 800w","/smartboard/images/out/Familie_Flucht_AB8_500.png 500w","/smartboard/images/out/Familie_Flucht_AB8_320.png 320w"],"thumbnail":"/smartboard/images/thumbnail/Familie_Flucht_AB8_480x318.png","caption":"Familien und Flucht AB8","orientation":"landscape"}]

/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aphrodite = __webpack_require__(78);
	
	var _reactScrolllock = __webpack_require__(398);
	
	var _reactScrolllock2 = _interopRequireDefault(_reactScrolllock);
	
	var _theme = __webpack_require__(22);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Arrow = __webpack_require__(166);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _Container = __webpack_require__(365);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Footer = __webpack_require__(366);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(367);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _PaginatedThumbnails = __webpack_require__(368);
	
	var _PaginatedThumbnails2 = _interopRequireDefault(_PaginatedThumbnails);
	
	var _Portal = __webpack_require__(370);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Spinner = __webpack_require__(371);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _bindFunctions = __webpack_require__(376);
	
	var _bindFunctions2 = _interopRequireDefault(_bindFunctions);
	
	var _canUseDom = __webpack_require__(377);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _deepMerge = __webpack_require__(45);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// consumers sometimes provide incorrect type or casing
	function normalizeSourceSet(data) {
		var sourceSet = data.srcSet || data.srcset;
	
		if (Array.isArray(sourceSet)) {
			return sourceSet.join();
		}
	
		return sourceSet;
	}
	
	var Lightbox = function (_Component) {
		_inherits(Lightbox, _Component);
	
		function Lightbox(props) {
			_classCallCheck(this, Lightbox);
	
			var _this = _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call(this, props));
	
			_this.theme = (0, _deepMerge2.default)(_theme2.default, props.theme);
			_this.classes = _aphrodite.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, _this.theme));
			_this.state = { imageLoaded: false };
	
			_bindFunctions2.default.call(_this, ['gotoNext', 'gotoPrev', 'closeBackdrop', 'handleKeyboardInput', 'handleImageLoaded']);
			return _this;
		}
	
		_createClass(Lightbox, [{
			key: 'getChildContext',
			value: function getChildContext() {
				return {
					theme: this.theme
				};
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.isOpen) {
					if (this.props.enableKeyboardInput) {
						window.addEventListener('keydown', this.handleKeyboardInput);
					}
					if (typeof this.props.currentImage === 'number') {
						this.preloadImage(this.props.currentImage, this.handleImageLoaded);
					}
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!_canUseDom2.default) return;
	
				// preload images
				if (nextProps.preloadNextImage) {
					var currentIndex = this.props.currentImage;
					var nextIndex = nextProps.currentImage + 1;
					var prevIndex = nextProps.currentImage - 1;
					var preloadIndex = void 0;
	
					if (currentIndex && nextProps.currentImage > currentIndex) {
						preloadIndex = nextIndex;
					} else if (currentIndex && nextProps.currentImage < currentIndex) {
						preloadIndex = prevIndex;
					}
	
					// if we know the user's direction just get one image
					// otherwise, to be safe, we need to grab one in each direction
					if (preloadIndex) {
						this.preloadImage(preloadIndex);
					} else {
						this.preloadImage(prevIndex);
						this.preloadImage(nextIndex);
					}
				}
	
				// preload current image
				if (this.props.currentImage !== nextProps.currentImage || !this.props.isOpen && nextProps.isOpen) {
					var img = this.preloadImageData(nextProps.images[nextProps.currentImage], this.handleImageLoaded);
					if (img) this.setState({ imageLoaded: img.complete });
				}
	
				// add/remove event listeners
				if (!this.props.isOpen && nextProps.isOpen && nextProps.enableKeyboardInput) {
					window.addEventListener('keydown', this.handleKeyboardInput);
				}
				if (!nextProps.isOpen && nextProps.enableKeyboardInput) {
					window.removeEventListener('keydown', this.handleKeyboardInput);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.props.enableKeyboardInput) {
					window.removeEventListener('keydown', this.handleKeyboardInput);
				}
			}
	
			// ==============================
			// METHODS
			// ==============================
	
		}, {
			key: 'preloadImage',
			value: function preloadImage(idx, onload) {
				return this.preloadImageData(this.props.images[idx], onload);
			}
		}, {
			key: 'preloadImageData',
			value: function preloadImageData(data, onload) {
				if (!data) return;
				var img = new Image();
				var sourceSet = normalizeSourceSet(data);
	
				// TODO: add error handling for missing images
				img.onerror = onload;
				img.onload = onload;
				img.src = data.src;
	
				if (sourceSet) img.srcset = sourceSet;
	
				return img;
			}
		}, {
			key: 'gotoNext',
			value: function gotoNext(event) {
				var _props = this.props,
				    currentImage = _props.currentImage,
				    images = _props.images;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!imageLoaded || currentImage === images.length - 1) return;
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				this.props.onClickNext();
			}
		}, {
			key: 'gotoPrev',
			value: function gotoPrev(event) {
				var currentImage = this.props.currentImage;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!imageLoaded || currentImage === 0) return;
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				this.props.onClickPrev();
			}
		}, {
			key: 'closeBackdrop',
			value: function closeBackdrop(event) {
				// make sure event only happens if they click the backdrop
				// and if the caption is widening the figure element let that respond too
				if (event.target.id === 'lightboxBackdrop' || event.target.tagName === 'FIGURE') {
					this.props.onClose();
				}
			}
		}, {
			key: 'handleKeyboardInput',
			value: function handleKeyboardInput(event) {
				if (event.keyCode === 37) {
					// left
					this.gotoPrev(event);
					return true;
				} else if (event.keyCode === 39) {
					// right
					this.gotoNext(event);
					return true;
				} else if (event.keyCode === 27) {
					// esc
					this.props.onClose();
					return true;
				}
				return false;
			}
		}, {
			key: 'handleImageLoaded',
			value: function handleImageLoaded() {
				this.setState({ imageLoaded: true });
			}
	
			// ==============================
			// RENDERERS
			// ==============================
	
		}, {
			key: 'renderArrowPrev',
			value: function renderArrowPrev() {
				if (this.props.currentImage === 0) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'left',
					icon: 'arrowLeft',
					onClick: this.gotoPrev,
					title: this.props.leftArrowTitle,
					type: 'button'
				});
			}
		}, {
			key: 'renderArrowNext',
			value: function renderArrowNext() {
				if (this.props.currentImage === this.props.images.length - 1) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'right',
					icon: 'arrowRight',
					onClick: this.gotoNext,
					title: this.props.rightArrowTitle,
					type: 'button'
				});
			}
		}, {
			key: 'renderDialog',
			value: function renderDialog() {
				var _props2 = this.props,
				    backdropClosesModal = _props2.backdropClosesModal,
				    isOpen = _props2.isOpen,
				    showThumbnails = _props2.showThumbnails,
				    width = _props2.width;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!isOpen) return _react2.default.createElement('span', { key: 'closed' });
	
				var offsetThumbnails = 0;
				if (showThumbnails) {
					offsetThumbnails = this.theme.thumbnail.size + this.theme.container.gutter.vertical;
				}
	
				return _react2.default.createElement(
					_Container2.default,
					{
						key: 'open',
						onClick: backdropClosesModal && this.closeBackdrop,
						onTouchEnd: backdropClosesModal && this.closeBackdrop
					},
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: (0, _aphrodite.css)(this.classes.content), style: { marginBottom: offsetThumbnails, maxWidth: width } },
							imageLoaded && this.renderHeader(),
							this.renderImages(),
							this.renderSpinner(),
							imageLoaded && this.renderFooter()
						),
						imageLoaded && this.renderThumbnails(),
						imageLoaded && this.renderArrowPrev(),
						imageLoaded && this.renderArrowNext(),
						this.props.preventScroll && _react2.default.createElement(_reactScrolllock2.default, null)
					)
				);
			}
		}, {
			key: 'renderImages',
			value: function renderImages() {
				var _props3 = this.props,
				    currentImage = _props3.currentImage,
				    images = _props3.images,
				    onClickImage = _props3.onClickImage,
				    showThumbnails = _props3.showThumbnails;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!images || !images.length) return null;
	
				var image = images[currentImage];
				var sourceSet = normalizeSourceSet(image);
				var sizes = sourceSet ? '100vw' : null;
	
				var thumbnailsSize = showThumbnails ? this.theme.thumbnail.size : 0;
				var heightOffset = this.theme.header.height + this.theme.footer.height + thumbnailsSize + this.theme.container.gutter.vertical + 'px';
	
				return _react2.default.createElement(
					'figure',
					{ className: (0, _aphrodite.css)(this.classes.figure) },
					_react2.default.createElement('img', {
						className: (0, _aphrodite.css)(this.classes.image, imageLoaded && this.classes.imageLoaded),
						onClick: onClickImage,
						sizes: sizes,
						alt: image.alt,
						src: image.src,
						srcSet: sourceSet,
						style: {
							cursor: onClickImage ? 'pointer' : 'auto',
							maxHeight: 'calc(100vh - ' + heightOffset + ')'
						}
					})
				);
			}
		}, {
			key: 'renderThumbnails',
			value: function renderThumbnails() {
				var _props4 = this.props,
				    images = _props4.images,
				    currentImage = _props4.currentImage,
				    onClickThumbnail = _props4.onClickThumbnail,
				    showThumbnails = _props4.showThumbnails,
				    thumbnailOffset = _props4.thumbnailOffset;
	
	
				if (!showThumbnails) return;
	
				return _react2.default.createElement(_PaginatedThumbnails2.default, {
					currentImage: currentImage,
					images: images,
					offset: thumbnailOffset,
					onClickThumbnail: onClickThumbnail
				});
			}
		}, {
			key: 'renderHeader',
			value: function renderHeader() {
				var _props5 = this.props,
				    closeButtonTitle = _props5.closeButtonTitle,
				    customControls = _props5.customControls,
				    onClose = _props5.onClose,
				    showCloseButton = _props5.showCloseButton;
	
	
				return _react2.default.createElement(_Header2.default, {
					customControls: customControls,
					onClose: onClose,
					showCloseButton: showCloseButton,
					closeButtonTitle: closeButtonTitle
				});
			}
		}, {
			key: 'renderFooter',
			value: function renderFooter() {
				var _props6 = this.props,
				    currentImage = _props6.currentImage,
				    images = _props6.images,
				    imageCountSeparator = _props6.imageCountSeparator,
				    showImageCount = _props6.showImageCount;
	
	
				if (!images || !images.length) return null;
	
				return _react2.default.createElement(_Footer2.default, {
					caption: images[currentImage].caption,
					countCurrent: currentImage + 1,
					countSeparator: imageCountSeparator,
					countTotal: images.length,
					showCount: showImageCount
				});
			}
		}, {
			key: 'renderSpinner',
			value: function renderSpinner() {
				var _props7 = this.props,
				    spinner = _props7.spinner,
				    spinnerColor = _props7.spinnerColor,
				    spinnerSize = _props7.spinnerSize;
				var imageLoaded = this.state.imageLoaded;
	
				var Spinner = spinner;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _aphrodite.css)(this.classes.spinner, !imageLoaded && this.classes.spinnerActive) },
					_react2.default.createElement(Spinner, {
						color: spinnerColor,
						size: spinnerSize
					})
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Portal2.default,
					null,
					this.renderDialog()
				);
			}
		}]);
	
		return Lightbox;
	}(_react.Component);
	
	Lightbox.propTypes = {
		backdropClosesModal: _propTypes2.default.bool,
		closeButtonTitle: _propTypes2.default.string,
		currentImage: _propTypes2.default.number,
		customControls: _propTypes2.default.arrayOf(_propTypes2.default.node),
		enableKeyboardInput: _propTypes2.default.bool,
		imageCountSeparator: _propTypes2.default.string,
		images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			src: _propTypes2.default.string.isRequired,
			srcSet: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
			caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
			thumbnail: _propTypes2.default.string
		})).isRequired,
		isOpen: _propTypes2.default.bool,
		leftArrowTitle: _propTypes2.default.string,
		onClickImage: _propTypes2.default.func,
		onClickNext: _propTypes2.default.func,
		onClickPrev: _propTypes2.default.func,
		onClose: _propTypes2.default.func.isRequired,
		preloadNextImage: _propTypes2.default.bool,
		preventScroll: _propTypes2.default.bool,
		rightArrowTitle: _propTypes2.default.string,
		showCloseButton: _propTypes2.default.bool,
		showImageCount: _propTypes2.default.bool,
		showThumbnails: _propTypes2.default.bool,
		spinner: _propTypes2.default.func,
		spinnerColor: _propTypes2.default.string,
		spinnerSize: _propTypes2.default.number,
		theme: _propTypes2.default.object,
		thumbnailOffset: _propTypes2.default.number,
		width: _propTypes2.default.number
	};
	Lightbox.defaultProps = {
		closeButtonTitle: 'Close (Esc)',
		currentImage: 0,
		enableKeyboardInput: true,
		imageCountSeparator: ' of ',
		leftArrowTitle: 'Previous (Left arrow key)',
		onClickShowNextImage: true,
		preloadNextImage: true,
		preventScroll: true,
		rightArrowTitle: 'Next (Right arrow key)',
		showCloseButton: true,
		showImageCount: true,
		spinner: _Spinner2.default,
		spinnerColor: 'white',
		spinnerSize: 100,
		theme: {},
		thumbnailOffset: 2,
		width: 1024
	};
	Lightbox.childContextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		content: {
			position: 'relative'
		},
		figure: {
			margin: 0 // remove browser default
		},
		image: {
			display: 'block', // removes browser default gutter
			height: 'auto',
			margin: '0 auto', // maintain center on very short screens OR very narrow image
			maxWidth: '100%',
	
			// disable user select
			WebkitTouchCallout: 'none',
			userSelect: 'none',
	
			// opacity animation on image load
			opacity: 0,
			transition: 'opacity 0.3s'
		},
		imageLoaded: {
			opacity: 1
		},
		spinner: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
	
			// opacity animation to make spinner appear with delay
			opacity: 0,
			transition: 'opacity 0.3s',
			pointerEvents: 'none'
		},
		spinnerActive: {
			opacity: 1
		}
	};
	
	exports.default = Lightbox;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(11);
	
	var _theme = __webpack_require__(22);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(45);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Container(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var props = _objectWithoutProperties(_ref, []);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement('div', _extends({ id: 'lightboxBackdrop',
			className: (0, _noImportant.css)(classes.container)
		}, props));
	}
	
	Container.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		container: {
			alignItems: 'center',
			backgroundColor: _theme2.default.container.background,
			boxSizing: 'border-box',
			display: 'flex',
			height: '100%',
			justifyContent: 'center',
			left: 0,
			paddingBottom: _theme2.default.container.gutter.vertical,
			paddingLeft: _theme2.default.container.gutter.horizontal,
			paddingRight: _theme2.default.container.gutter.horizontal,
			paddingTop: _theme2.default.container.gutter.vertical,
			position: 'fixed',
			top: 0,
			width: '100%',
			zIndex: _theme2.default.container.zIndex
		}
	};
	
	exports.default = Container;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(11);
	
	var _theme = __webpack_require__(22);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(45);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Footer(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var caption = _ref.caption,
		    countCurrent = _ref.countCurrent,
		    countSeparator = _ref.countSeparator,
		    countTotal = _ref.countTotal,
		    showCount = _ref.showCount,
		    props = _objectWithoutProperties(_ref, ['caption', 'countCurrent', 'countSeparator', 'countTotal', 'showCount']);
	
		if (!caption && !showCount) return null;
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		var imageCount = showCount ? _react2.default.createElement(
			'div',
			{ className: (0, _noImportant.css)(classes.footerCount) },
			countCurrent,
			countSeparator,
			countTotal
		) : _react2.default.createElement('span', null);
	
		return _react2.default.createElement(
			'div',
			_extends({ className: (0, _noImportant.css)(classes.footer) }, props),
			caption ? _react2.default.createElement(
				'figcaption',
				{ className: (0, _noImportant.css)(classes.footerCaption) },
				caption
			) : _react2.default.createElement('span', null),
			imageCount
		);
	}
	
	Footer.propTypes = {
		caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
		countCurrent: _propTypes2.default.number,
		countSeparator: _propTypes2.default.string,
		countTotal: _propTypes2.default.number,
		showCount: _propTypes2.default.bool
	};
	Footer.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		footer: {
			boxSizing: 'border-box',
			color: _theme2.default.footer.color,
			cursor: 'auto',
			display: 'flex',
			justifyContent: 'space-between',
			left: 0,
			lineHeight: 1.3,
			paddingBottom: _theme2.default.footer.gutter.vertical,
			paddingLeft: _theme2.default.footer.gutter.horizontal,
			paddingRight: _theme2.default.footer.gutter.horizontal,
			paddingTop: _theme2.default.footer.gutter.vertical
		},
		footerCount: {
			color: _theme2.default.footer.count.color,
			fontSize: _theme2.default.footer.count.fontSize,
			paddingLeft: '1em' // add a small gutter for the caption
		},
		footerCaption: {
			flex: '1 1 0'
		}
	};
	
	exports.default = Footer;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(11);
	
	var _theme = __webpack_require__(22);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(45);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	var _Icon = __webpack_require__(167);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Header(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var customControls = _ref.customControls,
		    onClose = _ref.onClose,
		    showCloseButton = _ref.showCloseButton,
		    closeButtonTitle = _ref.closeButtonTitle,
		    props = _objectWithoutProperties(_ref, ['customControls', 'onClose', 'showCloseButton', 'closeButtonTitle']);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement(
			'div',
			_extends({ className: (0, _noImportant.css)(classes.header) }, props),
			customControls ? customControls : _react2.default.createElement('span', null),
			!!showCloseButton && _react2.default.createElement(
				'button',
				{
					title: closeButtonTitle,
					className: (0, _noImportant.css)(classes.close),
					onClick: onClose
				},
				_react2.default.createElement(_Icon2.default, { fill: !!theme.close && theme.close.fill || _theme2.default.close.fill, type: 'close' })
			)
		);
	}
	
	Header.propTypes = {
		customControls: _propTypes2.default.array,
		onClose: _propTypes2.default.func.isRequired,
		showCloseButton: _propTypes2.default.bool
	};
	Header.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		header: {
			display: 'flex',
			justifyContent: 'space-between',
			height: _theme2.default.header.height
		},
		close: {
			background: 'none',
			border: 'none',
			cursor: 'pointer',
			outline: 'none',
			position: 'relative',
			top: 0,
			verticalAlign: 'bottom',
			zIndex: 1,
	
			// increase hit area
			height: 40,
			marginRight: -10,
			padding: 10,
			width: 40
		}
	};
	
	exports.default = Header;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(11);
	
	var _Thumbnail = __webpack_require__(372);
	
	var _Thumbnail2 = _interopRequireDefault(_Thumbnail);
	
	var _Arrow = __webpack_require__(166);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _theme = __webpack_require__(22);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var classes = _noImportant.StyleSheet.create({
		paginatedThumbnails: {
			bottom: _theme2.default.container.gutter.vertical,
			height: _theme2.default.thumbnail.size,
			padding: '0 50px',
			position: 'absolute',
			textAlign: 'center',
			whiteSpace: 'nowrap',
			left: '50%',
			transform: 'translateX(-50%)'
		}
	});
	
	var arrowStyles = {
		height: _theme2.default.thumbnail.size + _theme2.default.thumbnail.gutter * 2,
		width: 40
	};
	
	var PaginatedThumbnails = function (_Component) {
		_inherits(PaginatedThumbnails, _Component);
	
		function PaginatedThumbnails(props) {
			_classCallCheck(this, PaginatedThumbnails);
	
			var _this = _possibleConstructorReturn(this, (PaginatedThumbnails.__proto__ || Object.getPrototypeOf(PaginatedThumbnails)).call(this, props));
	
			_this.state = {
				hasCustomPage: false
			};
	
			_this.gotoPrev = _this.gotoPrev.bind(_this);
			_this.gotoNext = _this.gotoNext.bind(_this);
			return _this;
		}
	
		_createClass(PaginatedThumbnails, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// Component should be controlled, flush state when currentImage changes
				if (nextProps.currentImage !== this.props.currentImage) {
					this.setState({
						hasCustomPage: false
					});
				}
			}
	
			// ==============================
			// METHODS
			// ==============================
	
		}, {
			key: 'getFirst',
			value: function getFirst() {
				var _props = this.props,
				    currentImage = _props.currentImage,
				    offset = _props.offset;
	
				if (this.state.hasCustomPage) {
					return this.clampFirst(this.state.first);
				}
				return this.clampFirst(currentImage - offset);
			}
		}, {
			key: 'setFirst',
			value: function setFirst(event, newFirst) {
				var first = this.state.first;
	
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				if (first === newFirst) return;
	
				this.setState({
					hasCustomPage: true,
					first: newFirst
				});
			}
		}, {
			key: 'gotoPrev',
			value: function gotoPrev(event) {
				this.setFirst(event, this.getFirst() - this.props.offset);
			}
		}, {
			key: 'gotoNext',
			value: function gotoNext(event) {
				this.setFirst(event, this.getFirst() + this.props.offset);
			}
		}, {
			key: 'clampFirst',
			value: function clampFirst(value) {
				var _props2 = this.props,
				    images = _props2.images,
				    offset = _props2.offset;
	
	
				var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
	
				if (value < 0) {
					return 0;
				} else if (value + totalCount > images.length) {
					// Too far
					return images.length - totalCount;
				} else {
					return value;
				}
			}
	
			// ==============================
			// RENDERERS
			// ==============================
	
		}, {
			key: 'renderArrowPrev',
			value: function renderArrowPrev() {
				if (this.getFirst() <= 0) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'left',
					size: 'small',
					icon: 'arrowLeft',
					onClick: this.gotoPrev,
					style: arrowStyles,
					title: 'Previous (Left arrow key)',
					type: 'button'
				});
			}
		}, {
			key: 'renderArrowNext',
			value: function renderArrowNext() {
				var _props3 = this.props,
				    offset = _props3.offset,
				    images = _props3.images;
	
				var totalCount = 2 * offset + 1;
				if (this.getFirst() + totalCount >= images.length) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'right',
					size: 'small',
					icon: 'arrowRight',
					onClick: this.gotoNext,
					style: arrowStyles,
					title: 'Next (Right arrow key)',
					type: 'button'
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _props4 = this.props,
				    images = _props4.images,
				    currentImage = _props4.currentImage,
				    onClickThumbnail = _props4.onClickThumbnail,
				    offset = _props4.offset;
	
	
				var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
				var thumbnails = [];
				var baseOffset = 0;
				if (images.length <= totalCount) {
					thumbnails = images;
				} else {
					// Try to center current image in list
					baseOffset = this.getFirst();
					thumbnails = images.slice(baseOffset, baseOffset + totalCount);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(classes.paginatedThumbnails) },
					this.renderArrowPrev(),
					thumbnails.map(function (img, idx) {
						return _react2.default.createElement(_Thumbnail2.default, _extends({ key: baseOffset + idx
						}, img, {
							index: baseOffset + idx,
							onClick: onClickThumbnail,
							active: baseOffset + idx === currentImage }));
					}),
					this.renderArrowNext()
				);
			}
		}]);
	
		return PaginatedThumbnails;
	}(_react.Component);
	
	exports.default = PaginatedThumbnails;
	
	
	PaginatedThumbnails.propTypes = {
		currentImage: _propTypes2.default.number,
		images: _propTypes2.default.array,
		offset: _propTypes2.default.number,
		onClickThumbnail: _propTypes2.default.func.isRequired
	};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Pass the Lightbox context through to the Portal's descendents
	// StackOverflow discussion http://goo.gl/oclrJ9
	
	var PassContext = function (_Component) {
		_inherits(PassContext, _Component);
	
		function PassContext() {
			_classCallCheck(this, PassContext);
	
			return _possibleConstructorReturn(this, (PassContext.__proto__ || Object.getPrototypeOf(PassContext)).apply(this, arguments));
		}
	
		_createClass(PassContext, [{
			key: 'getChildContext',
			value: function getChildContext() {
				return this.props.context;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react.Children.only(this.props.children);
			}
		}]);
	
		return PassContext;
	}(_react.Component);
	
	PassContext.propTypes = {
		context: _propTypes2.default.object.isRequired
	};
	PassContext.childContextTypes = {
		theme: _propTypes2.default.object
	};
	
	exports.default = PassContext;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(403);
	
	var _reactDom = __webpack_require__(54);
	
	var _PassContext = __webpack_require__(369);
	
	var _PassContext2 = _interopRequireDefault(_PassContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_Component) {
		_inherits(Portal, _Component);
	
		function Portal() {
			_classCallCheck(this, Portal);
	
			var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
			_this.portalElement = null;
			return _this;
		}
	
		_createClass(Portal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var p = document.createElement('div');
				document.body.appendChild(p);
				this.portalElement = p;
				this.componentDidUpdate();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				// Animate fade on mount/unmount
				var duration = 200;
				var styles = '\n\t\t\t\t.fade-enter { opacity: 0.01; }\n\t\t\t\t.fade-enter.fade-enter-active { opacity: 1; transition: opacity ' + duration + 'ms; }\n\t\t\t\t.fade-leave { opacity: 1; }\n\t\t\t\t.fade-leave.fade-leave-active { opacity: 0.01; transition: opacity ' + duration + 'ms; }\n\t\t';
	
				(0, _reactDom.render)(_react2.default.createElement(
					_PassContext2.default,
					{ context: this.context },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'style',
							null,
							styles
						),
						_react2.default.createElement(
							_reactTransitionGroup.TransitionGroup,
							this.props,
							_react2.default.createElement(
								_reactTransitionGroup.CSSTransition,
								{ timeout: { enter: duration, exit: duration }, classNames: 'fade' },
								this.props.children
							)
						)
					)
				), this.portalElement);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				(0, _reactDom.unmountComponentAtNode)(this.portalElement);
				document.body.removeChild(this.portalElement);
			}
		}, {
			key: 'render',
			value: function render() {
				return null;
			}
		}]);
	
		return Portal;
	}(_react.Component);
	
	exports.default = Portal;
	
	
	Portal.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner(props) {
		var classes = _noImportant.StyleSheet.create(styles(props));
	
		return _react2.default.createElement(
			'div',
			{ className: (0, _noImportant.css)(classes.spinner) },
			_react2.default.createElement('div', { className: (0, _noImportant.css)(classes.ripple) })
		);
	};
	
	Spinner.propTypes = {
		color: _propTypes2.default.string,
		size: _propTypes2.default.number
	};
	
	var rippleKeyframes = {
		'0%': {
			top: '50%',
			left: '50%',
			width: 0,
			height: 0,
			opacity: 1
		},
		'100%': {
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			opacity: 0
		}
	};
	
	var styles = function styles(_ref) {
		var color = _ref.color,
		    size = _ref.size;
		return {
			spinner: {
				display: 'inline-block',
				position: 'relative',
				width: size,
				height: size
			},
			ripple: {
				position: 'absolute',
				border: '4px solid ' + color,
				opacity: 1,
				borderRadius: '50%',
				animationName: rippleKeyframes,
				animationDuration: '1s',
				animationTimingFunction: 'cubic-bezier(0, 0.2, 0.8, 1)',
				animationIterationCount: 'infinite'
			}
		};
	};
	
	exports.default = Spinner;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(11);
	
	var _theme = __webpack_require__(22);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(45);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Thumbnail(_ref, _ref2) {
		var index = _ref.index,
		    src = _ref.src,
		    thumbnail = _ref.thumbnail,
		    active = _ref.active,
		    _onClick = _ref.onClick;
		var theme = _ref2.theme;
	
		var url = thumbnail ? thumbnail : src;
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement('div', {
			className: (0, _noImportant.css)(classes.thumbnail, active && classes.thumbnail__active),
			onClick: function onClick(e) {
				e.preventDefault();
				e.stopPropagation();
				_onClick(index);
			},
			style: { backgroundImage: 'url("' + url + '")' }
		});
	}
	
	Thumbnail.propTypes = {
		active: _propTypes2.default.bool,
		index: _propTypes2.default.number,
		onClick: _propTypes2.default.func.isRequired,
		src: _propTypes2.default.string,
		thumbnail: _propTypes2.default.string
	};
	
	Thumbnail.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		thumbnail: {
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			borderRadius: 2,
			boxShadow: 'inset 0 0 0 1px hsla(0,0%,100%,.2)',
			cursor: 'pointer',
			display: 'inline-block',
			height: _theme2.default.thumbnail.size,
			margin: _theme2.default.thumbnail.gutter,
			overflow: 'hidden',
			width: _theme2.default.thumbnail.size
		},
		thumbnail__active: {
			boxShadow: 'inset 0 0 0 2px ' + _theme2.default.thumbnail.activeBorderColor
		}
	};
	
	exports.default = Thumbnail;

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z\"/>\n\t</svg>";
	};

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z\"/>\n\t</svg>";
	};

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\n\t\t<path d=\"M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z\"/>\n\t</svg>";
	};

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = bindFunctions;
	/**
		Bind multiple component methods:
	
		* @param {this} context
		* @param {Array} functions
	
		constructor() {
			...
			bindFunctions.call(this, ['handleClick', 'handleOther']);
		}
	*/
	
	function bindFunctions(functions) {
		var _this = this;
	
		functions.forEach(function (f) {
			return _this[f] = _this[f].bind(_this);
		});
	};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// Return true if window + document
	
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropToggle = __webpack_require__(169);
	
	var _PropToggle2 = _interopRequireDefault(_PropToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LifeCycleProvider = function LifeCycleProvider(_ref) {
	  var isActive = _ref.isActive,
	      props = _objectWithoutProperties(_ref, ['isActive']);
	
	  return isActive ? _react2.default.createElement(_PropToggle2.default, props) : null;
	};
	
	LifeCycleProvider.defaultProps = _PropToggle.defaultProps;
	
	exports.default = LifeCycleProvider;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LifeCycleProvider = __webpack_require__(378);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LifeCycleProvider).default;
	  }
	});
	
	var _PropToggle = __webpack_require__(169);
	
	Object.defineProperty(exports, 'SimpleToggle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PropToggle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(75);
	
	var _reactPropToggle = __webpack_require__(379);
	
	var _utils = __webpack_require__(176);
	
	var _withTouchListeners = __webpack_require__(399);
	
	var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LOCK_COUNT = 0;
	
	var ScrollLock = function (_PureComponent) {
	  _inherits(ScrollLock, _PureComponent);
	
	  function ScrollLock() {
	    _classCallCheck(this, ScrollLock);
	
	    return _possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
	  }
	
	  _createClass(ScrollLock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      LOCK_COUNT++;
	      if (_exenv.canUseDOM) {
	        this.initialHeight = window.innerHeight;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      LOCK_COUNT = Math.max(LOCK_COUNT - 1, 0);
	
	      if (_exenv.canUseDOM) {
	        var offset = window.innerHeight - this.initialHeight;
	
	        // adjust scroll if the window has been resized since the lock was engaged
	        if (offset) {
	          window.scrollTo(0, window.pageYOffset + offset);
	        }
	      }
	
	      // reset the initial height in case this scroll lock is used again
	      this.initialHeight = window.innerHeight;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var accountForScrollbars = this.props.accountForScrollbars;
	
	      // avoid overly incrementing padding
	
	      var scrollbarSpacer = accountForScrollbars && LOCK_COUNT < 1 ? { 'padding-right': (0, _utils.getPadding)() + 'px' } : {};
	
	      var height = (0, _utils.getDocumentHeight)() + 'px';
	
	      return _react2.default.createElement(_reactPropToggle.SimpleToggle, {
	        styles: _extends({
	          'box-sizing': 'border-box', // account for possible declaration `width: 100%;` on body
	          overflow: 'hidden',
	          position: 'relative',
	          height: height
	        }, scrollbarSpacer)
	      });
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.PureComponent);
	
	ScrollLock.defaultProps = {
	  accountForScrollbars: true
	};
	exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScrollLock = __webpack_require__(397);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScrollLock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withTouchListeners;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(75);
	
	var _utils = __webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withTouchListeners(WrappedComponent) {
	  return function (_PureComponent) {
	    _inherits(TouchProvider, _PureComponent);
	
	    function TouchProvider() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TouchProvider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
	        capture: false,
	        passive: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TouchProvider, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // account for touch devices
	        if (target && (0, _utils.isTouchDevice)()) {
	          // Mobile Safari ignores { overflow: hidden } declaration on the body.
	          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          // Allow scroll on provided target
	          if (touchScrollTarget) {
	            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // remove touch listeners
	        if (target && (0, _utils.isTouchDevice)()) {
	          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          if (touchScrollTarget) {
	            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	    }]);
	
	    return TouchProvider;
	  }(_react.PureComponent);
	}

/***/ }),
/* 400 */,
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _addClass = _interopRequireDefault(__webpack_require__(317));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(319));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(177));
	
	var _PropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	
	var propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or has finished the transition.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply spread
	   * them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};;
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation. After the animation,
	 * matching `done` class names are applied to persist the animation state.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 */
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var _this$getClassNames3 = _this.getClassNames('enter'),
	          doneClassName = _this$getClassNames3.doneClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          className = _this$getClassNames4.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames5.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames6 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames6.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames7 = this.getClassNames(type),
	        className = _this$getClassNames7.className,
	        activeClassName = _this$getClassNames7.activeClassName,
	        doneClassName = _this$getClassNames7.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(54);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(178));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};;
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? propTypes : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(401));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(402));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(178));
	
	var _Transition = _interopRequireDefault(__webpack_require__(177));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBmaWxsPSIjQjg5MjI3IiBkPSJNMTMgN2gtMnY0SDd2Mmg0djRoMnYtNGg0di0yaC00Vjd6bS0xLTVDNi40OCAyIDIgNi40OCAyIDEyczQuNDggMTAgMTAgMTAgMTAtNC40OCAxMC0xMFMxNy41MiAyIDEyIDJ6bTAgMThjLTQuNDEgMC04LTMuNTktOC04czMuNTktOCA4LTggOCAzLjU5IDggOC0zLjU5IDgtOCA4eiIvPjwvc3ZnPgo="

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Katharina_Hochmuth-BfA_600.617683dd.jpg";

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Bundesstiftung-Logo@2x.19e5c3bc.png";

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC4xMDEgMjEuNTk5Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO3N0cm9rZTojZmZmO308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAuODMzIC0xNS4wMTgpIj48cGF0aCBjbGFzcz0iYSIgZD0iTTM5LjQwNiwxOC41MTRhLjQ0OC40NDgsMCwwLDAtLjQ0OC40NDhWMzAuMDgzbC0zLjI4NC0zLjYzMWEuNDQ4LjQ0OCwwLDEsMC0uNjY1LjZsNC4wNjUsNC40OTQuMDA4LjAwN2EuNDQ2LjQ0NiwwLDAsMCwuMDQyLjAzOGMuMDA4LjAwNy4wMTYuMDE1LjAyNS4wMjFhLjQ1MS40NTEsMCwwLDAsLjA1OC4wMzNsLjAyLjAxMWEuNDUyLjQ1MiwwLDAsMCwuMDc5LjAyNmwuMDA3LDBhLjQzOS40MzksMCwwLDAsLjE4NiwwbC4wMDcsMGEuNDUyLjQ1MiwwLDAsMCwuMDc5LS4wMjZsLjAyLS4wMTFhLjQ1LjQ1LDAsMCwwLC4wNTgtLjAzM2MuMDA5LS4wMDYuMDE3LS4wMTQuMDI1LS4wMjFhLjQ0Ni40NDYsMCwwLDAsLjA0Mi0uMDM4bC4wMDgtLjAwN0w0My44LDI3LjA1MmEuNDQ4LjQ0OCwwLDEsMC0uNjY1LS42aDBsLTMuMjg0LDMuNjMxVjE4Ljk2MmEuNDQ4LjQ0OCwwLDAsMC0uNDQ4LS40NDhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYuMzY1IC0yLjk5NikiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTMzLjk4Niw1OC44NmEuNDQ4LjQ0OCwwLDAsMC0uNDQ4LjQ0OHY2LjMxMUgxMi4yMjlWNTkuMzA4YS40NDguNDQ4LDAsMSwwLS45LDBoMHY2Ljc1OWEuNDQ4LjQ0OCwwLDAsMCwuNDQ4LjQ0OEgzMy45ODZhLjQ0OC40NDgsMCwwLDAsLjQ0OC0uNDQ4VjU5LjMwOGEuNDQ4LjQ0OCwwLDAsMC0uNDQ4LS40NDhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMC4zOTgpIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTkgNXYxNEg1VjVoMTRtMC0ySDVjLTEuMSAwLTIgLjktMiAydjE0YzAgMS4xLjkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJWNWMwLTEuMS0uOS0yLTItMnptLTQuODYgOC44NmwtMyAzLjg3TDkgMTMuMTQgNiAxN2gxMmwtMy44Ni01LjE0eiIvPjwvc3ZnPg=="

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTkgMTlINVY1aDdWM0g1Yy0xLjExIDAtMiAuOS0yIDJ2MTRjMCAxLjEuODkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJ2LTdoLTJ2N3pNMTQgM3YyaDMuNTlsLTkuODMgOS44MyAxLjQxIDEuNDFMMTkgNi40MVYxMGgyVjNoLTd6Ii8+PC9zdmc+"

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNNCA2LjQ3TDUuNzYgMTBIMjB2OEg0VjYuNDdNMjIgNGgtNGwyIDRoLTNsLTItNGgtMmwyIDRoLTNsLTItNEg4bDIgNEg3TDUgNEg0Yy0xLjEgMC0xLjk5LjktMS45OSAyTDIgMThjMCAxLjEuOSAyIDIgMmgxNmMxLjEgMCAyLS45IDItMlY0eiIvPjwvc3ZnPg=="

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMjAgMkg4Yy0xLjEgMC0yIC45LTIgMnYxMmMwIDEuMS45IDIgMiAyaDEyYzEuMSAwIDItLjkgMi0yVjRjMC0xLjEtLjktMi0yLTJ6bTAgMTRIOFY0aDEydjEyek00IDZIMnYxNGMwIDEuMS45IDIgMiAyaDE0di0ySDRWNnptMTIgNlY5YzAtLjU1LS40NS0xLTEtMWgtMnY1aDJjLjU1IDAgMS0uNDUgMS0xem0tMi0zaDF2M2gtMVY5em00IDJoMXYtMWgtMVY5aDFWOGgtMnY1aDF6bS04IDBoMWMuNTUgMCAxLS40NSAxLTFWOWMwLS41NS0uNDUtMS0xLTFIOXY1aDF2LTJ6bTAtMmgxdjFoLTFWOXoiLz48L3N2Zz4="

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Grafik_PDF-Download.0d423357.png";

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Grafik_PDF-Download@2x.775f2acf.png";

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTQuNTkgOEwxMiAxMC41OSA5LjQxIDggOCA5LjQxIDEwLjU5IDEyIDggMTQuNTkgOS40MSAxNiAxMiAxMy40MSAxNC41OSAxNiAxNiAxNC41OSAxMy40MSAxMiAxNiA5LjQxIDE0LjU5IDh6TTEyIDJDNi40NyAyIDIgNi40NyAyIDEyczQuNDcgMTAgMTAgMTAgMTAtNC40NyAxMC0xMFMxNy41MyAyIDEyIDJ6bTAgMThjLTQuNDEgMC04LTMuNTktOC04czMuNTktOCA4LTggOCAzLjU5IDggOC0zLjU5IDgtOCA4eiIvPjwvc3ZnPg=="

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTkgMTlINVY1aDdWM0g1Yy0xLjExIDAtMiAuOS0yIDJ2MTRjMCAxLjEuODkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJ2LTdoLTJ2N3pNMTQgM3YyaDMuNTlsLTkuODMgOS44MyAxLjQxIDEuNDFMMTkgNi40MVYxMGgyVjNoLTd6Ii8+PC9zdmc+"

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Grafik_family.d0bb2019.png";

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Grafik_family@2x.054c08c1.png";

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Grafik_family_mobile.52fb2b52.png";

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Grafik_family_mobile@2x.2deacfd7.png";

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mauer1.76958a86.png";

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mauer1@2x.3d41c23e.png";

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mauer2.3ca15791.png";

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mauer2@2x.5d2c1288.png";

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDEzIEwxMDAgMCBMMTAwIDg3IEwwIDEwMCBaIiBmaWxsPSIjREFEQURCIiAvPgo8L3N2Zz4K"

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDMgTDEwMCAwIEwxMDAgOTcgTDAgMTAwIFoiIGZpbGw9IiNEQURBREIiIC8+Cjwvc3ZnPgo="

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDE0IEwxMDAgMCBMMTAwIDg2IEwwIDEwMCBaIiBmaWxsPSIjREFEQURCIiAvPgo8L3N2Zz4K"

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kiwi.f06921c0.png";

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAA5CAYAAACPr42tAAAAAXNSR0IArs4c6QAADJtJREFUaAXlWnlwVdUZP8td3pq8LAaTEAiLyJawBRC1nYQZdVRAARNHRlprB+lIi+O0RcdxyT/a6Yxt1daxZQa0dcOAZRSXsmjABUETQ0AWgSAQCC+EkLz13neXc/qdFx8GDeE9eGF4emeSd9+95557vt/7vt+3HYx+ZEdDQ60rn+debds8TLSs1sPoiFVVVWslK6aU7MBMGMc5wvvrwy9ErZPlRvR0lFKpvVD1PQVrb0h2/T8qQPasv3uEHtxznWVERiAESsGZ35Ez1JksGGIcSWXw5TxWaEc4cHK8ZQQ8nMUACwthEE9x5O1JZd0/GkAwRpwifD3idgGoRhwDTOVP2OmT8k8SkB1vzZ9kG6Hb4mAQwQREx1Rp1rpyOn9ygOyur/aYWud8ELyEI4oxKAimUpsq57xZsXi5+ZMDxO2d6EWI/hoRqjq8g5ErZ0RMdhW+FrNYWypgiLEZ72X2fbLMG+3yP0iIms0ZQ5goKKtw2iHbCq8ZPv3hYKqAZDSp8rpqGj6xa4YeOHQ357YTC+7A3MKErxw27aGvAIwedk0BlYzWkL3ULrD10MOWbRdSxY0wlpAdC+wMdezchDG2U8DhzNCM1ZCtddXOiNk9HzF7CkIMMUtDthlizI5t1HIrdp+RMMWTjAXEoxgjbctcCO4kC7gUbINx4I9tbsX9z4qKxSl5lt6YZSQgLRurs/Vo4F7EjYmCNyDeQATLfsmZ+w+/b+Kx3gKmep5xgPDaWnK6s6uS2+ZsQpyK6i4UITqDqHRLjq9sbSqZbV9gZRwgn5c35zBbvwdxPkxSPMAdUchiUBNRvU+XVtbG+hIylWsZBUgtaAfRQwuRbVdCJEqI7ESWpYUBkDWTb5/YJPKZVITva2zGuF0Rje+taBkbCeNqjjkEYSayLd0GQt0ieaWVGNeyvgRM9VrGaMj77/1OiYT8S4BAp0lKdlwXbDN8FL6/VH7jhFOpCn6u8RmhIQ3/uk9mwb0LbEubRxCTMKGQzBKISPF6SVY/TJd2CJAyQkOU4nAJ5mwx4lYBM6MQjQaBNvBuSXKvLJ/1Wte5fu0LuX7ZA7K7rjo3FulYBq51KqEOkFFQBQ5hor5MPL6UqmHJAHRZm0z9i5WOiN0xh1mxGvAfhEgACCaQ5ctbFW/uqgk3vRxJRshUxlzWGpKXX1jKLGMJFEhzEvkKJHDfUNn75IRZ406kImiyYy9bQPZu+kUe4/w+MJWyhDCQwYaorK4sKB7VkE4iTcwvPtMOCK+ro980vejjnOPeL0rlvKHhPlkLhm7gpjYXgi/122c5oc4PPMVDni259m9aKvOlMjbtHHLAt7EMdfnubW187nDLlkfX6Uw6Ma6qNpzSog63jrdt9BvTDA2FEB08CjApkXYhSp9etWlI2nmj99rSCgivr5UaO7bfQ0j7r6KhYxQx47eq64ql8MJ3er+0v/Ntb901yIy0LWPMmg69FfCuoMSYBmTJ9cLkmg1bp8ZLyP3NcHH30moyu07vGsLt2FRD6/BAWc+phdqK9FBbHue1Sb2nFYo+UsT/AHiV2QCG8LGgHTwKXuV12aPUAYdcdK5yPriSWuj5JkncZ5ReBUWayULNxUEIOmoa2uFkCFBUwNr56UWQrC3hiLvjE4gyIJG3qWrWivJZ76Y1AIvP38e/tAEiMlHGzCpMZKht9kyLMW1jTGrq471nXXrvuZtVhXXOsozoQ1AXzkrchHmOSYr7+fLcKTsT1wb6M22AVF+DfLKaW0wguaBqFpi+bGIsv6sVa9H+hKivr5QKBrFrbVN/HOKNosRYyFeChHqedSvKRpzCdobE8xf6mTZAqCdqQqP5OuiNYOAAsBd6Ego4B6qqNp9zb4ZwIJ4OdTIzI39knI35TghsYuKoy7qy9OXRt70d+u76wJ+lzctY3f4KLloiUOMUtQo4uOTNb+xPhJ2rZ5dyK7SUcasy3qsWgzG2qOxa55Z9j19dtTxtaX1/6+h9Ly0aUgcNIzMWHAqF3nwgxHi+QRVPcywQPmfnbMe66mLdCD7JbHM+kHBiD4cJgNYTJfvRMfPe9Pde6KU6TwsgYrGWGaoyIm1uMxpvtlugJi3OceN+EFGKCHbX2ttHGMGOv3BmzIWUPu5eAUUb+OcLoroemzJv7d5L4WL7AjktJlNqG0XQKBoJ7UQIKuOUwZGkto0bV2v0fqnQpC9W31omEbqM2Vp1XJV6BkBPhX6JsfPPoTyjXzPrPd9AnKdDQ7CMtBLIXIq/WyDRbYY++O47EAq45WEkVo7N8COGduqOM74ZQi8qu/dJsvNp7HFs6o+Ee883UOfp0BDOVXkID7PBiWwOmHUPlslZ5tI4ausoCLMesJlxC2iGDDEKYAI5ClYOqO7BvzeKHJsqKpabrVv/6uzq2jeSoQBsachrk8JdjlCbN5DqPo8LBeyiAWlev9AdO3X0xgQYsBARpgamlg7dLxYlwvamNz4rM+3oU8jEM4FDgDME8VKLqtmfY9X1CICxVYAhxtvUnomY9gdbCxSYwY4wNLF3qiXuwwc+ql078mdPDDi3XDQgeldnMfzQo0FIqPzGD06pay2astwSaXzzmsYqG8CATptoO8L2HnglxgaR3Vskl/exCbeu2v7tc/EPPeSHnm10IgzywR9cw1Md7oJuhMzS4/vWPgwX4qzd+5l0nl80h0iKNByEnZBYFITbRzC194umkaODzDSt6DO2bUKHHgATOQ6hNvzqW2RH3p++jthn7R8VHogo6kHFke+CLj409uHPiuFAe1OO5Mj9pYxpL55KvDG9nxcFiDAXUO05QKiKWFZP54yccqulX4jvTlc+dWQNRQ5vsZAUDEUURuXtBLyJHBv1aU3N6rP2cGx/f6nXofqCRFIVzmzAD7ZWQsvBnTsKAYAnTSy82MAeF2UyZqi9BKx+Cqy8Zx4hMZXfXNXUU8TJGjTsY2fB+GeNSPsTQX+jz4ic+IhK3scO2PTLmpraM2AIntn5fmcR19tqOk+032br3QwSRSKIl0pulD/8lojqLXw1fPrI8YGFo8dIL+gdIg/58o0bF1hGcAXgEC/zEUxbiOJdVHHn+vrEpHVQUrx+nLEoGjhSBMHYC2Nuesaf6ME2vVjpMxy0THXkVHLO7rBi3cOBZ9zCTKBAJMrsgK8rMmjsglfziq590pk74mhi3oH6vGAV3PXWnEFauOt5bhtzBTOISg4hyoeFwypmf7/m2dpa59SP++WrrlkaD+XrobLmC+8fZkfb77AMbQ40oSaBKqjARWAisNeDKtB84Scl5xUbFFf+fwxZbpxY9UwAFguvGtjjgkxG1D5ixvYJUNWaDuSQ4KEYlRwvrdiQ/YMtCSUlNSIm0T6vq77S7ckey8IH51hW7GZCXYMRj7iEpWFQOQjQgEgFKHQ3FJRf82QXvHJV1d+PDSwEZ89+QYDMndHiNIO4GrijSHhGsHX45XCzIiuNANaZLjzndXTP6s1O6wqPD0f8o43wsVmR7vafQ4mgTFKyJAj14VnAE/6c2aUhxZF7DArL27hl/dtwOncAGIGzlzvw31IGRHBH03+DM5gZ/jn8sgSBiwH7Z7Lq/d/4ue98DfcTGkOa18yZadl6pUMbMhOq5mNg+4I33p6AQcAX8JyNoJOPYLNLS/agSXWE4NcPhibtraqqOmcNZaAhSRmQPZvvdyPeOg/cYilEm2DVUPaU1FZZ8ny44+07Z7izSssgZqgIte8oM6xIAWhAHuz48UB5ACroFLl8w1EsdBx6UDYwp3mCELrN4fKtZsixbciU+9tLLkEhuT9QUwaERYLlsPdxLgASjz3E5OAR8nW941WqeJke8TsdVMmWnblKLOqHwEoHbQgJooybhxXrQpCjfAYd/M0Mud+eVD0bdv6IXYMrYKYl/a31ktxLChDhFUYo8uhA9/5FsfCJG0DI3J7VfUv6zPIAcXgQbFXAuAtpQIzCHARJmrYBO32iUZlkg7uVWgiy16mSc7POnK2Tm0uDAMYZzrkkEp/nJUm73c4jW2o7D69/Qg+3IT1wGKYVPSSIxuMhNvzAEFwACnBNhlKI1wLQdLClELiNr7Dk2ObwFH0a0Q41TJ/3wYDmIueR97y3kwZECx65Ptje/IrW3TLUjJ5C0e5DFmyFBD61ZdjaZHPbagdwIgyMhllWEzSXPgN++HjKXZu/TgRi513NZTAgKZMR62SxjhZL69igB75ZCJtVompW8XZkmjvBTeoEWZ3U6T1p2qEDZtvBXdMWN8ZT+bh8Cy4DKVNYQtIaIvKNvZtPj+Vad6Vp4fqsglGneIjqepGufb9UmML7M3/o1roHExXyzBemDwn+D5qwbX9GFJ6cAAAAAElFTkSuQmCC"

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stacheldraht-kl@2x.a0d84804.png";

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stacheldraht_gr.68cb4e0c.png";

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stacheldraht_gr@2x.160039ae.png";

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTE4MCIgaGVpZ2h0PSI2NCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0xMTcyIDAgTDExODAgMCBMMTE4MCA4IEwwIDY0IEwwIDAgTDggMCBMOCA1NiBaIiBmaWxsPSIjRjdGN0Y3IiAvPgo8L3N2Zz4K"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTE4MCIgaGVpZ2h0PSI2NCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDAgTDggMCBMOCA2NCBMMCA2NCBaIiBmaWxsPSIjRjdGN0Y3IiAvPgogIDxwYXRoIGQ9Ik0xMTcyIDAgTDExODAgMCBMMTE4MCA2NCBMMTE3MiA2NCBaIiBmaWxsPSIjRjdGN0Y3IiAvPgo8L3N2Zz4K"

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTE4MCIgaGVpZ2h0PSI2NCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDY0IEwwIDU2IEwxMTgwIDAgTDExODAgNjQgTDExNzIgNjQgTDExNzIgOCBMOCA2NCBaIiBmaWxsPSIjRjdGN0Y3IiAvPgo8L3N2Zz4K"

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-99825f24a56e516e3d4e.js